import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionPanel } from '@angular/material/expansion';
import { MatIconRegistry } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import firebase from 'firebase/app';
import { defaultIfEmpty, firstValueFrom, Subscription } from 'rxjs';
import { folderColors } from 'src/app/dictionaries/folderColors';
import { Labels } from 'src/app/dictionaries/labels';
import { UserRoles } from 'src/app/dictionaries/UserRoles';
import { ContextMenuModel } from 'src/app/models/ContextMenu';
import { NotificationTypes } from 'src/app/models/NotificationTypes';
import { ViewAllNotesDialogData } from 'src/app/models/ViewAllNotesDialogData';
import { ClientMatterService } from 'src/app/services/client-matter.service';
import { ClientProfileConsultantService } from 'src/app/services/client-profile-consultant.service';
import { ClientProfileFileService } from 'src/app/services/client-profile-file.service';
import { ClientProfileFolderService } from 'src/app/services/client-profile-folder.service';
import { ClientProfileSharingService } from 'src/app/services/client-profile-sharing.service';
import { CookiesService } from 'src/app/services/cookies.service';
import { DialogService } from 'src/app/services/dialog.service';
import { FileCommentsAttachmentsService } from 'src/app/services/file-comments-attachments.service';
import { FoldersService } from 'src/app/services/folders.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { environment } from '../../../environments/environment';
import { UploadTypes } from '../../models/UploadTypes';
import { AuthService } from '../../services/auth.service';
import { PhiAccessAuditService } from '../../services/phi-access-audit.service';
import { FilesService } from '../../services/files.service';
import { FirebaseUtilitiesService } from '../../services/firebase-utilities.service';
import { GapiOperationsService } from '../../services/gapi-operations.service';
import { LogService } from '../../services/log.service';
import { NotificationsService } from '../../services/notifications.service';
import { PermissionsService } from '../../services/permissions.service';
import { UIMessagingService } from '../../services/uimessaging.service';
import { UploadHelperService } from '../../services/upload-helper.service';
import { UsersService } from '../../services/users.service';
import { UtilsService } from '../../services/utils.service';
import { DocumentsToShareComponent } from '../documents-to-share/documents-to-share.component';
import { HowToBurnADiscComponent } from '../ui/how-to-burn-a-disc/how-to-burn-a-disc.component';
import { FileActionsDictionary } from './../../dictionaries/FileActions';
import { LogLevelsDictionary } from './../../dictionaries/LogLevels';
import { AlgoliaService } from './../../services/algolia.service';
import { ClientProfileLibraryFacade, LibraryContext } from './../../services/client-profile-library.facade';
import { SharingFilesService } from './../../sharing-files.service';
import { ClientProfileToolbarComponent } from './../ui/client-profile-toolbar/client-profile-toolbar.component';

import { MatSnackBar } from '@angular/material/snack-bar';
import { UserPlans } from 'src/app/dictionaries/UserPlans';
import { Consultant } from 'src/app/models/Consultant';
import { FolderElement } from 'src/app/models/FolderElement';
import { NoteFile } from 'src/app/models/NoteFile';
import { NoteObject } from 'src/app/models/NoteObject';
import { ShareFilesDialogResult } from 'src/app/models/ShareFilesDialogResult';
import { AccordionDataService } from '../../services/accordion-data.service';
import { HomeFoldersAccordionFacilitatorsComponent } from '../home-folders-accordion-facilitators/home-folders-accordion-facilitators.component';
import { SORT_TYPES } from './../../constants/sort-types';
import { SortType } from './../../interfaces/sort-type';

declare function require(name: string);
declare function dumpFile(file: any, option: string): [];

const DISCS_FOLDER_NAME = 'Discs';
const LIBRARY_FOLDER_NAME = 'Library';
const HOME_FOLDER_NAME = '';
const INDEX_FOLDER_NAME = 'all';
const ZIP_EXTENSIONS = ['zip', 'rar', '7z', 'tar', 'gz', 'bz2', 'xz', 'z', 'tgz', 'tbz2', 'txz', 'tar.gz'];

const localFolderColors = ['rgb(187, 222, 251)', 'rgb(209, 196, 233)', 'rgb(255, 224, 130)'];
const indexFolderColor = '#eadbff';
const indexFolderLabel = 'INDEX';
const unshareIconUrl = './../../assets/svg/unshare.svg';
const notPlayableVideoExtensions = ['mpeg', 'vob'];
const permissionsNeeded = [
  'uploadfiles',
  'editfiles',
  'deletefiles',
  'consultantslist',
  'sharefileicon',
  'createfolder'
];

const viewerUrlParts = {
  location: 4,
  dataSet: 6,
  dicomStore: 8,
  studyUID: 10
};

@Component({
    selector: 'app-clientprofile',
    templateUrl: './clientprofile.component.html',
    styleUrls: ['./clientprofile.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ClientProfileComponent implements OnInit, AfterViewChecked, OnDestroy {
  selectedHub: any;
  userOwnerID: string;
  async selectHub($event: any) {
    console.log('hub: ', $event);
    this.selectedHub = $event;

    // Reload folders with the selected hub's facility context
    await this.reloadFoldersForSelectedHub();
  }
  selectedSpoke: any;
  async selectSpoke($event: any) {
    console.log('spoke: ', $event);
    this.selectedSpoke = $event;
  }
  isSpoke: boolean;
  isHub: boolean = true;
  showSpokesAsFolders: boolean = false;
  sharerSpokes: any[] = [];
  hubName: string = 'John Dell Hospital'; // Dynamic hub name - will be updated with real data
  selectedFilesForAccordion: any[] = [];
  selectedRightPanel: 'consultants' | 'facilityUsers' | null = null; // No default value
  // selectedFacility: string | null = null; // Add facility selection property
  active_medical_records_department_users: any;
  topMenuData: any;

  // Consultants
  // availableFacilityConsultants: any[];
  // activeFacilityConsultants: any;

  // Facilitators
  // availableFacilityAdmins: any;
  // activeFacilityAdmins: any;

  indexFolderNameCounter: any;
  userIsOwner: boolean;

  folderSelections: Map<string, Set<string>> = new Map();

  // Add breadcrumb collapse state
  breadcrumbCollapsed = false;
  mainTabGroupCollapsed = false;
  // rightPanelCollapsed = false;

  // Add new collapse states for improved UX
  patientInfoCollapsed = false;
  topActionsCollapsed = false;

  // Add these properties to the class
  originalFiles: any[] = []; // Store the original files before filtering
  isFiltered: boolean = false; // Track if files are currently filtered

  sortTypes: SortType[] = SORT_TYPES;
  Labels = Labels;
  discsFolderName = DISCS_FOLDER_NAME;
  uploadTypes = this.getUploadTypes();
  generateDiscLabel = 'GENERATE DISC';
  downloadDiscLabel = 'DOWNLOAD DISC FILES';
  filesFilter = { name: '', valid: false };
  nofilesMessage = 'No files have been uploaded for this folder yet.';
  unshareAllFilesMsg = 'Unshare all files with this Consultant.';
  // activeConsultant = null;
  activeFacilityUser = null;
  lastModified = 'lastModified';
  displayedColumns: string[] = [
    'select',
    'fileName',
    // 'ftype',
    'predefined',
    'fileDesc',
    'fdate',
    this.lastModified,
    'uploadedDate',
    'parentFolderName',
    'fileId',
    'isShared'
  ];

  // Removed fileActionsMenuItems - no longer needed

  user: any;
  patient: any = false;
  fdesc: string;
  fdate: string;
  ftime: string;

  ftype: string;

  files: any[] = [];
  patientName = '...';
  currentFolder = '';
  url: string;

  fileName: string;
  uid: string;
  currentFileOpen: any;
  allowAddNote: boolean;
  allowDeleteNote: boolean;
  realRole: string;
  selectedFile: string;

  width: string;
  casename: string;
  storename: string;
  selection = new SelectionModel<any>(true, []);

  // Search Results Properties
  searchResults: any[] = [];
  searchQuery: string = '';
  isSearchActive: boolean = false;
  searchResultsSelection = new SelectionModel<any>(true, []);

  @ViewChild('picker', { static: true }) picker;
  @ViewChild(ClientProfileToolbarComponent, { static: false })
  clientProfileToolbarComponent: ClientProfileToolbarComponent;
  filesTableDataSource = new MatTableDataSource<any>(this.files);
  sortedData = this.files.slice();
  @ViewChild(MatPaginator) uppaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  clientDataStores: any;
  ownerID: any;

  sharerHubs: any[];
  activeConsultants: any[];
  availableConsultants: any[];

  activeFacilitiesUsers: any[];
  availableFacilitiesUsers: any[];

  loadingPermissions = true;
  permissions_uploadfiles: any;
  permissions_editfiles: any;
  permissions_deletefiles: boolean = true;
  permissions_consultantslist: any;
  permissions_sharefileicon: any;
  permissions_createfolder: any;

  permissions: {
    createfolder: boolean;
    deletefiles: boolean;
    editfiles: boolean;
    sharefileicon: boolean;
  } = {
      createfolder: false,
      deletefiles: false,
      editfiles: false,
      sharefileicon: false
    };

  @ViewChild('homeFoldersAccordion') homeFoldersAccordion: DocumentsToShareComponent;
  @ViewChild('homeFoldersAccordionFacilitators')
  homeFoldersAccordionFacilitators: HomeFoldersAccordionFacilitatorsComponent;
  @ViewChild('homeFoldersAccordionSpokes')
  homeFoldersAccordionSpokes: any; // Reference to home-folders-accordion-spokes component
  @ViewChild('sharedFilesAccordion') sharedFilesAccordion: any; // Reference to shared-files-accordion component

  refreshButton = true;
  refreshing = false;
  getFilesForPatientRunning: Promise<void>;
  defaultFolders: boolean;

  /**
   * BASIC CONTEXT MENU
   */
  title = 'context-menu';
  isDisplayContextMenu: boolean;
  rightClickMenuItems: Array<ContextMenuModel> = [];
  matMenu: MatMenu;
  // reference to the MatMenuTrigger in the DOM
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  @ViewChild('helpPanel') helpPanel: MatExpansionPanel;
  @ViewChild('howToBurnADisc') howToBurnADisc: HowToBurnADiscComponent;
  menuTopLeftPosition = { x: '0', y: '0' };
  selected = 0;
  foldersList: any;
  currentFolderName: any;
  caseFolders: any[];
  pageSize: number;
  pageSizes: number[];
  objectsCount: number;
  pagesLength: number;
  selectionRecord: any;
  folderColor: string;
  sharedFolders: any[];
  viewNotesButton: boolean;
  indexFolderName: any;
  UserRoles: {
    owner: string;
    admin: string;
    associate: string;
    consultant: string;
    superuser: string;
    client: string;
  };
  FileActionsDictionary: typeof FileActionsDictionary;
  pickedSharedFile = {};
  consultantsSelectedTabIndex: number;
  facilityusersSelectedTabIndex: number;
  loading: boolean;
  loadingMessage: string;
  importFromAppsBtn = true;
  button: any;
  infectedFiles = [];
  section: any;
  targetFolder: any;
  homeFolderName = '';
  userIsConsultant: boolean;
  userIsClient: boolean;
  dicomdirFileName: string;
  plancode: string;
  ownerHasAccess: boolean = false;
  sharedFilesCount: number;
  sysadmin = environment.config.sysadmin;
  discsFolderFlow: any = false;
  clientProfileNotifications: any = [];
  notificationIds: string[] = [];
  ownerTotalStudies: Promise<any>;
  ownerPlanCode: any;
  addClientUploadCondition = false;
  folderPath: { level1: string; level2: string[] } = { level1: '', level2: [] };
  foldersStructure: any;
  // hospitals: any;
  selectedHospital: any;
  facilities: any;

  // Cache for accordion folders to prevent performance issues
  private _cachedAccordionFolders: any[] = [];
  private _accordionFolders: any[] = []; // Persistent array for accordion folders
  public accordionFolders: any[] = []; // Public property for template binding
  public hierarchicalFolders: any[] = []; // Hierarchical structure for accordion display

  // Subscription management
  private subscription: Subscription = new Subscription();

  // Data table collapse state
  dataTableCollapsed: boolean = true;

  // Shared files accordion properties
  indexFiles: any[] = [];
  /**
   * Contains all files from the INDEX folder (all patient files)
   * This variable is automatically updated when the INDEX folder is loaded
   * and when new files are uploaded to the patient's account
   */
  allFiles: any[] = [];
  // sharedFilesForAccordion: any[] = [];
  // sharedUserForAccordion: any = null;

  // Client Admin specific properties
  clientAdminFilteredFolders: any[] = [];
  originalUsersData: {
    availableConsultants: any[];
    activeConsultants: any[];
    availableAdmins: any[];
    activeAdmins: any[];
  };

  // Prevents initial flicker of email-like folders until roles are known
  private classificationReady: boolean = false;

  constructor(
    private ngZone: NgZone,
    private auth_$: AuthService,
    private cookies_$: CookiesService,
    private algolia_$: AlgoliaService,
    private permissions_$: PermissionsService,
    private firebase_utilities_$: FirebaseUtilitiesService,
    private gapiOperations_$: GapiOperationsService,
    private uploadHelper_$: UploadHelperService,
    private utils_$: UtilsService,
    private files_$: FilesService,
    private folders_$: FoldersService,
    private sharing_files_$: SharingFilesService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public ref: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ClientProfileComponent>,
    private dialog_$: DialogService,
    private dialog: MatDialog,
    private log_$: LogService,
    private users_$: UsersService,
    private http: HttpClient,
    private clientMatter_$: ClientMatterService,
    private uiMessaging_$: UIMessagingService,
    private notifications_$: NotificationsService,
    private fileCommentsAttachments_$: FileCommentsAttachmentsService,
    private sessionStorage_$: SessionStorageService,
    private clientProfileFolderService: ClientProfileFolderService,
    private clientProfileFileService: ClientProfileFileService,
    private clientProfileConsultantService: ClientProfileConsultantService,
    private clientProfileSharingService: ClientProfileSharingService,
    private libraryFacade: ClientProfileLibraryFacade,
    private snackBar: MatSnackBar,
    private phiAudit: PhiAccessAuditService,
    @Inject(MAT_DIALOG_DATA) data,
    private router: Router,
    private accordionDataService: AccordionDataService
  ) {
    const { patient, button, section, targetFolder } = data || {};
    this.dicomdirFileName = 'DICOMDIR';
    this.targetFolder = targetFolder || null;
    this.facilityusersSelectedTabIndex = 0;
    this.consultantsSelectedTabIndex = 0;
    this.FileActionsDictionary = FileActionsDictionary;

    // Initialize originalUsersData with empty arrays
    this.originalUsersData = {
      availableConsultants: [],
      activeConsultants: [],
      availableAdmins: [],
      activeAdmins: []
    };

    this.UserRoles = {
      owner: UserRoles.owner,
      client: UserRoles.client,
      admin: UserRoles.admin,
      associate: UserRoles.associate,
      consultant: UserRoles.consultant,
      superuser: UserRoles.superuser
    };
    this.viewNotesButton = false;
    this.pageSize = 0;
    this.pageSizes = [5, 10, 20, 40, 80, 100];
    this.matIconRegistry.addSvgIcon('unshareIcon', this.domSanitizer.bypassSecurityTrustResourceUrl(unshareIconUrl));
    this.patient = patient;

    // Ensure patient IDs are properly mapped from metadata.medical_record_numbers
    if (this.patient?.metadata?.medical_record_numbers && !this.patient.patientIDs) {
      this.patient.patientIDs = this.patient.metadata.medical_record_numbers;
    }

    if (patient) {
      this.auth_$.setCurrentPatient(patient);
      this.patientName = this.getPatientName(patient);
    } else {
      this.patientName = '';
    }

    // Try to get casename from various possible fields
    this.casename =
      this.patient.caseName || this.patient.LegalCaseId || this.patient.legalCaseId || this.patient.patientDocId;

    // Set casename from patient data

    this.defaultFolders = Boolean(this.patient.defaultFolders);
    this.files = [];
    this.allowAddNote = true;
    this.allowDeleteNote = true;
    this.fdesc = '';
    this.fdate = this.utils_$.getCurrentDate();
    this.ftime = null;
    this.ftype = '';
    this.sortedData = this.files.slice();
    this.button = button;
    this.section = section || null;

    this.foldersStructure = {
      name: 'Home',
      id: INDEX_FOLDER_NAME,
      children: [
        {
          name: LIBRARY_FOLDER_NAME,
          id: LIBRARY_FOLDER_NAME,
          children: []
        },
        {
          name: 'Discs',
          id: 'Discs',
          children: []
        }
      ]
    };
  }

  async ngOnInit() {
    this.ownerID = this.getOwnerID();

    // Wait for userData to be ready before accessing ownerID
    // userData is populated asynchronously, so we need to wait for it
    const userData = this.auth_$.userData.value;
    if (!userData || Object.keys(userData).length === 0 || !userData['ownerID']) {
      // If userData is not ready yet, wait for it using a promise
      await new Promise<void>(resolve => {
        const subscription = this.auth_$.userData.subscribe(data => {
          if (data && Object.keys(data).length > 0 && data['ownerID']) {
            this.userOwnerID = data['ownerID'];
            subscription.unsubscribe();
            resolve();
          }
        });
        // Timeout fallback - if userData doesn't load within 5 seconds, use patient ownerID
        setTimeout(() => {
          subscription.unsubscribe();
          this.userOwnerID = this.ownerID;
          resolve();
        }, 5000);
      });
    } else {
      this.userOwnerID = userData['ownerID'];
    }

    this.isSpoke = this.auth_$.userData.getValue()['plancode'] === UserPlans.spoke;

    // Force hide body scrollbar
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // Load user layout preferences
    this.loadLayoutPreferences();

    // TODO: What is this for?
    this.topMenuData = {
      currentFolder: this.currentFolder,
      currentFolderName: this.currentFolderName,
      folderColor: this.folderColor,
      foldersStructure: this.foldersStructure,
      indexFolderNameCounter: this.indexFolderNameCounter
    };

    this.realRole = this.auth_$.userData.getValue()['role'];
    this.isSpoke = this.auth_$.userData.getValue()['plancode'] === UserPlans.spoke;

    // Determine if user is a hub
    const userPlanCode = this.auth_$.userData.getValue()['plancode'];
    this.isHub = userPlanCode === UserPlans.hub;
    this.isHub = true;
    this.showSpokesAsFolders = this.isHub;

    // Get the sharer hubs
    this.sharerHubs = [];

    // Mock spokes data for testing (to be replaced with real data later)
    // Set the hub name (will be dynamic based on user's facility later)
    // TODO: Replace with actual hub name from user data
    // this.hubName = this.auth_$.userData.getValue()['facilityName'] || 'Your Hospital';

    // TODO: Replace with actual spokes data from user data
    this.sharerSpokes = [
      { name: 'Springfield General Hospital', facilityId: 'spoke-1', facility: 'Springfield General' },
      { name: 'Riverside Medical Center', facilityId: 'spoke-2', facility: 'Riverside Medical' },
      { name: 'City Hospital', facilityId: 'spoke-3', facility: 'City Hospital' }
    ];

    // TODO: Replace with actual permissions from user data
    this.permissions_createfolder = [UserRoles.owner, UserRoles.admin, UserRoles.associate].includes(this.realRole);

    // TODO: Replace with actual permissions from user data
    this.permissions = {
      createfolder: this.permissions_createfolder,
      deletefiles: this.permissions_deletefiles,
      editfiles: this.permissions_editfiles,
      sharefileicon: this.permissions_sharefileicon
    };

    // TODO: Check if this can be obtained later in the code.
    this.firebase_utilities_$.getFacilities().then(async facilities => {
      this.facilities = facilities;
      this.updateFacilitiesConsultantsLists();
    });

    // TODO: Consultants folders are not yet supported. Later development will include them.
    // NOTE: If OWNER, get the consultants folders.
    let consultantsFolders = undefined;
    if (!this.isSpoke) {
      consultantsFolders = [];
      if (this.realRole === UserRoles.owner && this.auth_$.userData.getValue()['showConsultantsFolders']) {
        const validCasename = this.validateCasename();
        if (validCasename) {
          // Consultant folders are no longer supported
          consultantsFolders = [];
        } else {
          console.warn('Skipping consultants folders due to invalid casename');
        }
      }
    }

    // TODO: Update folders list
    // TODO: Check if this can be obtained later in the code.
    // NOTE: This fills up the caseFolders array.
    // await this.updateFoldersList();
    this.caseFolders = await this.handlingFolders(null, this.userOwnerID);

    this.realRole = this.auth_$.userData.getValue()['realRole'];
    this.user = this.auth_$.userData.getValue()['user'];

    const isOwner = this.realRole === UserRoles.owner;
    const noClientUser = !this.patient?.clientUser || this.patient.clientUser.length === 0;

    this.addClientUploadCondition = isOwner && noClientUser;
    this.addClientUploadCondition = false; // Temporary disable this condition
    this.subscribeToClientProfileNotifications();
    // Removed fillUpActionsMenuItems call - no longer needed

    this.sessionStorage_$.clearStoppedGeneratedDiscAlert();
    this.getOwnerAccess();
    this.plancode = this.auth_$.userData.getValue()['plancode'];
    this.auth_$.showLoader(`Loading the ${Labels.clientMatterLabel} ...`);

    this.setPermissions();

    this.permissions_uploadfiles =
      this.realRole === UserRoles.owner || this.realRole === UserRoles.admin || this.realRole === UserRoles.associate;

    this.userIsConsultant = this.realRole === UserRoles.consultant;
    this.userIsOwner = this.realRole === UserRoles.owner;
    this.userIsClient = this.realRole === UserRoles.client;
    this.allowAddNote = this.allowDeleteNote = !this.userIsConsultant;
    this.uploadHelper_$.scannedBlocksSource.next([]); // Clean scanned blocks.

    if ([UserRoles.admin, UserRoles.owner, UserRoles.superuser].includes(this.user.role)) {
      this.subscribeToFilesAction();
    }
    this.subscribeToInfectedFiles();
    this.subscribeToClientProfileActions();
    this.subscribeToClientProfileFiles();

    if ([UserRoles.owner, UserRoles.admin, UserRoles.associate].includes(this.user.role)) {
      window.onclick = event => {
        event.preventDefault();
        this.cleanHighlighted();
        this.showSharedConsultantsByFile({});
      };
    }

    this.uid = this.auth_$.uid;
    this.activeFacilityUser = null;

    // NOTE: No need to get the folders here, they are already in the caseFolders array.
    // this.caseFolders = await this.handlingFolders();

    if (consultantsFolders?.length > 0) {
      // Filter out facilitator folders for Owner role before adding to caseFolders
      const filteredConsultantsFolders = consultantsFolders.filter(folder => {
        if (this.realRole === this.UserRoles.owner && folder.folderId && folder.folderId.includes('@')) {
          const email = folder.folderId;
          const isFacilitator = false; // Facilitator folders are no longer supported
          if (isFacilitator) {
            return false;
          }
        }
        return true;
      });

      this.caseFolders = this.caseFolders.concat(filteredConsultantsFolders);
    }

    this.foldersStructure = {
      name: 'Home',
      id: '',
      children: [
        {
          name: indexFolderLabel,
          id: INDEX_FOLDER_NAME,
          children: []
        }
      ].concat(
        this.caseFolders.map(folder => {
          return {
            name: folder.name,
            id: folder.folderId,
            color: folder.color,
            children: []
          };
        })
      )
    };

    // Initialize accordion data after folders are loaded
    await this.initializeAccordionData();

    this.topMenuData.foldersStructure = this.foldersStructure;
    this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;

    this.subscribeToFileUploads();

    this.selection.clear();

    // Update the facilities users lists
    // TODO: Remove this method if not needed
    await this.updateFacilitiesUsersLists();

    this.ownerTotalStudies = await this.getOwnerTotalStudies();
    this.ownerPlanCode = this.getOwnerPlanCode();

    // this.handleActiveButton(this.button);
    this.auth_$.hideLoader();

    if (this.targetFolder) {
      await this.browseFolderByName(this.targetFolder);
    }

    if (this.section) {
      console.log('section: ', this.section);
    } else {
      await this.getData();
    }

    // Ensure allFiles is populated
    await this.ensureAllFilesPopulated();

    this.auth_$.hideLoader();
  }

  async getSharerHubs(casename: string, facility: string) {
    const docid = casename;

    const doc = await firebase.firestore().collection('patients').doc(docid).get();
    const patient = doc.data();
    const facilities = patient.sharedWith.facilities;
    // Find all facility objects matching the facility and collect their hubs (could be multiple)
    const hubs = facilities
      .filter(facilityObj => facilityObj?.facility === facility && facilityObj?.hub)
      .map(facilityObj => facilityObj.hub);
    return hubs;
  }

  getUploadTypes() {
    return [
      { id: '1', name: UploadTypes.FILE },
      { id: '2', name: UploadTypes.VIDEO },
      { id: '3', name: UploadTypes.DICOMDisk },
      { id: '4', name: UploadTypes.VIDEODisk }
    ];
  }

  getPatientName(patient?: { firstname?: string; lastname?: string }): string {
    if (!patient || !patient.firstname || !patient.lastname) {
      return '';
    }
    return `${patient.firstname.charAt(0).toUpperCase()}${patient.firstname.slice(1)} ${patient.lastname
      .charAt(0)
      .toUpperCase()}${patient.lastname.slice(1)}`;
  }

  async handlingFolders(selectedHub?: string, userOwnerID?: string) {
    await this.checkCreateDefaultFolders(this.patient.ownerID);
    return this.firebase_utilities_$.getFolders(this.casename, {
      patientType: this.patient.type,
      isSpoke: false,
      restrictedTo: null,
      selectedHub,
      ownerID: this.patient.ownerID,
      userOwnerID: userOwnerID
    });
  }

  async reloadFoldersForSelectedHub() {
    if (!this.selectedHub) {
      return;
    }

    // Use the selected hub as the facility context
    const hubFacility = typeof this.selectedHub === 'string' ? this.selectedHub : this.selectedHub.facility;
    const selectedHubName =
      typeof this.selectedHub === 'string' ? this.selectedHub : this.selectedHub.name || this.selectedHub.facility;


    // Reload folders with the hub's facility and selected hub name
    this.caseFolders = await this.handlingFolders(selectedHubName, this.userOwnerID);

    // Reinitialize accordion data with the new folders
    await this.initializeAccordionData();
  }

  async addConsultant() {
    const limits = await this.checkPlanLimits();
    const { CreateuserComponent } = await import('../createuser/createuser.component');
    const r_dialog = this.dialog_$.open(CreateuserComponent, {
      width: '680px',
      data: {
        userType: 'Admin',
        title: this.realRole === UserRoles.client ? 'Add an observer' : 'Create a user',
        defaultValue: this.realRole === UserRoles.client ? 'consultant' : null,
        role: this.realRole,
        button: 'Create',
        screen: 'full',
        casename: this.casename,
        limits: { limits: limits }
      }
    });
    r_dialog.afterClosed().subscribe(async result => {
      if (result) {
        // Refresh all consultant and admin lists after creating a new user
        this.availableConsultants = await this.getAvailableConsultants();
        // TODO: Remove this method if not needed
        // await this.updateFacilityConsultantsLists();
        // TODO: Remove this method if not needed
        // await this.updateFacilityAdminsLists();
        // Trigger change detection to update the UI
        this.ref.detectChanges();
      }
    });
  }

  async checkPlanLimits() {
    const [limits, users] = await Promise.all([
      this.getPlanLimits(this.auth_$.userData.value['plancode']),
      this.getUsersCount()
    ]);
    return { limits, users };
  }

  private getUsersCount() {
    return this.auth_$.getUsersCount();
  }

  private getPlanLimits(planCode: string) {
    return this.auth_$.getPlanLimits(planCode).then(limits => {
      return limits;
    });
  }

  // FIXME: Use the default folders obtained here to avoid to get them later in the code.
  async checkCreateDefaultFolders(ownerID?: string) {
    const mandatoryFolders = await this.getDefaultFolders();
    const currentMandatoryFolders =
      (await this.firebase_utilities_$.getPatientDefaultFolders(this.casename, ownerID)) || [];
    const missing = mandatoryFolders.filter(f => !currentMandatoryFolders.some(pf => pf.name === f.name));

    if (missing.length) {
      // TODO: Make sure this method add the folders restrictions.
      // These folders should have the same ownership as the patient.
      await this.createDefaultFolders(missing, this.casename, ownerID);
    }
  }

  subscribeToClientProfileNotifications() {
    this.auth_$.clientProfileNotifications.subscribe(
      notifications => (this.clientProfileNotifications = notifications)
    );
  }

  onNotificationClick({ action, id }) {
    if (action === 'ok') {
      this.auth_$.clientProfileActionsData = { fileId: id };
      this.auth_$.clientProfileActions.next('gotodiscs');
    } else {
      {
        this.auth_$.disableUserDataNewDownloadNotification(id);
        this.auth_$.disableFirestoreNewDownloadNotification(id);
      }
    }

    this.clientProfileNotifications = this.clientProfileNotifications.filter(notification => notification.id !== id);
  }

  subscribeToInfectedFiles() {
    this.firebase_utilities_$.infectedFiles.subscribe(x =>
      this.infectedFiles.length > 0 ? this.showInfectedFiles(this.infectedFiles) : null
    );
  }

  subscribeToFilesAction() {
    this.uploadHelper_$.action.subscribe({
      next: action => {
        if (action === 'update') {
          this.getFilesForPatient(this.currentFolder, {
            caseFolders: this.caseFolders,
            roleConsultant: this.userIsConsultant,
            roleClient: this.userIsClient
          });
        }
      },
      error: error => { },
      complete: () => { }
    });
  }

  subscribeToFileUploads() {
    // Allow specific roles or users without defined roles for development
    if ([UserRoles.owner, UserRoles.admin, UserRoles.associate].includes(this.user.role) || !this.user.role) {
      // NOTE: Set an observer to fetch files after each file upload.
      // Use subscribe instead of toPromise() to handle multiple uploads
      this.subscription.add(
        this.uploadHelper_$.fileUploaded.subscribe({
          next: async uploaded => {
            if (uploaded) {
              const folderName = this.getFolderName(this.caseFolders, this.currentFolder);
              this.topMenuData.currentFolderName = folderName;
              this.topMenuData.currentFolder = this.currentFolder;
              this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;

              try {
                // Get files for patient first
                await this.getFilesForPatient(this.currentFolder, {
                  folderName: folderName,
                  caseFolders: this.caseFolders,
                  roleConsultant: this.userIsConsultant,
                  roleClient: this.userIsClient
                });

                // Add a longer delay to ensure Firebase data is committed and Algolia is indexed
                setTimeout(async () => {
                  try {
                    // First, refresh all files data to ensure we have the latest data
                    await this.refreshAllFiles();

                    // Force refresh accordion folders to update file counts
                    await this.refreshAccordionFolders();

                    // Also refresh the INDEX folder specifically to ensure its count is updated
                    await this.forceRefreshIndexFolderCount();

                    // Also refresh the target folder count if a specific folder was targeted
                    if (this.targetFolder && this.targetFolder.folderId) {
                      await this.forceRefreshTargetFolderCount(this.targetFolder.folderId);
                    }

                    // Add a second retry after another delay to ensure counts are updated
                    setTimeout(async () => {
                      try {
                        if (!this.isSpoke) {
                          await this.forceRefreshIndexFolderCount();
                        }
                        if (this.targetFolder && this.targetFolder.folderId) {
                          await this.forceRefreshTargetFolderCount(this.targetFolder.folderId);
                        }
                      } catch (retryError) {
                        console.error('❌ Error in retry update:', retryError);
                      }
                    }, 3000);
                  } catch (error) {
                    console.error('❌ Error updating folder counts after file upload:', error);
                    // Show user-friendly error message
                    this.uiMessaging_$.toastMessage(
                      'Files uploaded but some display updates failed. Please refresh the page.',
                      'WARNING',
                      { duration: 5000 }
                    );
                  }
                }, 3000); // Increased delay to 3 seconds
              } catch (error) {
                console.error('❌ Error in file upload subscription:', error);
                this.uiMessaging_$.toastMessage(
                  'Error refreshing files after upload. Please refresh the page.',
                  'ERROR',
                  { duration: 5000 }
                );
              }
            }
          },
          error: error => {
            console.error('❌ Error in fileUploaded subscription:', error);
            this.uiMessaging_$.toastMessage('Error monitoring file uploads. Please refresh the page.', 'ERROR', {
              duration: 5000
            });
          },
          complete: () => {
            // File upload subscription completed
          }
        })
      );
    }
  }

  async clientProfileReload(event) {
    await this.getData();
  }


  removeFilter() {
    this.filesFilter = { name: '', valid: false };
    this.getFilesForPatient(this.currentFolder, {
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient
    });
    this.topMenuData.clearFilterButton = false;
  }

  getProperViewer(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    let viewer = 'google';

    switch (extension) {
      case 'mp4':
      case 'avi':
        viewer = 'video';
        break;
      case 'pdf':
        viewer = 'pdf';
        break;
      case 'doc':
      case 'docx':
      case 'xls':
      case 'xlsx':
      case 'ppt':
      case 'pptx':
      case 'csv':
        viewer = 'office';
        break;
      case 'png':
      case 'jpg':
      case 'jpeg':
      case 'gif':
        viewer = 'url';
        break;
      default:
        viewer = 'google';
        break;
    }
    return viewer;
  }

  async previewDocument(filePath: string, fileName: string) {
    this.auth_$.showLoader('Loading the document ...');
    const fileUrl = await this.files_$.getFileUrl(filePath);

    if (!fileUrl) this.uiMessaging_$.toastMessage('Error getting the file URL', 'ERROR');

    const { DocViewerComponent } = await import('../ui/doc-viewer/doc-viewer.component');
    this.dialog_$
      .open(DocViewerComponent, {
        width: '80%',
        data: {
          src: fileUrl.data.url,
          title: fileName,
          info: fileUrl.data.url,
          viewer: this.getProperViewer(fileName)
        }
      })
      .afterOpened()
      .subscribe(() => this.auth_$.hideLoader());
  }


  async getData() {
    // Load INDEX folder by default to populate allFiles
    if (!this.currentFolder || this.currentFolder === '') {
      this.currentFolder = INDEX_FOLDER_NAME;
      this.currentFolderName = indexFolderLabel;
    }

    // Process files for accordion
    if (!this.userIsConsultant && !this.userIsClient) {
      await this.updateConsultantsLists();
      // await this.updateFacilityAdminsLists();
      // await this.updateFacilityConsultantsLists();

      // Now update consultant folders for accordion with proper consultant data

      // Mark classification ready and refresh to render consultant folders without flicker
      this.classificationReady = true;
      await this.refreshAccordionFolders();
    }

    // NOTE: Start getting the files.
    await this.getFilesForPatient(this.currentFolder, {
      folderName: this.getFolderName(this.caseFolders, this.currentFolder),
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient,
      caseFolders: this.caseFolders
    });

    this.updatePaginator();
  }

  addSharedFlags(consultantsList: Consultant[], sharedUsers) {
    if (!consultantsList) return [];
    consultantsList.forEach(consultant => {
      consultant.shared = false;
      if (sharedUsers) {
        sharedUsers.forEach(user =>
          user && user.email && consultant.email.toLowerCase() === user.email.toLowerCase()
            ? (consultant.shared = true)
            : null
        );
      }
    });
    return consultantsList;
  }

  handleFolderNameClick(event: { preventDefault: () => void }, element: { parentFolderName: any; parentFolder: any }) {
    event.preventDefault();
    this.browseFolderByName(element.parentFolderName || element.parentFolder);
  }

  async browseFolderByName(folderName: string, defaultSort?: string) {
    const folderId = await this.getFolderId(folderName);
    if (!folderId) {
      console.error('Folder not found.', folderName);
      throw new Error('Folder not found.');
    }

    return this.browseFolderContents(folderId, folderName, defaultSort || null).then(() => {
      this.currentFolderName = folderName;
      this.currentFolder = folderId;
      this.updateFolderPath(); // Update the folder path
      this.topMenuData.currentFolderName = folderName;
      this.topMenuData.currentFolder = folderId;
      this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;
    });
  }


  /** @deprecated PracticePanther integration removed */
  checkPracticePantherAuthToken(): string {
    return '';
  }

  /**
   * Deactivates the active consultant, clears files selection and getFiles for the patient based on a folderId.
   * Updates the variables:
   * - activeConsultant
   * - activeFacilityUser
   * - selection
   * - currentFolderName
   * - currentFolder
   * @param folderId if the folder you intend to browse.
   * @param folderName string name.
   */
  async browseFolderContents(folderId: string, folderName: string, defaultSort?: string) {
    // TODO: Get rid of this portion since there is no need for activeConsultant
    // this.activeConsultant = this.activeFacilityUser = null;
    this.selection.clear();
    this.auth_$.setCurrentFolder(folderName);

    let diagnoses = [];

    // NO NEED FOR DIAGNOSES IN THE CLIENT PROFILE ANYMORE
    /* if (folderName === LIBRARY_FOLDER_NAME) {
      diagnoses = await this.getDiagnoses();
    } */

    await this.getFilesForPatient(
      folderId,
      {
        globalFolders: true,
        folderName: folderName,
        roleConsultant: this.userIsConsultant,
        roleClient: this.userIsClient,
        caseFolders: this.caseFolders,
        defaultSort: defaultSort
      },
      true,
      diagnoses
    );

    if (defaultSort) {
      this.handleSortData({ active: defaultSort, direction: 'desc' });
    }

    if (!this.userIsConsultant) {
      // this.updateConsultantsLists();
      // this.updateFacilityAdminsLists();
      // this.updateFacilityConsultantsLists();
    }

    if (this.currentFolderName === DISCS_FOLDER_NAME) {
      // this.displayedColumns = this.displayedColumns.filter(column => ![this.lastModified, 'fileId'].includes(column));
      this.sortTypes = this.sortTypes.filter(sort => !['ftype', 'lastModified'].includes(sort.value));
      this.sortTypes.find(sort => sort.value === 'uploadedDate').label = 'Date Created';
    }
  }

  /**
   * Check if the given viewerurl is forbidden to be browsed.
   * @param viewerurl the url to be destructured.
   * @returns boolean
   */
  checkInactiveStore(element: any): boolean {
    if (!element || !element.viewerurl) {
      return;
    }
    const storename = this.utils_$.viewerurlToDicomStore(element.viewerurl, viewerUrlParts.dicomStore);
    const casename = this.utils_$.viewerurlToDicomStore(element.viewerurl, viewerUrlParts.dataSet);
    if (!this.uploadHelper_$.unAvailableStores.length) {
      return;
    }

    const isUnAvailable = this.uploadHelper_$.unAvailableStores.filter(el => {
      const sameStore = el.storename === storename;
      const sameCase = el.casename === casename;
      if (sameCase && sameStore) {
        return true;
      } else {
        return;
      }
    });

    return isUnAvailable.length > 0;
  }

  checkIfSelected(file: { fileId: any }) {
    for (let index = 0; index < this.selection.selected.length; index++) {
      if (this.selection.selected[index].fileId === file.fileId) {
        return true;
      }
    }
    return false;
  }

  /**
   * Check if any of the files in the list has any shared user that match with the given consultant email.
   */
  checkIfAnyShared(filesList: any[], consultantemail: string): boolean {
    for (let index = 0; index < filesList.length; index++) {
      if (filesList[index].sharedUsers && filesList[index].sharedUsers.length > 0) {
        for (let j = 0; j < filesList[index].sharedUsers.length; j++) {
          if (filesList[index].sharedUsers[j].email.toLowerCase() === consultantemail.toLowerCase()) {
            return true;
          }
        }
      }
    }
    return false;
  }

  clearActiveConsultantsSelected() {
    this.activeConsultants.forEach(consultant => (consultant.selected = false));
  }

  clearActiveFacilitiesUsersSelected() {
    this.activeFacilitiesUsers.forEach(user => (user.selected = false));
  }

  clearSharedFlags(consultantsList: any[]): any[] {
    if (!consultantsList) return [];
    consultantsList.forEach(consultant => {
      consultant.shared = false;
    });
    return consultantsList;
  }

  private async checkDefaultFoldersV2(caseName: string, defaultFolders, ownerID?: string): Promise<boolean> {
    const _defaultFolders = defaultFolders.map(folder => folder.name);
    const dbFiles = firebase.firestore().collection('files');
    let query = dbFiles
      .where('belongsTo', '==', caseName)
      .where('type', '==', 'folder')
      .where('name', 'in', _defaultFolders);
    if (ownerID) query = query.where('ownerID', '==', ownerID);
    const result = await query.get();
    return !result.empty;
  }

  async createDefaultFolders(defaultFolders, belongsTo: string, ownerID?: string) {
    if (await this.checkDefaultFoldersV2(belongsTo, defaultFolders, ownerID)) return true;

    await Promise.all(
      defaultFolders.map(({ name, color }) =>
        this.firebase_utilities_$.createFolder({
          children: '',
          name: name,
          color: color,
          parentFolder: '',
          type: 'folder',
          belongsTo: belongsTo,
          predefined: true,

          forDelete: false,
          folderId: this.uploadHelper_$.getRandomString(20),
          ownerID: ownerID
        })
      )
    );

    await this.firebase_utilities_$.updateDefaultFolders(true, {
      casename: this.casename,
      ...(ownerID && { ownerID })
    });
  }

  cleanHighlighted() {
    document.querySelectorAll('.mat-column-fileName .mat-icon').forEach(item => item.classList.remove('on'));
  }

  async copySelectedTo(folderId: string) {
    const folderName = this.caseFolders.find(folder => folder.folderId === folderId).name;
    return this.firebase_utilities_$.createFirestoreFilesDuplicates(this.selection.selected, {
      folderId,
      folderName
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string' && typeof b === 'string')
      return (a.trim().toLowerCase() < b.trim().toLowerCase() ? -1 : 1) * (isAsc ? 1 : -1);
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareDates(a: number | string, b: number | string, isAsc: boolean) {
    return (new Date(a).getTime() < new Date(b).getTime() ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * Check if emails from the @param usersArr are existing users, otherwise
   * this email(s) will be returned back.
   */
  async clearNonExistentUsers(usersArr: string[]): Promise<{ unLinked: string[]; notExistent: string[] }> {
    if (!usersArr.length) return { unLinked: [], notExistent: [] };
    
    const result = await this.clientProfileConsultantService.clearNonExistentUsers(usersArr);
    
    if (result.notExistent.length > 0) {
      const message = 'There were some deleted consultants linked to your file. Those have been removed successfully.';
      this.uiMessaging_$.toastMessage(message, 'IMPORTANT');
    }
    
    return result;
  }

  deleteGoogleStorageFile(filePath: string, fileName: string, storageBucket: string) {
    return this.files_$
      .deleteGoogleStorageFile(filePath, storageBucket)
      .then(() => {
        // File deleted successfully
      })
      .catch(error => {
        console.error('Error deleting the file from Google Storage.', error);
        return error;
      });
  }

  deleteSingleRow(element, event: { stopPropagation: () => void }) {
    event.stopPropagation();

    if (element.DICOMDIRFileId) {
      this.deleteZippedDiscContentsFile(element);
      return;
    }

    if (!element) return;

    if (element.type !== 'folder') {
      this.selection.selected[0] = element;
      this.openDeleteConfirmDialog();
    } else {
      // Remove folder
    }
  }

  updateDeletedZippedDiscContentsFile(DICOMDIRFileId) {
    return this.files_$.updateDeletedZippedDIscContentsFile(DICOMDIRFileId);
  }

  deleteZippedDiscContentsFile(element) {
    const { filePath, fileId, fileName, storageBucket, DICOMDIRFileId } = element;

    this.auth_$.showLoaderV2('Deleting the zipped contents file ...', {
      loaderId: 'deleting-zipped-file',
      hasBackdrop: false
    });

    // 1. Delete the Google Storage file.
    this.deleteGoogleStorageFile(filePath, fileName, storageBucket)
      .then(() => {
        // 2. Update the DICOMDIR file.
        this.files_$
          .removeDownloadLinkFromFile(DICOMDIRFileId)
          .then(() => {
            // 3. Delete the file.
            this.files_$
              .deleteFileByFileId(fileId)
              .then(() => {
                this.auth_$.updateLoaderMessage('The zipped contents file has been deleted.', 'deleting-zipped-file');
                setTimeout(() => {
                  this.auth_$.hideLoader('deleting-zipped-file');
                  this.getFilesForPatient(this.currentFolder, this.getFilesForPatientOptions());
                  this.auth_$.hideLoader('deleting-zipped-file');
                }, 3000);
              })
              .catch(error => {
                console.error('Error deleting the file.', error);
                this.auth_$.updateLoaderMessage('Error deleting the file.', 'deleting-zipped-file');
                setTimeout(() => this.auth_$.hideLoader('deleting-zipped-file'), 3000);
              });
          })
          .catch(error => {
            console.error('Error deleting the DICOMDIR file.', error);
            this.auth_$.updateLoaderMessage('Error deleting the file.', 'deleting-zipped-file');
            setTimeout(() => this.auth_$.hideLoader('deleting-zipped-file'), 3000);
          });
      })
      .catch(error => {
        console.error('Error deleting the DICOMDIR file.', error);
        this.auth_$.updateLoaderMessage('Error deleting the file.', 'deleting-zipped-file');
        setTimeout(() => this.auth_$.hideLoader('deleting-zipped-file'), 3000);
      });
  }

  deleteFilesFromAlgolia(fileIds: string[]) {
    this.algolia_$
      .deleteManyFromAlgolia(fileIds)
      .then(() => this.uiMessaging_$.toastMessage('Files deleted successfully', 'IMPORTANT'));
  }

  /**
   * Delete multiple files from the files list.
   */
  async deleteFiles(files: { fileId: string; filePath: string; fileName: string }[]) {
    let wrongStructuredFile;

    const findWrongStructuredFile = file => {
      const condition = file.fileId && file.filePath && file.fileName;
      if (!condition) {
        wrongStructuredFile = file;
      }
      return condition;
    };

    // Check the files params is an array of objects with the given properties.
    if (!Array.isArray(files) || !files.length || !files.every(findWrongStructuredFile)) {
      // Show the wrong structured file with more detailed error message
      const missingProps = [];
      if (!wrongStructuredFile.fileId) missingProps.push('fileId');
      if (!wrongStructuredFile.filePath) missingProps.push('filePath');
      if (!wrongStructuredFile.fileName) missingProps.push('fileName');

      const errorMsg = `Error deleting the file(s).${wrongStructuredFile.fileName || wrongStructuredFile.fileId || 'Unknown'} - Missing: ${missingProps.join(', ')}`;
      console.error('File validation failed:', wrongStructuredFile, 'Missing properties:', missingProps);
      this.uiMessaging_$.toastMessage(errorMsg, 'ERROR');
      return;
    }

    try {
      const filesWithId = (files as any[]).filter(f => f.id);
      const filesWithoutId = (files as any[]).filter(f => !f.id);

      if (filesWithoutId.length > 0) {
        console.warn('Delete aborted: files missing Firestore doc id', filesWithoutId);
        this.uiMessaging_$.toastMessage(
          `Unable to delete ${filesWithoutId.length} file(s): missing internal document id. Please refresh and try again.`,
          'ERROR'
        );
        return;
      }

      // NOTE: Delete files from Storage.
      await this.deleteFilesFromStorage(files.map(f => f.filePath));

      const filesData: { id: string; fileId: string }[] = filesWithId.map(f => ({ id: f.id, fileId: f.fileId }));
      const deletedFiles = await Promise.all(filesData.map(file => this.files_$.deleteFileByDocId(file)));

      // Only remove files from accordion after successful deletion
      files.forEach(file => {
        this.removeFileFromAccordion(file.fileId);
      });

      this.deleteFilesFromAlgolia(deletedFiles.map(f => f.fileId));
      this.handleDeleteAllFilesNotifications(deletedFiles.map(f => f.fileId));
      this.uiMessaging_$.toastMessage('The file(s) has been deleted.', 'INFO');
      if (!this.userIsConsultant && !this.userIsConsultant) {
        // this.updateConsultantsLists();
        // this.updateFacilityAdminsLists();
        // this.updateFacilityConsultantsLists();
      }
      this.getFilesForPatient(this.currentFolder, this.getFilesForPatientOptions());
    } catch (error) {
      console.error('Error deleting files:', error);
      this.uiMessaging_$.toastMessage('Error deleting the file(s). Please try again.', 'ERROR');
    }
  }

  @HostListener('document:click')
  documentClick(): void {
    this.isDisplayContextMenu = false;
  }

  // TODO: Get rid of this method since the SharedFilesComponent is not needed anymore.
  /* fileSharedValidation(row: {
    sharedUsers: {
      filter: (arg0: (item: any) => boolean) => { (): any; new (): any; length: any };
    };
  }) {
    if (!this.activeConsultant || !row.sharedUsers) {
      return false;
    }
    return row.sharedUsers.filter(item => item.email.toLowerCase() === this.activeConsultant.toLowerCase()).length;
  } */

  fetchAlgoliaSearchResults(flag: boolean) {
    if (!flag) {
      // fetchAlgoliaSearchResults -- flag is false
      return;
    }

    const fixMissingFolderName = (): any[] => {
      return this.algolia_$.algoliaSearchResults.map(g => ({
        ...g,
        parentFolderName:
          g.parentFolderName === ''
            ? this.caseFolders.find(f => f.folderId === g.parentFolder).name
            : g.parentFolderName
      }));
    };

    const processedResults = fixMissingFolderName();
    this.filesTableDataSource.data = processedResults;

    // Update search results for the new component
    this.searchResults = processedResults;
    this.isSearchActive = true;
  }

  filesSelected() {
    return Boolean(this.selection.selected.find(selected => selected?.type !== 'folder'));
  }

  fileSelected() {
    return (
      Boolean(this.selection.selected.find(selected => selected?.type !== 'folder')) &&
      this.selection.selected.length === 1
    );
  }

  focusActiveConsultantsTab() {
    this.consultantsSelectedTabIndex = 0;
  }

  focusActiveFacilityUsersTab() {
    this.facilityusersSelectedTabIndex = 0;
  }

  formatDate(dateString: string | number | Date) {
    return new Date(dateString).toLocaleDateString('en-EN');
  }

  /** @deprecated PracticePanther integration removed */
  getPracticePantherAuthorization(): void {}

  /** @deprecated PracticePanther integration removed */
  private getPracticePantherUrl(): string {
    return '';
  }

  getOtherFolderId(casename: string) {
    return this.files_$.getOtherFolderId(casename);
  }

  getFilesCountByClient(casename: string, roleConsultant?: boolean, consultantEmail?: string) {
    return this.files_$.getFilesCountByClient(casename, roleConsultant, consultantEmail);
  }

  goBack() {
    window.history.back();
  }

  async goRefresh(ev) {
    ev ? ev.preventDefault() : (ev = {});
    this.firebase_utilities_$.infectedFiles.next([]);
    this.getFilesForPatient(this.currentFolder, await this.getRefreshOptions());
  }

  async setFolderCountLabels(isConsultant, caseFolders) {
    if (isConsultant) return caseFolders;
    else {
      const options = {
        isConsultant: this.userIsConsultant,
        isClient: this.userIsClient,
        useremail: this.auth_$.userData.value['email']
      };
      const getLabel = async ({ folderId, name }) => this.files_$.getFolderLabel(folderId, name, options);
      return await Promise.all(
        caseFolders.map(async (folder: { folderId: any; name: any }) => ({
          ...folder,
          label: await getLabel(folder)
        }))
      );
    }
  }

  /**
   * Get the extra information for a folder.
   * @param folder the folder to get the extra information for.
   * @param roleConsultant the role of the consultant.
   * @param useremail the email of the user.
   * @param filesShared the files shared with the user.
   * @returns the extra information for the folder.
   */
  async getFolderExtra(folder, roleConsultant, useremail, filesShared) {
    const folderExtra = await this.clientProfileFolderService.getFolderExtra(
      folder,
      roleConsultant,
      useremail,
      filesShared,
      this.uid
    );
    return {
      ...folderExtra,
      fileId: this.uploadHelper_$.getRandomString(17),
      hasNotifications: this.checkIfFolderHasNotifications(folder.folderId)
    };
  }

  async getFolderNameExtra(folder: { name: string }, roleConsultant: any, useremail: any, filesShared: any) {
    return this.clientProfileFolderService.getFolderNameExtra(folder, roleConsultant, useremail, filesShared);
  }

  async getFolderNameWithCounter(folder, roleConsultant, useremail, filesShared) {
    return this.clientProfileFolderService.getFolderNameWithCounter(folder, roleConsultant, useremail, filesShared);
  }
  async getFilesIndexFolder({ casename, roleConsultant, userOwnerID = '' }) {
    const userEmail = this.auth_$.userData.value['email'];
    let files = await this.clientProfileFileService.getFilesIndexFolder({
      casename,
      roleConsultant,
      userOwnerID,
      userEmail
    });

    // Decorate files with folder information
    const filesArr = [];
    for (let i = 0; i < files.length; i++) {
      if (files[i].type !== 'folder') {
        const { name, color } = this.getFoldersByParentFolderId(this.caseFolders, files[i].parentFolder);
        files[i]['predefined'] = false;
        files[i]['parentFolderName'] = name;
        files[i]['color'] = color;
        files[i]['hasCommentAttachments'] = files[i].notes && files[i].notes.length > 0;
      }
      filesArr.push(files[i]);
    }

    // FIXME: If this necessary?
    this.files = filesArr;

    // Update allFiles with the complete list of files from INDEX folder
    this.allFiles = [...filesArr];

    return filesArr;
  }

  async getFolderExtraX(fileName, ftype, folderId, predefined) {
    const folderExtra = await this.clientProfileFileService.getFolderExtraX(fileName, ftype, folderId, predefined);
    return {
      ...folderExtra,
      creator: this.uid,
      fileId: this.uploadHelper_$.getRandomString(17)
    };
  }

  /**
   * Get files from a folder.
   * @param paramsObject the parameters for the files.
   * @returns the files from the folder.
   */
  async getFilesFolder(paramsObject): Promise<any[]> {
    const isConsultant = this.realRole === UserRoles.consultant;
    const { casename, folderId, email, ownerID, userOwnerID } = paramsObject;

    // Fetch files and folders, merge and deduplicate by id
    const [directFiles, directFolders] = await Promise.all([
      this.files_$.getFilesByParentFolderId(
        folderId,
        casename,
        null,
        isConsultant,
        isConsultant ? email : '',
        ownerID,
        userOwnerID
      ),
      this.files_$.getFolderItemsByParentFolderId(
        folderId,
        casename,
        null,
        isConsultant,
        isConsultant ? email : '',
        ownerID,
        userOwnerID
      )
    ]);
    const filesMap = new Map<string, any>();
    [...directFiles, ...directFolders].forEach(item => {
      const key = item.folderId || item.fileId || item.id || Math.random().toString();
      filesMap.set(key, item);
    });
    const files = Array.from(filesMap.values()).filter(f => {
      const fileName = f.filename || f.fileName || f.name;
      return fileName && fileName.trim() !== '';
    });

    // Use service to get files with decorations
    const filesArr = await this.clientProfileFileService.getFilesFolder({
      folderId,
      casename,
      email,
      ownerID,
      userOwnerID,
      isConsultant,
      caseFolders: this.caseFolders
    });

    this.files = filesArr;
    return filesArr;
  }

  /**
   * Checks if a file has notifications.
   * @param file the file to check.
   * @returns true if the file has notifications, false otherwise.
   */
  private checkIfFileHasNotifications(file) {
    return [
      'modifiedNoteNotifications',
      'newFileNotifications',
      'newNoteNotifications',
      'sharedFileNotifications'
    ].some(key => Array.isArray(file[key]) && file[key].length > 0);
  }

  /**
   * Gets the files array for a folder.
   * @param folderId the id of the folder.
   * @param roleConsultant the role of the consultant.
   * @param caseFolders the case folders.
   * @returns the files array for the folder.
   */
  async getFilesArray(folderId: string, roleConsultant, caseFolders, userOwnerID = null) {
    switch (folderId) {
      case HOME_FOLDER_NAME:
        return await this.getFilesHomeFolder({ roleConsultant, caseFolders });
      case INDEX_FOLDER_NAME:
        return await this.getFilesIndexFolder({
          roleConsultant,
          casename: this.casename,
          userOwnerID: userOwnerID
        });
      default:
        const email = this.auth_$.userData.value['email'];
        return await this.getFilesFolder({
          folderId,
          casename: this.casename,
          email,
          ownerID: this.ownerID,
          userOwnerID: userOwnerID
        });
    }
  }

  /**
   * Get files from all subfolders recursively
   */
  private async getFilesFromSubfolders(
    parentFolderId: string,
    casename: string,
    creator: any,
    isConsultant: boolean,
    email: string
  ): Promise<any[]> {
    try {
      // Get all subfolders of this folder
      const subfolders = await this.firebase_utilities_$.getFoldersByParentFolderId(parentFolderId, casename);

      let allSubfolderFiles: any[] = [];

      for (const subfolder of subfolders) {
        // Get files directly in this subfolder
        const subfolderFiles = await this.files_$.getFilesByParentFolderId(
          subfolder.folderId,
          casename,
          creator,
          isConsultant,
          isConsultant ? email : ''
        );

        // Add files from this subfolder
        allSubfolderFiles = allSubfolderFiles.concat(subfolderFiles);

        // Recursively get files from sub-subfolders
        const deeperFiles = await this.getFilesFromSubfolders(
          subfolder.folderId,
          casename,
          creator,
          isConsultant,
          email
        );

        allSubfolderFiles = allSubfolderFiles.concat(deeperFiles);
      }

      return allSubfolderFiles;
    } catch (error) {
      console.error('Error getting files from subfolders:', error);
      return [];
    }
  }

  /**
   * Get all the files for the current opened Client Profile.
   * Updates the global variables:
   * - files
   * - filesTableDataSource
   * - currentFolder
   * - currentFolderName
   * - pageSize
   * @param folderId where the files will be loaded from.
   * @param options globalFolder, folderName
   * @returns a void promise.
   */
  async getFilesForPatient(
    folderId: string = '',
    options: any = {},
    checkNotifications?: boolean,
    diagnoses = []
  ): Promise<any> {
    this.startRefreshing();

    const files = (
      await this.getPatientsFilesArray(folderId, options.roleConsultant, options.caseFolders, this.userOwnerID)
    ).concat(diagnoses);

    this.updatePage(files, folderId, options.folderName);
    this.stopRefreshing();
  }

  /**
   * Starts the refreshing process.
   * Updates the variables:
   * - refreshing
   * - refreshButton
   * - files
   */
  startRefreshing() {
    this.refreshing = true;
    this.refreshButton = false;
    this.files = [];
  }

  /**
   * Updates the paging for the files.
   * Updates the variables:
   * - filesTableDataSource
   * - currentFolder
   * - currentFolderName
   * - pageSize
   * @param files the files to be updated.
   * @param folderId the folder id.
   * @param folderName the folder name.
   * @returns a void promise.
   * @description This function updates the paging for the files.
   * @date 2025-07-02
   */
  updatePage(files, folderId, folderName) {
    this.setPaging(files, folderId, folderName);
    this.refreshButton = true;
  }

  /**
   * Stops the refreshing process.
   */
  stopRefreshing() {
    // this.auth_$.hideLoader();
  }

  /**
   * Builds the context object required by ClientProfileLibraryFacade methods.
   */
  private getLibraryContext(): LibraryContext {
    return {
      casename: this.casename,
      currentFolder: this.currentFolder,
      currentFolderName: this.currentFolderName,
      caseFolders: this.caseFolders,
      userIsConsultant: this.userIsConsultant,
      userIsClient: this.userIsClient
    };
  }

  /**
   * Shows the library manager.
   */
  async showLibraryManager() {
    return this.libraryFacade.showLibraryManager(this.getLibraryContext());
  }

  /**
   * Adds a diagnosis.
   */
  async addDiagnoses() {
    return this.libraryFacade.addDiagnoses(this.getLibraryContext(), this.ownerID);
  }

  /**
   * Shows the my diagnoses.
   * afterClosed() stays here because getFilesForPatient is not owned by the facade.
   */
  async showMyDiagnoses() {
    const ref = await this.libraryFacade.showMyDiagnoses(this.getLibraryContext());
    ref.afterClosed().subscribe({
      next: answer => {
        const { action, diagnosis } = answer || {};
        switch (action) {
          case 'edit':
            this.editDiagnosis(diagnosis);
            break;
          case 'delete':
            this.deleteDiagnosis(diagnosis);
            break;
          default:
            break;
        }
        this.getFilesForPatient(this.currentFolder, this.getFilesForPatientOptions());
      },
      error: err => console.error(err)
    });
  }

  /**
   * Deletes a diagnosis.
   * @param diagnosis the diagnosis to be deleted.
   */
  deleteDiagnosis(diagnosis) {
    this.libraryFacade.deleteDiagnosis(diagnosis);
  }

  /**
   * Edits a diagnosis.
   * @param diagnosis the diagnosis to be edited.
   */
  async editDiagnosis(diagnosis) {
    return this.libraryFacade.editDiagnosis(diagnosis, this.getLibraryContext());
  }


  /**
   * Get the folder name of a given folderId.
   * @param caseFolders is the array having all the folders (name,id) of the given casename.
   * @param parentFolderId to match with the caseFolder items.
   * @returns the name of the folder or empty string.
   */
  getFolderName(caseFolders, parentFolderId): string {
    return this.clientProfileFolderService.getFolderName(caseFolders, parentFolderId);
  }

  /**
   * Get the folders by parent folder id.
   * @param caseFolders the case folders.
   * @param parentFolderId the parent folder id.
   * @returns the folders by parent folder id.
   */
  getFoldersByParentFolderId(caseFolders: any[], parentFolderId: string): FolderElement {
    const result = this.clientProfileFileService.getFoldersByParentFolderId(caseFolders, parentFolderId);
    return {
      name: result.name,
      id: parentFolderId,
      color: result.color
    };
  }

  /**
   * Gets the missing shared files.
   * @param file the file.
   */
  async getMissingSharedFiles(file) {
    if (!file.sharedUsers) {
      return;
    }
    const sharedUserEmails = file.sharedUsers.map(u => u.email.toLowerCase());
    const activeConsultantsEmails = this.activeConsultants.map(ac => ac.email.toLowerCase());
    const notFound = this.findIn(sharedUserEmails, activeConsultantsEmails);
    if (!notFound.length) {
      return;
    }

    const { unLinked, notExistent } = await this.clearNonExistentUsers(notFound);
    this.repairUnLinkedUsers(unLinked, notFound, file);
    this.repairNonExistent(notExistent, file);
    this.ngOnInit();
  }

  /**
   * Finds the missing files.
   * @param arr1 the array 1.
   * @param arr2 the array 2.
   * @returns the missing files.
   */
  findIn(arr1, arr2) {
    return this.clientProfileFileService.findIn(arr1, arr2);
  }

  /**
   * Gets the folder id by folder name.
   * @param folderName the folder name.
   * @returns the folder id.
   */
  async getFolderIdByFolderName(folderName: string) {
    if (!this.caseFolders || this.caseFolders.length === 0) return;

    let folderId = this.clientProfileFolderService.getFolderIdByFolderName(folderName, this.caseFolders);

    if (!folderId) {
      this.auth_$.showLoader(`Creating missing ${folderName} folder...`);
      await this.firebase_utilities_$.createFolder(this.createFolderObject(folderName));
      this.auth_$.hideLoader();
      await this.refreshCaseFolders();
      return await this.getFolderIdByFolderName(folderName);
    }

    return Promise.resolve(folderId);
  }

  /**
   * Gets the folder id.
   * @param folderName the folder name.
   * @returns the folder id.
   */
  async getFolderId(folderName) {
    return this.getFolderIdByFolderName(folderName);
  }

  /**
   * Deletes the stores.
   * @param filesIDs the files ids.
   */
  async deleteStores(filesIDs) {
    this.clientDataStores = await this.uploadHelper_$.getDataStoresByClient(this.casename);
    if (!this.clientDataStores) return;

    const dicomStores = this.clientDataStores.map(urlname => {
      this.utils_$.viewerurlToDicomStore(
        `${environment.config.ohifViewerURL}${urlname.name}`,
        viewerUrlParts.dicomStore
      );
    });
    this.gapiOperations_$
      .deleteStoresByCaseName(this.casename, dicomStores)
      .then(result => {
        // DICOM Store deleted successfully
        return 200;
      })
      .catch(reason => {
        // TODO: #187 There is an error when try to delete all files from a client profile.
        console.error(`Error deleting : ${reason}`);
        return 0;
      });
  }

  /**
   * Gets the store name.
   * @param fileId the file id.
   * @returns the store name.
   */
  getStoreName(fileId): Promise<any> {
    return this.files_$.getFileByFileId(fileId).then(res => res.docs[0].data());
  }

  /**
   * Gets the stores from file ids list.
   * @param filesIDsToDelete the files ids to delete.
   * @returns the stores from file ids list.
   */
  getStoresFromFileIDsList(filesIDsToDelete) {
    const dataStores = [];
    filesIDsToDelete.forEach(file => dataStores.push(this.getStoreName(file.fileId)));
  }

  /**
   * Handles the folder click.
   * @param event the event.
   * @param folder the folder.
   */
  async handleFolderClick(event, folder) {
    event.stopPropagation();
    event.preventDefault();

    // Debug logging for folder click

    this.auth_$.showLoader(`Loading folder '${folder.name}' contents...`, 'loading-folder-contents');
    let index;

    if (folder.predefined === true && folder.folderId !== INDEX_FOLDER_NAME) {
      index = 0;
    } else if (folder.folderId === INDEX_FOLDER_NAME) {
      index = 1;
    } else {
      index = 3;
    }

    this.folderColor = localFolderColors[index];
    this.topMenuData.folderColor = this.folderColor;
    this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;
    if (false) {
      // Consultant folders are no longer supported
      // before browse folder contents, check if the folder has any shared files that are not shared with the active consultant.
      await this.browseConsultantFolderContents(folder);
    } else {
      await this.browseFolderContents(folder.folderId, folder.name);
    }

    // this.updateConsultantsLists();
    // this.updateFacilityAdminsLists();
    // this.updateFacilityConsultantsLists();

    // this.auth_$.hideLoader(); // FIXME: Avoid hide the DOWNLOAD DISC NOTIFICATION.
    this.auth_$.hideLoader('loading-folder-contents');
  }
  /**
   * Handles the folder click v2.
   * @param event the event.
   * @param element the element.
   */
  async handleFolderClickV2(event, element) {
    const { predefined, folderId, name } = element;
    this.auth_$.showLoader(`Loading folder '${name}' contents...`, 'loading-folder-contents');
    let index;

    if (predefined === true && folderId !== INDEX_FOLDER_NAME) index = 0;
    else if (folderId === INDEX_FOLDER_NAME) index = 1;
    else index = 3;

    this.folderColor = localFolderColors[index];
    this.topMenuData.folderColor = this.folderColor;
    this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;
    await this.browseFolderContentsV2(folderId, name);
    this.auth_$.hideLoader();
  }

  /**
   * Handles the file click.
   * @param event the event.
   * @param element the element.
   */
  handleFileClick(event, element) {
    event.stopPropagation();

    this.handleDeleteNewFileAndSharedFileNotifications(element);
    this.getRidOfNotesNotifications(element, [NotificationTypes.newfile, NotificationTypes.sharedfile]);

    if (element.ftype === UploadTypes.DICOMDisk) {
      this.handleStudyClick(element, event);
    } else {
      this.handleNoStudyFileClick(element);
    }
  }

  handleFileClickV2(p) {
    const { arg1 } = p;
    p['$event'].stopPropagation();

    this.handleDeleteNewFileAndSharedFileNotifications(arg1);
    this.getRidOfNotesNotifications(arg1, [NotificationTypes.newfile, NotificationTypes.sharedfile]);

    if (arg1.ftype === UploadTypes.DICOMDisk) {
      this.handleStudyClick(arg1, event);
    } else {
      this.handleNoStudyFileClick(arg1);
    }
  }

  /**
   * Handles the study click.
   * @param element the element.
   * @param event the event.
   */
  async handleStudyClick(element, event) {
    // Log the study browsing action.
    this.log_$.storeLog(
      this.auth_$.userData.getValue(),
      LogLevelsDictionary.info,
      { message: 'A study has been browsed.' },
      'BrowseStudy',
      this.casename
    );

    event.preventDefault();

    this.auth_$.showLoader('Opening the study viewer...');

    if (environment.config.viewerIndex === 0) {
      await this.preStudyViewAction(); // FIXME: WIP
    }

    this.auth_$.hideLoader();

    window.open(this.getViewerUrl(element.viewerurl), '_blank');

    // Remove notifications related to the file.
    this.handleDeleteNewFileAndSharedFileNotifications(element);
  }

  /**
   * Gets the viewer url.
   * @param viewerurl the viewer url.
   * @returns the viewer url.
   */
  private getViewerUrl(viewerurl: string): string {
    return `${environment.config.ohifViewerURL}${viewerurl.substr(viewerurl.indexOf('/projects'))}`;
  }

  /**
   * Pre-study view action.
   */
  private async preStudyViewAction() {
    const randomState = this.uploadHelper_$.getRandomString(20);
    const email = this.auth_$.userData.getValue()['email'];
    const result = (await this.updateUserStudyViewAction(randomState, email))['data'];
    const customToken = result['customToken'];
    const cookieValue = `${randomState}#${email}#${customToken}`;
    const cookieName = 'studyOpenedFromNuageDxApp';

    this.cookies_$.setCookie(cookieName, cookieValue, 1);
  }

  /**
   * Updates the user study view action.
   * @param randomState the random state.
   * @param email the email.
   * @returns the user study view action.
   */
  private updateUserStudyViewAction(randomState, email) {
    return firebase.functions().httpsCallable('user-updateUserStudyViewAction')({
      randomState,
      email
    });
  }

  /**
   * Handles the regular file click.
   * @param filePath the file path.
   * @param fileName the file name.
   */
  async handleRegularFileClick(filePath: string, fileName: string) {
    this.auth_$.showLoader('Opening the document viewer...', 'loading-document-viewer');
    await this.previewDocument(filePath, fileName);
    this.auth_$.hideLoader();
  }

  /**
   * Gets the file name extension.
   * @param fileName the file name.
   * @returns the file name extension.
   */
  private getFileNameExtension(fileName: string): string {
    return this.utils_$.getFileExtension(fileName);
  }

  /**
   * Handles the no study file click.
   * @param element the element.
   */
  async handleNoStudyFileClick(element: { fileId: string; fileName: string; storageBucket: string; filePath?: string }) {
    const { fileId, fileName } = element;
    const fileExtension = this.getFileNameExtension(fileName);

    // Show the loader.
    this.auth_$.showLoader('Getting the file path...');

    // Log the file browsing action.
    this.log_$.storeLog(
      this.auth_$.userData.getValue(),
      LogLevelsDictionary.info,
      { message: 'A file has been browsed.', filename: fileName },
      'BrowseFile',
      this.casename
    );

    let filePath: string;
    try {
      if (element.filePath) {
        filePath = element.filePath;
      } else {
        const result = await this.files_$.getFileByFileId(fileId);
        if (!result.docs.length) {
          this.auth_$.hideLoader();
          this.uiMessaging_$.toastMessage("File not found. Please delete it and re-upload.", 'ERROR');
          return;
        }
        filePath = result.docs[0].data().filePath;
      }
    } catch (err) {
      this.auth_$.hideLoader();
      this.uiMessaging_$.toastMessage("Could not load the file. Please try again.", 'ERROR');
      return;
    }

    if (notPlayableVideoExtensions.includes(fileExtension)) {
      this.handleVOBFileClick(filePath);
    } else if (ZIP_EXTENSIONS.includes(fileExtension)) {
      await this.handleZIPFileClick(filePath, element.storageBucket || '');
    } else {
      await this.handleSimpleFileClick(filePath, fileName);
    }

    // Update the access history - the updateAccessHistory method will handle the shared file logic internally
    this.firebase_utilities_$.updateAccessHistory(fileId, this.auth_$.userData.getValue()['email']);
  }

  /**
   * Handles the ZIP file click.
   * @param filePath the file path.
   * @param bucket the bucket.
   */
  private handleZIPFileClick(filePath: string, bucket?: string) {
    return this.handleDownloadFile(filePath, bucket);
  }

  /**
   * Gets the zipped file from DICOMDIR file id.
   * @param fileId the file id.
   * @returns the zipped file.
   */
  private async getZippedFileFromDICOMDIRFileId(fileId) {
    const fileData = await this.files_$.getZippedFileByDDICOMDIRFileId(fileId);
    return fileData;
  }

  /**
   * Handles the derived ZIP file click.
   * @param DICOMDIRFile the DICOMDIR file.
   */
  private async handleDerivedZIPFileClick(DICOMDIRFile) {
    const zippedFile = await this.getZippedFileFromDICOMDIRFileId(DICOMDIRFile.fileId).catch(err => {
      console.error(err);
      return null;
    });
    return this.handleDownloadFile(zippedFile.filePath, `${environment.config.projectId}.appspot.com`);
    // return this.handleDownloadFile(zippedFile.filePath, 'testing-bucket-001-spideep');
  }

  private async handleSimpleFileClick(filePath: string, fileName: string) {
    // Validate file metadata.
    if (!(await this.validateFileMeta(filePath))) {
      // File metadata is not valid
    } else {
      this.handleRegularFileClick(filePath, fileName);
    }
  }

  /**
   * Handles the VOB file click.
   * @param filePath the file path.
   */
  async handleVOBFileClick(filePath) {
    const { VOBInfoWindowComponent } = await import('./../vob-info-window/vob-info-window.component');
    const dialogRef = this.dialog_$.open(VOBInfoWindowComponent, { height: 'auto', width: 'auto' });
    firstValueFrom(dialogRef
      .afterClosed())
      .then(async res => {
        if (res === 'download') await this.handleDownloadFile(filePath, '');
        else if (res === 'getConvertAndExport') this.handleConvertAndExport(firebase.storage().ref(), filePath);
      });
  }

  /**
   * Handles the download file.
   * @param filePath the file path.
   * @param storageBucket the storage bucket.
   */
  private handleDownloadFile(filePath, storageBucket) {
    this.auth_$.showLoader('Downloading the file...');
    const afterGetSignedURL = result => {
      this.auth_$.hideLoader();
      window.open(result.data.url, '_blank');
    };
    return firebase
      .functions()
      .httpsCallable('firebaseUtilities-fileGetSignedURLV2')({ filePath, storageBucket })
      .then(result => afterGetSignedURL(result))
      .catch(err => this.handleError(err));
  }

  /**
   * Handles the convert and export.
   * @param pathReference the path reference.
   * @param filePath the file path.
   */
  private handleConvertAndExport(pathReference, filePath) {
    pathReference
      .child(filePath)
      .getDownloadURL()
      .then(targetURL => {
        firebase.functions().httpsCallable('cloudconvert-getConvertAndExport')({ url: targetURL });
      });
  }

  handleSelect(value) {
    const type = this.sortTypes[value];
    this.setSort(type.value, type.direction);
  }

  async handleDeleteAllFiles() {
    /**
     * NOTE: The reason of these duplicated calls using caseName and LegalCaseId is to prevent
     * those records with these values.This is only for old records, new ones should use
     * caseName only.
     */
    const filesToDelete = this.selection.selected.map(({ fileId, sharedUsers }) => ({
      fileId,
      sharedUsers
    }));
    const filesIDs = filesToDelete.map(file => file.fileId);
    const promises = [];
    promises.push(this.firebase_utilities_$.deleteFilesByIds(filesIDs));

    // NOTE: Remove shared users references to the files.
    filesToDelete.forEach(({ sharedUsers, fileId }) => {
      if (sharedUsers) {
        const shareUserEmail = sharedUsers
          .filter(user => user && user.email) // Filter out null/undefined users and users without email
          .map(user => user.email.toLowerCase());
        if (shareUserEmail.length > 0) {
          promises.push(this.firebase_utilities_$.removeFilesByIdsFromUser(fileId, shareUserEmail));
        }
      }
    });

    // Delete all notifications related to the files.
    this.handleDeleteAllFilesNotifications(filesIDs);

    return Promise.all(promises);
  }

  async handleDeleteAllStores() {
    this.clientDataStores = await this.uploadHelper_$.getDataStoresByClient(this.casename);
    if (!this.clientDataStores) {
      return;
    }
    const dicomStores = this.clientDataStores.map(urlname =>
      this.utils_$.viewerurlToDicomStore(
        `${environment.config.ohifViewerURL}${urlname.name}`,
        viewerUrlParts.dicomStore
      )
    );
    return this.gapiOperations_$
      .deleteStoresByCaseName(this.casename, dicomStores)
      .then(result => {
        return 200;
      })
      .catch(reason => {
        // TODO: #187 There is an error when try to delete all files from a client profile.
        console.error(`Error deleting : ${reason}`);
        return 0;
      });
  }

  handleCheckboxClick(ev: { preventDefault: () => void }) {
    ev.preventDefault();
  }


  /**
   * handleRowClick happens when user clicks on a single row of the DataTable.
   */
  handleRowClick(element, event, options?) {
    this.cleanHighlighted();
    this.showSharedConsultantsByFile({});

    const { currentFolder } = options;
    if (currentFolder === '') {
      return;
    }
    event.stopPropagation();
    this.selection.toggle(element);
    this.auth_$.clientProfileSelectedFiles = this.selection.selected;

    if (this.selection.selected.length > 0) {
      const sharedUsers = this.selection.selected[0].sharedUsers;

      this.activeConsultants = this.addSharedFlags(this.activeConsultants, sharedUsers);
      this.availableConsultants = this.addSharedFlags(this.availableConsultants, sharedUsers);

      this.activeFacilitiesUsers = this.addSharedFlags(this.activeFacilitiesUsers, sharedUsers);
      this.availableFacilitiesUsers = this.addSharedFlags(this.availableFacilitiesUsers, sharedUsers);

      this.viewNotesButton =
        this.selection.selected.length === 1
          ? this.selection.selected[0].notes && this.selection.selected[0].notes.length > 0
          : false;
    } else if (this.selection.selected.length === 0) {
      this.viewNotesButton = false;

      this.activeConsultants = this.clearSharedFlags(this.activeConsultants);
      this.availableConsultants = this.clearSharedFlags(this.availableConsultants);

      this.activeFacilitiesUsers = this.clearSharedFlags(this.activeFacilitiesUsers);
      this.availableFacilitiesUsers = this.clearSharedFlags(this.availableFacilitiesUsers);
    }
  }

  handleBreadcrumbClick(parentFolderId) {
    const folderName =
      parentFolderId === INDEX_FOLDER_NAME
        ? this.indexFolderNameCounter
        : this.getFolderName(this.caseFolders, parentFolderId);
    this.showLoadingMessage(folderName);
    this.loadPatientFiles(parentFolderId, folderName).then(() => {
      this.resetSelection();
      this.auth_$.hideLoader('loading-folder-contents');
    });
  }

  showLoadingMessage(folderName: string) {
    const displayFolderName = folderName === '' ? 'Home' : folderName;
    const loadingMessage = `Loading ${displayFolderName} folder contents...`;
    this.auth_$.showLoader(loadingMessage, 'loading-folder-contents');
  }

  private resetSelection() {
    // TODO: Get rid of this portion since there is no need for activeConsultant
    // this.activeConsultant = null;
    this.selection.clear();
    // FIXME: Avoid to hide the GENERATE DISC NOTIFICATION.
    this.auth_$.hideLoader('loading-folder-contents');

    // Update the selected files accordion when clearing the active consultant
    this.updateSelectedFilesAccordion();
  }

  private loadPatientFiles(event, folderName) {
    return this.getFilesForPatient(event, {
      folderName: folderName,
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient,
      user: this.user,
      caseFolders: this.caseFolders
    });
  }

  isAllSelected() {
    return this.selection.selected.length === this.files.length;
  }


  /**
   * Check/UnCheck all rows in the dataTable.
   */
  masterToggle() {
    const event = document.createEvent('HTMLEvents');
    // tslint:disable-next-line: deprecation
    event.initEvent('click', true, false);
    this.isAllSelected()
      ? this.files
        .filter(row => this.checkIfSelected(row))
        .forEach(row => this.handleRowClick(row, event, { currentFolder: this.currentFolder }))
      : this.files
        .filter(row => !this.checkIfSelected(row))
        .forEach(row => this.handleRowClick(row, event, { currentFolder: this.currentFolder }));
  }

  async moveSelectedTo(folderId: string) {
    return this.firebase_utilities_$.moveFilesTo(this.selection.selected, folderId);
  }

  checkDuplicatedFolder(folderName: string, parentFolder?: any): boolean {
    return this.clientProfileFolderService.checkDuplicatedFolder(folderName, parentFolder, this.caseFolders);
  }

  addFolderToParentInStructure(structure: any, parentId: string, newFolder: any): boolean {
    if (structure.id === parentId) {
      if (!structure.children) {
        structure.children = [];
      }
      structure.children.push(newFolder);
      return true;
    }

    if (structure.children) {
      for (let child of structure.children) {
        if (this.addFolderToParentInStructure(child, parentId, newFolder)) {
          return true;
        }
      }
    }

    return false;
  }

  removeFolderFromStructure(structure: any, folderId: string): boolean {
    if (structure.children) {
      const index = structure.children.findIndex(child => child.id === folderId);
      if (index !== -1) {
        structure.children.splice(index, 1);
        return true;
      }

      for (let child of structure.children) {
        if (this.removeFolderFromStructure(child, folderId)) {
          return true;
        }
      }
    }

    return false;
  }

  async createFolder(currentFolder = null, options = {}) {
    const { NewFolderComponent } = await import('../new-folder/new-folder.component');
    this.dialog_$
      .open(NewFolderComponent, {
        data: {
          availableFolders: this.homeFoldersAccordion?.accordionFolders || [],
          parentFolder: currentFolder,
          hideParentFolderSelection: true
        }
      })
      .afterClosed()
      .subscribe(async result => {
        if (!result?.folderName) return;

        const { folderName, parentFolder } = result;

        if (this.checkDuplicatedFolder(folderName, parentFolder)) {
          this.uiMessaging_$.toastMessage(`Folder name ${folderName} is already taken in this location`, '');
          return;
        }

        const folderId = this.uploadHelper_$.getRandomString(20);
        const newFolder = {
          name: folderName.trim(),
          color: folderColors.custom,
          parentFolder: parentFolder?.id || '',
          parentId: parentFolder?.id ?? null,
          ownerID: this.userOwnerID,
          type: 'folder',
          belongsTo: this.casename,
          predefined: false,
          forDelete: false,
          folderId,
          children: ''
        };

        this.auth_$.showLoader('Creating folder...');
        await this.firebase_utilities_$.createFolder(newFolder);
        this.caseFolders.push(newFolder);

        // NOTE: Why don't we get fresh data from the database to populate the accordion data service?
        this.accordionDataService.addFolder({
          id: newFolder.folderId,
          ownerID: newFolder.ownerID,
          name: newFolder.name,
          color: newFolder.color,
          type: newFolder.type,
          expanded: false,
          loading: false,
          parentId: newFolder.parentId,
          level: parentFolder ? (parentFolder.level || 0) + 1 : 0,
          children: [],
          count: '0'
        });

        // NOTE: If we are using the foldersStructure, we need to update it with the new folder.
        if (this.foldersStructure?.children) {
          const child = { name: newFolder.name, id: folderId, children: [] };
          parentFolder
            ? this.addFolderToParentInStructure(this.foldersStructure, parentFolder.id, child)
            : this.foldersStructure.children.push(child);
        }

        // NOTE: We need to get the files for the patient to update the files accordion.
        this.getFilesForPatient(currentFolder || this.currentFolder, {
          ...options,
          caseFolders: this.caseFolders,
          roleConsultant: this.userIsConsultant,
          roleClient: this.userIsClient
        }).then(async () => {
          // Refresh accordion folders to ensure the new folder appears in the UI
          await this.refreshAccordionFolders();
          this.auth_$.hideLoader();
        });
      });
  }

  /**
   * Handle create subfolder event from the accordion component
   * @param event - Event containing the folder where the subfolder should be created
   */
  handleCreateSubfolder(event: { folder: any; event: Event }) {
    const { folder } = event;

    // Use the existing createFolder method with the clicked folder as the parent
    this.createFolder(folder, {
      folderName: folder.name,
      isSubfolder: true
    });
  }

  /**
   * Handle create subfolder event from the accordion component
   * @param event - Event containing the folder where the subfolder should be created
   */
  handleCreateFacilitatorSubfolder(event) {
    const { folder } = event;

    // Use the existing createFolder method with the clicked folder as the parent
    this.createFolder(folder, {
      folderName: folder.name,
      isSubfolder: true
    });
  }

  async addNote(noteFile: NoteFile, { attachments, name, description, useremail, noteId, visibility }: NoteObject) {
    const attachmentLists = await this.getAttachmentLists(attachments);
    const newAttachments = attachmentLists ? [].concat(attachmentLists) : [];
    noteFile.notes = noteFile.notes || [];
    const noteObject = this.generateNoteObject(
      name,
      description,
      useremail,
      newAttachments,
      noteFile,
      noteId,
      visibility
    );

    noteFile.notes.push(noteObject);

    await this.updateNote(noteFile.id, noteFile.notes);

    return {
      docId: noteFile.id,
      id: noteFile.fileId,
      type: noteFile.type,
      parentFolder: noteFile.parentFolder,
      noteId: noteObject.noteId
    };
  }

  updateNote(noteFileId, noteFileNotes) {
    return this.files_$
      .updateFileByDocId(noteFileId, { notes: noteFileNotes })
      .then(() => {
        this.uiMessaging_$.toastMessage('Notes Added Successfully', null);
        return 'Note Added Successfully';
      })
      .catch(error => {
        this.uiMessaging_$.toastMessage(error.message, null);
        return error.message;
      });
  }

  generateNoteObject(name, description, useremail, newAttachments, noteFile, noteId, visibility) {
    return {
      title: name,
      note: description,
      createdBy: useremail,
      attachments: newAttachments.concat(noteFile.attachments || []),
      noteId: noteId || this.generateNoteId(),
      visibility: visibility || { consultants: true, clients: true },
      datetime: new Date().toISOString(),
      fileId: noteFile.fileId,
      authorName: this.auth_$.userData.getValue()['userName']
    };
  }

  onRightClick(event: MouseEvent, item) {
    event.preventDefault();
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    this.matMenuTrigger.menuData = { item: item };
    this.matMenuTrigger.openMenu();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  handleWindowTitleClose(): void {
    this.dialogRef.close();
    this.router.navigateByUrl('/');
  }

  onlySharedFolders(folder) {
    const isSharedWithConsultant = (sharedUsers: any[], consultantEmail: string) => {
      if (typeof sharedUsers === 'undefined' || !sharedUsers.length) {
        return;
      } else {
        return sharedUsers.some(
          user => user && user.email && user.email.toLowerCase() === consultantEmail.toLowerCase()
        );
      }
    };

    return isSharedWithConsultant(folder.data().sharedUsers, this.user.email.toLowerCase());
  }

  async openDialog(options?) {
    const buildDialogConfig = options => {
      const action_params = {
        files: '',
        type: '',
        desc: '',
        caseName: this.casename,
        creator: this.uid
      };
      const currentFolder = { folderId: this.currentFolder, folderName: this.currentFolderName };
      this.topMenuData.currentFolder = this.currentFolder;
      this.topMenuData.currentFolderName = this.currentFolderName;
      this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;
      const dialogConfigData = {
        id: 1,
        section: options.type ? false : options.section || null,
        title: options && options.section === 'upload_dicom_disk' ? 'Upload Medical Images' : 'Upload files and discs',
        currentFolder: currentFolder,
        uploadTypes: this.uploadTypes,
        ftime: this.ftime,
        fdate: this.fdate,
        basicfile: this.files,
        description: this.fdesc,
        type: this.ftype,
        clientName: this.patientName,
        action_params: action_params,
        ownerPlanCode: this.ownerPlanCode,
        ownerID: this.ownerID,
        userOwnerID: this.userOwnerID
      };
      const dialogConfig = new MatDialogConfig();
      this.dialog_$.dialog.openDialogs.pop();

      dialogConfig.width = '700px';
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.maxHeight = '70vw';
      dialogConfig.data = dialogConfigData;

      return dialogConfig;
    };

    this.dialog_$.dialog.openDialogs.pop();
    const { UploadDialogComponent } = await import('../ui/uploaddialog/uploaddialog.component');
    const dialogRef = this.dialog.open(UploadDialogComponent, buildDialogConfig(options));
    // const dialogRef = this.dialog_$.open(UploadDialogComponent, buildDialogConfig(options));

    const afterClosedSub = dialogRef.afterClosed().subscribe(async (result) => {
      afterClosedSub.unsubscribe();
      if (result !== 'refresh') {
        return;
      }
      this.loading = true;
      this.loadingMessage = 'This list is getting updated, please wait.';
      try {
        // Capture expanded folders before invalidating so we can reload them immediately
        const expandedFolderIds = this.accordionDataService.getFlatFolderList()
          .filter(f => f.expanded)
          .map(f => f.id);
        // Reset all folder file caches so the next expand fetches fresh data from Firestore
        this.accordionDataService.invalidateFiles();
        this.caseFolders = await this.firebase_utilities_$.getFolders(this.casename, {
          ownerID: this.userOwnerID,
          userOwnerID: this.userOwnerID
        });
        await this.getFilesForPatient(this.currentFolder, {
          folderName: this.currentFolderName,
          caseFolders: this.caseFolders,
          roleConsultant: this.userIsConsultant,
          roleClient: this.userIsClient
        });
        await this.refreshAccordionFolders();
        // Eagerly reload any folders that were expanded so the new file appears immediately
        await Promise.all(expandedFolderIds.map(id => this.handleLoadFolderContents(id)));
      } finally {
        this.loading = false;
      }
    });

    firstValueFrom(dialogRef.keydownEvents().pipe(defaultIfEmpty(null as KeyboardEvent)))
      .then(e => {
        if (!e) {
          return;
        }
        if (e.key === 'Escape') {
          e.preventDefault();
          dialogRef.close();
        }
      });
  }

  async openShareFilesDialog(restoreState?: any) {
    // Check if there are any files to share
    if (!this.allFiles || this.allFiles.length === 0) {
      this.uiMessaging_$.toastMessage(
        'No files have been uploaded yet. Please upload at least one file before sharing.',
        'WARNING',
        { duration: 5000 }
      );
      return;
    }

    // Ensure consultant data is loaded before opening the dialog
    if (!this.originalUsersData?.availableConsultants?.length && !this.originalUsersData?.activeConsultants?.length) {
      await this.updateFacilitiesConsultantsLists();
    }

    const dialogConfig = new MatDialogConfig();

    // Create INDEX folder with proper count
    const indexFolder = {
      folderId: 'all',
      name: 'INDEX',
      count: this.allFiles?.length || 0
    };

    // Prepare real data for the Share Files dialog
    const dialogData = {
      patient: this.patient,
      allFiles: this.allFiles || [],
      files: this.files || [],
      caseFolders: [indexFolder, ...(this.caseFolders || [])], // Include INDEX folder at the beginning
      facilities: this.isSpoke
        ? this.facilities.filter(facility => this.auth_$.userData.getValue()['hubs'].includes(facility.id)) // NOTE: The sharing process from a HUB to a SPOKE must add the HUB name to the userData['hubs'] array.
        : this.facilities || [],
      users: {
        activeConsultants: this.originalUsersData?.activeConsultants || this.activeConsultants || [],
        activeFacilitiesUsers: this.activeFacilitiesUsers || [],
        availableFacilitiesUsers: this.availableFacilitiesUsers || [],
        availableConsultants: this.originalUsersData?.availableConsultants || this.availableConsultants || []
      }
    };

    // Add restore state if provided
    if (restoreState) {
      dialogData['restoreState'] = restoreState;
    }

    dialogConfig.width = '1000px';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = dialogData;
    const component = this.isSpoke
      ? (await import('../share-files-spoke/share-files-spoke.component')).ShareFilesSpokeComponent
      : (await import('../share-files/share-files.component')).ShareFilesComponent;
    firstValueFrom(this.dialog
      .open(component as any, dialogConfig)
      .afterClosed())
      .then(async (sharingObject: ShareFilesDialogResult) => this.handleSharing(sharingObject));
  }

  sendNotification(targetEmail: string, extraMessage: string | null, files: any[], casename: string) {
    this.clientProfileSharingService.sendNotification(targetEmail, extraMessage, files, casename);
  }

  async handleSharing(shareObject: ShareFilesDialogResult) {
    if (!shareObject) {
      console.error('NO RESULT FROM SHARE FILES DIALOG', shareObject);
      return;
    }

    // Special case: refresh and reopen dialog
    if ((shareObject as any).action === 'refreshAndReopen') {
      await this.updateFacilitiesConsultantsLists();
      await new Promise(resolve => setTimeout(resolve, 500));
      this.openShareFilesDialog((shareObject as any).currentState);
      return;
    }

    // Share with facility facilitators (admin) or consultant
    if (this.clientProfileSharingService.shouldShareWithFacilityFacilitators(shareObject)) {
      await this.handleShareWithFacilityFacilitators(shareObject);
    } else {
      await this.handleShareWithConsultant(shareObject);
    }

    // Send email notification to shared user
    this.sendNotification(
      shareObject.user?.email,
      (shareObject as any).message || null,
      shareObject.files,
      shareObject.patient?.caseName
    );

    // Optional copy notification to sharer
    if ((shareObject as any).sendCopy) {
      this.sendNotification(
        this.user.email,
        'This is a copy of the notification sent to the user.',
        shareObject.files,
        shareObject.patient?.caseName
      );
    }

    // Show snackbar notification
    const facilityName = shareObject.facility?.name || 'Unknown Facility';
    // Prefer user name for consultant if available, fallback to admin/facilitators list or generic
    const consultantName =
      shareObject.user?.role === UserRoles.admin
        ? facilityName + ' facilitators'
        : shareObject.user?.name || 'Unknown Consultant';
    const fileCount = shareObject.files.length;

    this.snackBar.open(`Successfully shared ${fileCount} file(s) with ${consultantName} at ${facilityName}`, 'Close', {
      duration: 3000
    });
  }

  async handleShareWithConsultant(shareObject: ShareFilesDialogResult) {
    await this.clientProfileSharingService.handleShareWithConsultant(
      shareObject,
      this.casename,
      this.auth_$.userData.getValue()['email']
    );
  }

  async handleShareWithFacilityFacilitators(shareObject: ShareFilesDialogResult) {
    await this.clientProfileSharingService.handleShareWithFacilityFacilitators(
      shareObject,
      this.userOwnerID,
      this.auth_$.userData.getValue()['email'],
      this.auth_$.userData.getValue()['facility']
    );
  }

  async getAllFacilityConsultants(
    facilityId: string
  ): Promise<{ name: string; email: string; role: string; id: string; uid: string }[]> {
    return this.firebase_utilities_$.getFacilitatorsByFacilityId(facilityId);
  }

  async openDeleteConfirmDialog() {
    const dialogConfig = new MatDialogConfig();
    const plural = this.selection.selected.length > 1 ? `s` : ``;
    const condition = this.selection.selected.length === this.filesTableDataSource.data.length;

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = this.getDeleteConfirmDialogConfigData(plural, condition);

    const { ConfirmationDialogComponent } = await import('../ui/confirmation-dialog/confirmation-dialog.component');
    firstValueFrom(this.dialog_$
      .open(ConfirmationDialogComponent, dialogConfig)
      .afterClosed())
      .then(async result => {
        if (!result) return;

        // Store the files to be deleted
        const filesToDelete = this.selection.selected;

        if (!result.deleteAllFiles) {
          // Delete individual files (accordion removal is handled in deleteFiles method)
          this.deleteFiles(filesToDelete);
        } else if (result.selectedFiles === null) {
          // Delete all files
          const deletionResult = await Promise.all([this.handleDeleteAllStores(), this.handleDeleteAllFiles()]);
          console.log('deletionResult :', deletionResult);

          // Clear all files from accordion after successful deletion
          this.clearAllFilesFromAccordion();
        } else console.log('log val', result);

        const options = {
          folderName: this.currentFolderName,
          caseFolders: this.caseFolders,
          roleConsultant: this.userIsConsultant,
          roleClient: this.userIsClient
        };

        // Refresh the main DataTable
        await this.getFilesForPatient(this.currentFolder, options);

        // Also refresh the accordion to keep it in sync
        await this.refreshAccordionAfterOperation();

        this.selection.clear();
      });
  }

  async openInfoDialog() {
    const { InfoWindowComponent } = await import('../info-window/info-window.component');
    firstValueFrom(this.dialog_$
      .open(InfoWindowComponent, { height: 'auto', width: 'auto' })
      .afterClosed())
      .then(() => this.openDialog());
  }

  open() {
    this.picker.open();
  }

  async openAddNoteDialog() {
    const selectedFile = this.selection.selected[0];
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '400px';
    dialogConfig.data = {
      title: 'Add Comments and/or Attachments',
      selected_file: selectedFile,
      useremail: this.user.email,
      userRole: this.realRole,
      name: '',
      description: '',
      visibility: { consultants: true, clients: true }
    };

    const { NoteDialogComponent } = await import('../ui/note-dialog/note-dialog.component');
    firstValueFrom(this.dialog_$
      .open(NoteDialogComponent, dialogConfig)
      .afterClosed())
      .then(result => {
        if (result?.type === 'notesave') this.noteDialogComponentCloseHandler(result);
      });
  }

  private noteDialogComponentCloseHandler(result) {
    // this.addNote(result.selected_file, result.data).then(({ docId, id, type, parentFolder, noteId }) =>
    //   this.afterAddNote({ fileDocId: docId, id, type, parentFolder, noteId }),
    // );
    this.fileCommentsAttachments_$
      .addCommentsAndAttachments(
        result.selected_file,
        result.data,
        this.patientName,
        this.auth_$.userData.getValue()['userName']
      )
      .then(({ docId, id, type, parentFolder, noteId }) =>
        this.afterAddNote({ fileDocId: docId, id, type, parentFolder, noteId })
      );
  }

  /**
   * Creates a id string with 10 random characters.
   *
   * @private
   * @return {*}
   * @memberof ClientProfileComponent
   */
  private generateNoteId() {
    return this.utils_$.getRandomString_(10);
  }

  async openCommentsAndAttachments(fileClicked) {
    let width: string, height: string, maxWidth: string, maxHeight: string;
    if (fileClicked.ftype === 'DICOM Disk (medical images)') {
      width = '95vw';
      height = '95vh';
      maxWidth = '95vw';
      maxHeight = '95vh';
    } else {
      width = '85vw';
      height = '80vh';
      maxWidth = '85vw';
      maxHeight = '95vh';
    }
    const dialogConfig = this.createDialogConfig({
      width,
      height,
      maxWidth,
      maxHeight,
      autoFocus: true,
      data: await this.populateAllNotesDialogData(fileClicked),
      disableClose: false
    });

    const { AllNotesDialogComponent } = await import('../ui/all-notes-dialog/all-notes-dialog.component');
    const dialog = this.dialog_$.open(AllNotesDialogComponent, dialogConfig);
    firstValueFrom(dialog
      .afterClosed())
      .then(val => this.allNotesCloseHandler({ fileId: dialogConfig.data.fileid }));
  }

  /**
   * Show all notes of a selected file.
   *
   * @memberof ClientProfileComponent
   */
  async openAllNotes(fileClicked) {
    const dialogConfig = this.createDialogConfig({
      width: '85vw',
      height: '80vh',
      maxWidth: '85vw',
      maxHeight: '95vh',
      autoFocus: true,
      data: await this.populateAllNotesDialogData(fileClicked),
      disableClose: false
    });

    const { AllNotesDialogComponent } = await import('../ui/all-notes-dialog/all-notes-dialog.component');
    firstValueFrom(this.dialog_$
      .open(AllNotesDialogComponent, dialogConfig)
      .afterClosed())
      .then(val => this.allNotesCloseHandler({ fileId: dialogConfig.data.fileid }));
  }
  async openFileSearch() {
    const dialogConfig = new MatDialogConfig();
    this.dialog_$.dialog.openDialogs.pop();
    dialogConfig.width = '400px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.maxHeight = '80vw';
    dialogConfig.data = this.getSeachFilesComponentData();

    const { SearchFilesComponent } = await import('../search-files/search-files.component');
    const dialogRef = this.dialog.open(SearchFilesComponent, dialogConfig);
    // const dialogRef = this.dialog_$.open(SearchFilesComponent, dialogConfig);
    const subs = dialogRef.componentInstance.updateResultsEvent.subscribe((searchQuery: string) => {
      this.searchQuery = searchQuery;
      this.fetchAlgoliaSearchResults(true);
    });

    firstValueFrom(dialogRef
      .keydownEvents())
      .then(e => {
        if (!e) return false;
        if (e.key === 'Escape') {
          e.preventDefault();
          dialogRef.close();
        }
      });

    firstValueFrom(dialogRef
      .afterClosed())
      .then(result => {
        console.log('result :', result);
        return subs.unsubscribe();
      });
  }

  async renameElement(element, event) {
    event.stopPropagation();
    if (element) this.selection.selected[0] = element;

    const selectedFile = this.selection.selected[0];
    const dialogConfig = new MatDialogConfig();

    let dialogData = {};

    if (element.type === 'folder') {
      dialogData = {
        title: 'Edit folder',
        name: selectedFile.fileName,
        type: element.type,
        label: 'Folder name'
      };
    } else {
      const newDateParts = selectedFile.fdate.split('/');

      dialogData = {
        title: 'Edit file',
        label: 'File name',
        message: `Please add a note here:`,
        confirm_action: this.addNote,
        selected_file: selectedFile,
        useremail: this.user.email,
        name: selectedFile.fileName,
        desc: selectedFile.fileDesc,
        date: new Date(newDateParts[2], parseInt(newDateParts[0], 10) - 1, newDateParts[1]),
        description: ''
      };
    }

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data = dialogData;

    const { EditFileDialogComponent } = await import('../edit-file-dialog/edit-file-dialog.component');
    const dialogRef = this.dialog_$.open(EditFileDialogComponent, dialogConfig);

    firstValueFrom(dialogRef
      .afterClosed())
      .then(data => (data ? this.updateFile(data, selectedFile) : null));
  }

  /**
   * Update linked users with the selected file if they are unlinked. "Unlinked"
   * means the file is shared with a consultant but the consultant has no
   * registry of this.
   * @param unLinked is the array of email addresses unlinked with the file.
   * @param file selected.
   */
  async repairUnLinkedUsers(unLinked: string[], notFound, file): Promise<void> {
    if (!unLinked.length) return;
    return this.users_$.getUsersByEmailsArray(unLinked).then(sp => {
      if (!sp.docs.length) {
        return;
      }
      sp.docs.forEach(doc =>
        this.users_$.updateUserByDocId(doc.id, {
          filesSharedWith: firebase.firestore.FieldValue.arrayUnion({
            fileId: file.fileId,
            patientCaseName: this.casename,
            ownerID: this.ownerID
          })
        })
      );
      this.uiMessaging_$.toastMessage(
        'There were some consultants unlinked with your shared file, those have been repaired',
        'IMPORTANT'
      );
    });
  }

  /**
   * Removes the link of the selected file with users than are deleted
   * or removed from firestore.
   * @param notExistent the array of emails.
   * @param file to be requested.
   */
  async repairNonExistent(notExistent, file): Promise<void> {
    if (!notExistent.length) return;
    const sharedUsers = (await this.files_$.getFileByFileId(file.fileId)).docs[0].data()['sharedUsers'];

    for (let index = 0; index < notExistent.length; index++) {
      const uemail = notExistent[index].toLowerCase();
      const fileDBId = (await this.files_$.getFileByFileId(file.fileId)).docs[0].id;
      this.files_$.updateFileByDocId(fileDBId, {
        sharedUsers: sharedUsers.filter(user => user && user.email && user.email.toLowerCase() !== uemail.toLowerCase())
      });
    }
  }

  setPageSize(objectsCount: number = 0) {
    for (let index = 0; index < this.pageSizes.length; index++) {
      const element = this.pageSizes[index];
      if (element >= objectsCount) {
        this.pageSize = element;
        break;
      }
    }
    if (objectsCount > this.pageSizes[this.pageSizes.length]) this.pageSize = this.pageSizes[this.pageSizes.length];
    this.pagesLength = Math.ceil(objectsCount / this.pageSize);
  }

  async setPermissions() {
    this.loadingPermissions = true;
    const prefix = 'permissions_';
    let permissionsArr;
    if (
      this.auth_$.getPermissions('clientprofile_permissions') &&
      JSON.parse(this.auth_$.getPermissions('clientprofile_permissions')).length === permissionsNeeded.length
    ) {
      permissionsArr = JSON.parse(this.auth_$.getPermissions('clientprofile_permissions'));
    } else {
      const permissions = await this.validateRoleMulti(permissionsNeeded);
      permissionsArr = permissions.map(item => ({
        name: prefix + item.object,
        value: item.access
      }));
      this.auth_$.setPermissions(permissionsArr);
    }
    permissionsArr.forEach(item => (this[item.name] = item.value));
    this.loadingPermissions = false;
  }

  async setFileForDelete(file) {
    const fileId = (await this.files_$.getFileByFileId(file.fileId)).docs[0].id;
    this.files_$.updateFileByDocId(fileId, { forDelete: true });
  }

  async selectTarget(type) {
    this.caseFolders = await this.firebase_utilities_$.getFolders(this.casename, {
      ownerID: this.userOwnerID,
      userOwnerID: this.userOwnerID
    });
    const treeData = this.caseFolders
      .map(({ name, color, folderId }) => ({ name, id: folderId, color, children: [] }))
      .sort((a, b) => a.name.localeCompare(b.name));

    const dialogConfig = new MatDialogConfig();
    this.dialog_$.dialog.openDialogs.pop();
    dialogConfig.minWidth = '350px';
    dialogConfig.autoFocus = true;
    dialogConfig.data = treeData;

    const { FolderSelectorComponent } = await import('./../ui/folder-selector/folder-selector.component');
    const dialogRef = this.dialog_$.open(FolderSelectorComponent, dialogConfig);

    firstValueFrom(dialogRef
      .keydownEvents())
      .then(e => {
        if (!e) return;

        if (e.key === 'Escape') {
          e.preventDefault();
          dialogRef.close();
        }
      });

    dialogRef.afterClosed().subscribe(async folderId => {
      // NOTE: Targeting the root is not allowed.
      if (folderId === '') return;

      switch (type) {
        case FileActionsDictionary.COPY:
          // NOTE: Run copy action.
          await this.copySelectedTo(folderId);
          break;
        case FileActionsDictionary.MOVE:
          // NOTE: Run move action.
          await this.moveSelectedTo(folderId);
          break;
        default:
          break;
      }

      this.browseFolderContents(folderId, this.getFolderName(this.caseFolders, folderId));

      // NOTE: Refresh ActiveConsultants:
      if (!this.userIsConsultant) {
        // this.updateConsultantsLists();
        // this.updateFacilityAdminsLists();
        // this.updateFacilityConsultantsLists();
      }
    });
  }

  /**
   * Sets the paging for the files.
   * Updates the variables:
   * - filesTableDataSource
   * - currentFolder
   * - currentFolderName
   * - pageSize
   * @param files the files to be set.
   * @param folderId the folder id.
   * @param folderName the folder name.
   */
  setPaging(files: any[], folderId: string, folderName: string) {
    this.files = files.map(file => ({ ...file, name: file.fileName })); // Files with name.
    this.files_$.addPatientFiles(this.files);
    const isHome = folderId === this.homeFolderName;

    if (isHome) {
      this.filesTableDataSource = new MatTableDataSource(this.files);
      // this.filesTableDataSource = new MatTableDataSource(this.sortingIndexFolders(this.files));
    } else {
      this.filesTableDataSource = new MatTableDataSource(this.files.slice());
      this.updateDataTable();
    }

    this.currentFolder = folderId;
    this.currentFolderName = folderName || this.homeFolderName;

    this.topMenuData.currentFolder = this.currentFolder;
    this.topMenuData.currentFolderName = this.currentFolderName;
    this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;
    const count = this.currentFolder === this.homeFolderName ? this.files.length + 1 : this.files.length;
    this.setPageSize(count);
  }

  /**
   * Use sort function by specific criteria.
   */
  setSort(criteria: string, direction) {
    if (!this.sort) return;
    this.sort.sort({ id: null, start: direction, disableClear: false });
    this.sort.sort({ id: criteria, start: direction, disableClear: false });
    this.updatePaginator();
  }

  async showInfectedFiles(files) {
    const { SimpleMessageWindowComponent } = await import('../ui/simple-message-window/simple-message-window.component');
    this.dialog_$
      .open(SimpleMessageWindowComponent, {
        width: '550px',
        disableClose: true,
        data: {
          title: 'Malicious File Detected',
          message: 'The following files are infected and has been deleted:',
          list: files.map(n => ({ name: n })),
          buttons: [{ text: 'CLOSE AND REFRESH', value: 'refresh' }]
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result === 'refresh') this.goRefresh(null);
      });
  }

  showSharedConsultantsByFile(file) {
    if (Object.keys(file).length === 0) {
      return this.sharing_files_$.pickedFile.next(file);
    }

    if (!this.activeConsultants) {
      return;
    }

    const scEmails = this.activeConsultants.map(c => c.email);

    if (scEmails.length) {
      this.getMissingSharedFiles(file);
    }

    this.pickedSharedFile = file;
    this.sharing_files_$.pickedFile.next(this.pickedSharedFile);
  }

  getSortedData(data, sort) {
    return data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'isShared':
          return this.compare(a.isShared, b.isShared, false);
        case 'fdate':
          return this.compareDates(
            a.ftime ? a.fdate + ' ' + a.ftime : a.fdate,
            b.ftime ? b.fdate + ' ' + b.ftime : b.fdate,
            isAsc
          );
        case 'predefined':
          return this.compare(a.predefined, b.predefined, isAsc);
        case 'fileDesc':
          return this.compare(a.fileDesc, b.fileDesc, isAsc);
        case 'lastModified':
          return this.compare(a.lastModified, b.lastModified, isAsc);
        case 'uploadedDate':
          return this.compareDates(a.uploadedDate, b.uploadedDate, isAsc);
        case 'parentFolderName':
          return this.compare(a.parentFolderName, b.parentFolderName, isAsc);
        case 'ftype':
          return this.compare(a.ftype, b.ftype, isAsc);
        case 'fileName':
          return this.compare(a.fileName, b.fileName, isAsc);
        default:
          return 0;
      }
    });
  }

  handleSortData(sort: Sort) {
    const data = this.files.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = this.getSortedData(data, sort);
    this.filesTableDataSource.data = this.sortedData;
    this.updatePaginator();
    if (this.filesTableDataSource.paginator) {
      this.filesTableDataSource.paginator.firstPage();
    }
    this.ref.detectChanges();
    this.selection.clear();
    this.refreshButton = true;
    this.refreshing = false;
  }

  /**
   * Gets the data and:
   * 1. Isolate index link.
   * 2. Isolate predefined items and sort them alphabetically.
   * 3. Isolate custom folders and sort them alphabetically.
   * 4. Join 1, 2 and 3 keeping that order.
   * @param data is an array of files.
   */
  sortingIndexFolders(data) {
    let indexItem;
    if (this.userIsClient) {
      indexItem = false;
    } else {
      let indexINDEX = 0;
      indexItem = data.filter((file, i) => {
        if (file.fileName.substring(0, 5) === indexFolderLabel) {
          indexINDEX = i;
          return true;
        }
      })[0];
      data.splice(indexINDEX, 1);
    }
    const predefinedItems = data.filter(({ predefined }) => predefined === true);
    const customItems = data.filter(({ predefined }) => predefined !== true);
    const predefinedSortedItems = predefinedItems.slice().sort((a, b) => this.compare(a.fileName, b.fileName, true));
    const customSortedItems = customItems.slice().sort((a, b) => this.compare(a.fileName, b.fileName, true));

    return (indexItem ? [indexItem] : []).concat(predefinedSortedItems).concat(customSortedItems);
  }

  /**
   * Once you have selected one or more files, this action will
   * place selected one at the top of the list followed by the
   * non selected ones.
   */
  sortFilesBySelected() {
    const selectedItems = this.selection.selected;
    const selected = selectedItems.map(item => item.fileId);
    const data = this.filesTableDataSource.data.filter(item => !selected.includes(item.fileId));
    this.filesTableDataSource.data = selectedItems.concat(data);
  }

  updateFile(
    data: { type: string; date: { value: string | number | Date }; name: any; desc: any },
    file: { folderId: string; fileId: string }
  ) {
    const afterUpdate = async () => {
      const folderName = this.getFolderName(this.caseFolders, this.currentFolder);
      const message = successmessage + ' Reloading this list...';
      const label = 'INFORMATION';
      this.uiMessaging_$.toastMessage(message, label);
      await this.getFilesForPatient(this.currentFolder, {
        folderName,
        caseFolders: this.caseFolders,
        roleConsultant: this.userIsConsultant,
        roleClient: this.userIsClient
      });

      // Also refresh the accordion to keep it in sync
      await this.refreshAccordionAfterOperation();

      this.auth_$.snackBar.dismiss();
      if (!this.userIsConsultant) {
        // await this.updateConsultantsLists();
        // await this.updateFacilityAdminsLists();
        // await this.updateFacilityConsultantsLists();
      }
      return successmessage;
    };

    const successmessage = data.type === 'folder' ? 'Folder updated successfully' : 'File updated successfully.';

    let ndate = null;
    if (data.date) {
      const date = new Date(data.date.value);
      ndate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }

    if (data.type === 'folder') {
      this.files_$.getFilesByFolderId(file.folderId).then(fileSnapShot => {
        fileSnapShot.forEach(item => {
          const updateObject = {};
          if (data.name) {
            updateObject['name'] = data.name;
          }
          this.files_$
            .updateFileByDocId(item.id, updateObject)
            .then(() => afterUpdate())
            .catch(error => this.handleError(error));
        });
      });
    } else {
      this.files_$.getFileByFileId(file.fileId).then(fileSnapShot => {
        fileSnapShot.forEach(item => {
          const updateObject = {};

          if (data.name) {
            updateObject['fileName'] = data.name;
          }

          if (data.desc) {
            updateObject['fileDesc'] = data.desc;
          }

          if (ndate) {
            updateObject['fdate'] = ndate;
          }

          this.files_$
            .updateFileByDocId(item.id, updateObject)
            .then(() => afterUpdate())
            .catch(error => this.handleError(error));
        });
      });
    }
  }

  /**
   * This is used to update the facilities users list: Active and Available.
   * It's called when the user clicks on the facilities tab.
   * It's also called when the user clicks on the folder.
   */
  async updateFacilitiesUsersLists() {
    if (!this.isSpoke) {
      this.activeFacilitiesUsers = await this.firebase_utilities_$.getActiveFaciltiesAdminsByClientIdV2(
        this.casename,
        null,
        null,
        true
      );
    } else {
      this.activeFacilitiesUsers = await this.firebase_utilities_$.getSpokesFacilitators();
    }

    this.availableFacilitiesUsers = await this.firebase_utilities_$.getAvailableAdmins(
      this.casename,
      UserRoles.admin,
      this.activeFacilitiesUsers,
      true,
      null
    );
  }

  // FIXME: In case of INDEX_FOLDER_NAME should not touch those files already unshared.
  async unShareWith(params) {
    const { consultant, type } = params;
    const array = type === 'single' ? this.selection.selected : this.filesTableDataSource.data;
    const filesToUnShare = [];
    const result = [];
    for (let index = 0; index < array.length; index++) {
      if (array[index].sharedUsers && array[index].sharedUsers.length === 0) {
        continue;
      }

      if (this.utils_$.fileIsShared({ email: consultant }, array[index])) {
        result.push(array[index].fileName);
        await this.firebase_utilities_$.unShareFile(array[index], consultant, this.casename);
        filesToUnShare.push(array[index]);
      } else {
        continue;
      }
    }
    this.whenUnShareFilesAreDone(result, consultant);
    if (filesToUnShare.length > 0) {
      this.phiAudit.logPhiAccess('file', this.casename, 'unshare', { fileCount: filesToUnShare.length });
    }
    const filesGroup = filesToUnShare.map(item => item.fileName);
    this.log_$.storeLog(
      this.auth_$.userData.getValue(),
      LogLevelsDictionary.info,
      {
        message: 'A group of files has been unshared.',
        filenames: filesGroup.join(','),
        user: consultant
      },
      'Unshare',
      this.casename
    );
    const folderName = this.getFolderName(this.caseFolders, this.currentFolder);
    this.getFilesForPatient(this.currentFolder, {
      folderName,
      caseFolders: this.caseFolders,
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient
    });

    if (!this.userIsConsultant) {
      // this.updateConsultantsLists();
      // this.updateFacilityAdminsLists();
      // this.updateFacilityConsultantsLists();
    }
  }

  // TODO: Get rid of this method since the SharedFilesComponent is not needed anymore.
  /* async unShareAll(consultantEmail: string) {
    this.unShareWith({ consultant: consultantEmail, type: INDEX_FOLDER_NAME }).then(
      () => (this.activeConsultant = null)
    );
  } */

  // TODO: Get rid of this method since there is no need for activeConsultant
  /* updateDataSharedStatus() {
    const newData = [];
    this.filesTableDataSource.data.forEach(item => {
      item.isShared =
        typeof item.sharedUsers === 'undefined' ? false : this.isSharedWithActiveConsultant(item.sharedUsers);

      newData.push(item);
    });

    this.filesTableDataSource.data = newData;
    this.sharedFilesCount = this.countSharedFiles(this.filesTableDataSource.data);
  } */

  updatePaginator() {
    this.filesTableDataSource.paginator = this.uppaginator;
  }

  updateDataTable() {
    this.sortedData = this.files.slice();
    this.filesTableDataSource.data = this.files;
    this.updatePaginator();

    if (this.filesTableDataSource.paginator) {
      this.filesTableDataSource.paginator.firstPage();
    }

    this.ref.detectChanges();
    this.selection.clear();
    this.refreshButton = true;
    this.refreshing = false;
  }

  validateRole(role: string) {
    return this.permissions_$.validateRole(role);
  }

  async validateRoleMulti(objectList: any) {
    return await this.permissions_$.validateRoleMulti(objectList);
  }

  handleNoteClick(event, element) {
    event.stopPropagation();
    event.preventDefault();
    if (element.disabled) return;

    this.ngZone.run(async () => {
      this.auth_$.showLoader('Loading comments and attachments...');
      element.disabled = true;
      this.selection.selected.push(element);

      if (environment.config.viewerIndex === 0) {
        await this.preStudyViewAction();
      }

      this.openCommentsAndAttachments(element).then(() => {
        element.disabled = false;
        this.auth_$.hideLoader();
        this.getRidOfNotesNotifications(element);
      });
    });
  }

  async handleAddClientUser(event) {
    console.log('event :', event);
    console.log('handleAddClientUser');
    const { CreateCuaUserComponent } = await import('../create-cua-user/create-cua-user.component');
    const dialog = this.dialog_$.open(CreateCuaUserComponent, {
      width: '600px',
      data: {
        patient: this.patient,
        user: event
      }
    });

    dialog.afterClosed().subscribe(async ({ success, result }) => {
      if (success) {
        const { email } = result;
        await this.clientMatter_$.updateClientMatter(this.casename, email).then(res => {
          console.log('Patient updated :', res);
          this.updateClientData(email);
        });

        if (this.ownerHasAccess) {
          await this.createClientUploadFolder(this.casename)
            .then(res => {
              console.log('Folder created :', res);
              this.updateFoldersList().then(() => this.getData());
            })
            .catch(err => {
              console.error('Error creating folder :', err);
            });
        }
      }
    });
  }

  private async updateFoldersList() {
    this.caseFolders = await this.handlingFolders(null, this.userOwnerID);
  }

  private async createClientUploadFolder(casename) {
    const result = await this.folders_$.createFolder(
      'Client Upload',
      casename,
      {
        color: folderColors['Client Upload'],
        type: 'folder',
        predefined: true,
        forDelete: false,
        modal: false
      },
      this.caseFolders
    );
    return result;
  }

  private updateClientData(clientUserEmail) {
    this.patient.clientUser = clientUserEmail;
  }

  getDefinedDefaultFolders(userRole) {
    return this.firebase_utilities_$.getDefaultFoldersDefinition(userRole);
  }

  async getDefaultFolders() {
    return (await firebase.firestore().collection('defaultFolders').get()).docs
      .map(d => d.data())
      .filter(d => d.forbiddenPatientType !== this.patient.type);
  }

  private getSeachFilesComponentData() {
    return {
      id: 1,
      uploadTypes: this.uploadTypes,
      fdate: this.fdate,
      ftime: this.ftime,
      basicfile: this.files,
      description: this.fdesc,
      type: this.ftype,
      folder: this.currentFolder,
      clientName: this.patientName,
      casename: this.casename,
      action_params: {
        files: '',
        type: '',
        desc: '',
        caseName: this.casename,
        creator: this.uid
      }
    };
  }

  // Search Results Component Event Handlers
  onSearchResultFileClick(file: any): void {
    // Handle file click from search results
    console.log('Search result file clicked:', file);
    // You can implement file opening logic here
  }

  onSearchResultFileSelectionChange(file: any): void {
    // Handle file selection change from search results
    console.log('Search result file selection changed:', file);
  }

  onClearSearchResults(): void {
    // Clear search results and return to normal view
    this.searchResults = [];
    this.searchQuery = '';
    this.isSearchActive = false;
    this.searchResultsSelection.clear();

    // Restore original files if needed
    if (this.originalFiles.length > 0) {
      this.filesTableDataSource.data = this.originalFiles;
    }
  }
  // NOTE: This is used from template too .
  public async handleRefresh() {
    // First, refresh all files to ensure INDEX folder data is available
    await this.refreshAllFiles();

    // Refresh both files and accordion folders
    await this.getFilesForPatient(this.currentFolder, {
      folderName: this.currentFolderName,
      roleConsultant: this.realRole === UserRoles.consultant,
      caseFolders: await this.getCaseFolders()
    });

    // Also refresh the accordion folders to show newly created folders
    await this.refreshAccordionFolders();

    // Force change detection to ensure the accordion component gets the updated data
    // This ensures the template binding [folders]="hierarchicalFolders" is updated
    this.ref?.detectChanges();
  }

  private async updateFilesArrayNotifications() {
    await this.auth_$.getNotifications();

    let files = [];
    if (environment.config.notifications === 0) {
      files = this.files.map(file => ({ ...file, hasNotifications: false }));
    } else {
      files = this.files.map(file => ({ ...file, hasNotifications: this.getFileHasNotifications(file) }));
    }

    this.filesTableDataSource.data = this.files = files;
    await this.handleRefresh();
  }

  private getFileHasNotifications(file) {
    return this.getAllNotificationsFromUserData().some(n => n.fileId === file.fileId);
  }

  private checkIfFolderHasNotifications(folderId: string) {
    if (environment.config.notifications === 0) {
      return false;
    }
    return (
      this.auth_$.userData
        .getValue()
      ['notifications'].map(n => n.folderId)
        .indexOf(folderId) > -1
    );
  }

  private getUserDataNotifications(fileId) {
    return this.auth_$.userData.getValue()['notifications'].filter(n => n.fileId === fileId);
  }

  private getAllNotificationsFromUserData() {
    return this.auth_$.userData.getValue()['notifications'];
  }

  private afterAddNote({ fileDocId, id, type, parentFolder, noteId }) {
    this.selection.clear();
    const folderName = this.currentFolderName;
    this.topMenuData.currentFolderName = folderName;
    this.topMenuData.indexFolderNameCounter = this.indexFolderNameCounter;
    // Create notification.

    this.firebase_utilities_$.createNotifications(
      { id: id },
      { type: type === 'file' ? 1 : 2, uploadBlock: { casename: this.casename }, noteId },
      { parentFolderId: parentFolder },
      NotificationTypes.newnote
    );

    const options = {
      folderName,
      caseFolders: this.caseFolders,
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient
    };
    this.getFilesForPatient(this.currentFolder, options);
    if (!this.userIsConsultant) {
      // this.updateConsultantsLists();
      // this.updateFacilityAdminsLists();
      // this.updateFacilityConsultantsLists();
    }
  }

  private async populateAllNotesDialogData(fileClicked?): Promise<ViewAllNotesDialogData> {
    // Use fileClicked if provided, otherwise use the first selected file from selection model
    const selectedFile = fileClicked || (this.selection.selected.length > 0 ? this.selection.selected[0] : null);

    if (!selectedFile) {
      throw new Error('No file selected for comments and attachments');
    }

    const { fileName, viewerurl, ftype, fileId, id, notes, parentFolder, type } = selectedFile;
    const { uid, role, email, notifications } = <{ uid: string; role: string; email: string; notifications: any }>(
      this.auth_$.userData.getValue()
    );

    const dialogData = {
      title: 'View Comments & Attachments',
      message: `Filename: ${fileName}`,
      selected_files: fileClicked ? [selectedFile] : this.selection.selected,
      notes: notes,
      fileViewData: await this.getfileViewData(ftype, fileName, viewerurl, fileId),
      fileid: fileId,
      fileDocId: id,
      patientName: this.casename,
      createdBy: email,
      currentFolder: this.currentFolder,
      currentFolderName: this.currentFolderName,
      parentFolder: parentFolder,
      userRole: role,
      userEmail: email,
      fileType: type,
      notifications: this.getNotificationsFiltered(notifications, fileId, uid),
      restrictedProfiles: this.patient.restrictedProfiles,
      allowedProfiles: this.patient.allowedProfiles,
      fileClicked: fileClicked || null
    };

    return dialogData;
  }

  private allNotesCloseHandler(val: { fileId: any }) {
    this.selection.clear();
    this.auth_$.getNotifications(val?.fileId);
    this.getFilesForPatient(this.currentFolder, {
      folderName: this.currentFolderName,
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient,
      user: this.user,
      caseFolders: this.caseFolders
    });
    if (!this.userIsConsultant) {
      // this.updateConsultantsLists();
      // this.updateFacilityAdminsLists();
      // this.updateFacilityConsultantsLists();
    }
  }

  /**
   *
   *
   * @private
   * @return {*}
   * @memberof ClientProfileComponent
   */
  private getOptions(): {
    folderName: string;
    caseFolders: any[];
    roleConsultant: boolean;
    roleClient: boolean;
  } {
    return {
      folderName: this.getFolderName(this.caseFolders, this.currentFolder),
      caseFolders: this.caseFolders,
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient
    };
  }

  /**
   * If user is consultant, then the consultants lists are not updated. They doesn't exist.
   *
   * @private
   * @memberof ClientProfileComponent
   */
  private evaluateConsultantsListsUpdate() {
    if (!this.userIsConsultant) {
      // this.updateConsultantsLists();
      // this.updateFacilityAdminsLists();
      // this.updateFacilityConsultantsLists();
    }
  }

  /**
   *
   *
   * @private
   * @param {any[]} promisesResult
   * @param {string} consultantEmail
   * @memberof ClientProfileComponent
   */
  private handleStoreLog(promisesResult: any[], consultantEmail: string) {
    this.log_$.storeLog(
      this.auth_$.userData.getValue(),
      LogLevelsDictionary.info,
      {
        message: 'A group of files has been shared.',
        filenames: promisesResult.join(','),
        user: consultantEmail
      },
      'Share',
      this.casename
    );
  }

  private getActiveConsultants() {
    return this.clientProfileConsultantService.getActiveConsultants(this.casename, this.ownerID, this.files);
  }

  private getAvailableConsultants(noclient = false) {
    return this.clientProfileConsultantService.getAvailableConsultants(
      this.casename,
      this.activeConsultants,
      noclient
    );
  }

  deleteAllFileNotifications(fileId: string) {
    return this.notifications_$.deleteAllFileNotifications(fileId);
  }

  private handleDeleteAllFilesNotifications(fileIDs: any[]) {
    const deleteAllFilesNotifications = [];
    fileIDs.forEach(fileID => deleteAllFilesNotifications.push(this.deleteAllFileNotifications(fileID)));
    Promise.all(deleteAllFilesNotifications).then(() => {
      this.auth_$.getNotifications();
    });
  }

  async reloadProfiles() {
    this.patient = {
      ...this.patient,
      ...(await firebase.firestore().collection('patients').doc(this.patient.patientDocId).get()).data()
    };

    // Ensure patient IDs are properly mapped from metadata.medical_record_numbers
    if (this.patient?.metadata?.medical_record_numbers && !this.patient.patientIDs) {
      this.patient.patientIDs = this.patient.metadata.medical_record_numbers;
    }
  }

  async reloadConsultantsData($event) {
    await this.reloadProfiles();
    this.uiMessaging_$.toastMessage('Consultants list updated.', 'INFO');
  }

  validateProfile(notes) {
    if ([UserRoles.consultant, UserRoles.client].includes(this.auth_$.userData.getValue()['role'])) {
      if (Boolean(this.isAuthor(notes))) {
        return true;
      }

      if (this.isRestrictedProfile()) {
        return false;
      }

      if (this.patient.allowedProfiles?.includes(this.auth_$.userData.getValue()['uid'])) {
        return true;
      }

      return true;
    }
    return true;
  }

  private isRestrictedProfile() {
    return this.patient.restrictedProfiles?.includes(this.auth_$.userData.getValue()['uid']);
  }

  private isAuthor(notes) {
    return notes.find(n => n.createdBy === this.auth_$.userData.getValue()['email']);
  }

  /**
   * Check if the current user has Client Admin (Facilitator) role
   */
  isClientAdmin(): boolean {
    return this.realRole === UserRoles.admin;
  }

  /**
   * Check if consultant/facilitator panels should be shown
   */
  get shouldShowConsultantPanels(): boolean {
    return !this.isClientAdmin();
  }

  private getPromise(uid, newFileNotifications?, sharedFileNotifications?, fileId?) {
    if (newFileNotifications && sharedFileNotifications) {
      return this.notifications_$.deleteNewFileAndSharedFileNotificationsByFileIdAndUserId(fileId, uid);
    } else if (newFileNotifications) {
      return this.notifications_$.deleteNewFileNotificationsByFileIdAndUserId(fileId, uid);
    } else if (sharedFileNotifications) {
      return this.notifications_$.deleteSharedFileNotificationsByFileIdAndUserId(fileId, uid);
    } else {
      return Promise.resolve('');
    }
  }

  private handleDeleteNewFileAndSharedFileNotifications({ newFileNotifications, sharedFileNotifications, fileId }) {
    const uid = this.auth_$.userData.getValue()['uid'];
    this.getPromise(uid, newFileNotifications, sharedFileNotifications, fileId).then(() => {
      this.updateFilesArrayNotifications();
    });
  }

  private getPatientDocIdFromCaseName(casename: string) {
    return this.firebase_utilities_$.getPatientDocIdFromCaseName(casename);
  }

  private async afterProfileUpdated() {
    this.activeConsultants = await this.getActiveConsultants();
  }

  private prepareSimpleFileData(fileName, fileId) {
    const fileExtension = this.getFileNameExtension(fileName);
    if (notPlayableVideoExtensions.includes(fileExtension)) {
      return this.prerareVOBDownloadLink(fileExtension);
    } else {
      return this.prepareRegularFileViewerData(fileId, fileName, fileExtension);
    }
  }
  private prepareDICOMDIskData(viewerurl) {
    // Preparing the viewer url.
    return {
      type: 'dicomdisk',
      docviewer: false,
      downloadLink: false,
      viewerUrl: this.getDICOMDiskViewerUrl(viewerurl)
    };
  }

  private getDICOMDiskViewerUrl(viewerurl: string) {
    return this.getViewerUrl(viewerurl);
  }
  private prerareVOBDownloadLink(fileExtension: string) {
    // Prepare Download Link
    return {
      type: fileExtension.toLowerCase(),
      docviewer: false,
      downloadLink: this.getVOBDownloadLink()
    };
  }

  private async prepareRegularFileViewerData(fileId, fileName, fileExtension) {
    this.auth_$.showLoader('Loading viewer...');
    const type = ['png', 'jpg', 'jpeg', 'png', 'gif'].includes(fileExtension) ? 'image' : 'regular';
    const filePath = (await this.files_$.getFileByFileId(fileId)).docs[0].data().filePath;
    const fileUrl = await this.files_$.getFileUrl(filePath);
    return {
      type,
      docviewer: true,
      viewerData: {
        title: fileName,
        src: fileUrl.data.url,
        info: fileUrl.data.url,
        viewer: this.getProperViewer(fileName)
      }
    };
  }

  private getVOBDownloadLink() {
    return 'https://www.w3schools.com/html/mov_bbb.mp4';
  }

  private createDialogConfig({ width, maxWidth, maxHeight, autoFocus, data, disableClose, height }) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = disableClose;
    dialogConfig.width = width;
    dialogConfig.height = height;
    dialogConfig.maxWidth = maxWidth;
    dialogConfig.maxHeight = maxHeight;
    dialogConfig.autoFocus = autoFocus;
    dialogConfig.data = data;
    return dialogConfig;
  }

  private async getfileViewData(ftype, fileName, viewerurl, fileId) {
    this.auth_$.showLoader('Loading viewer...');
    const preparingViewerData =
      ftype === UploadTypes.DICOMDisk
        ? Promise.resolve(this.prepareDICOMDIskData(viewerurl))
        : await this.prepareSimpleFileData(fileName, fileId);
    return preparingViewerData;
  }

  private getNotificationsFiltered(notifications, fileId, uid) {
    return notifications
      .filter((g: { fileId: string }) => g.fileId === fileId)
      .filter(({ userId }) => userId === uid)
      .filter(({ type }) => [NotificationTypes.modifiednote, NotificationTypes.newnote].includes(type));
  }

  private async getFileUrl(filePath) {
    return firebase.functions().httpsCallable('firebaseUtilities-fileGetSignedURL')({ filePath });
  }

  private getAttachmentLists(attachments) {
    return attachments ? this.firebase_utilities_$.storeNoteNewAttachments(attachments, this.patientName) : [];
  }

  private async validateFileMeta(filePath) {
    const result = await firebase
      .functions()
      .httpsCallable('firebaseUtilities-fileGetMetadata')({ filePath })
      .catch(err => {
        console.error('Error getting file metadata :', err);
        return false;
      });
    const fileMetadata = result['data']['url'];
    this.auth_$.hideLoader();

    if (!fileMetadata) {
      this.auth_$.hideLoader();
      this.uiMessaging_$.toastMessage(
        "It seems the file doesn't exist anymore. Please delete the file and import it again",
        'ERROR'
      );
      return false;
    }

    if (+fileMetadata['size'] === 0) {
      this.auth_$.hideLoader();
      this.uiMessaging_$.toastMessage(
        "It seems the file doesn't exist anymore. Please delete the file and import it again",
        'ERROR'
      );
      return false;
    }

    return true;
  }

  private getRidOfNotesNotifications(element, notificationTypes?: string[]) {
    this.deleteNotificationsByFileId(element.fileId, notificationTypes || null);
  }

  private deleteNotificationsByFileId(fileId, notificationTypes?: string[]) {
    this.firebase_utilities_$.deleteNotificationsByTypeUserIdAndFileId(
      notificationTypes || [NotificationTypes.newnote, NotificationTypes.modifiednote, NotificationTypes.newfile],
      this.user.uid,
      fileId
    );
    this.excludeNotificationsFromUserDataByFileId(
      fileId,
      notificationTypes || [NotificationTypes.newnote, NotificationTypes.modifiednote, NotificationTypes.newfile]
    );
  }

  private excludeNotificationsFromUserDataByFileId(fileIdParameter, notificationTypes?: string[]) {
    const notifications = this.getAllNotificationsFromUserData().filter(
      ({ fileId, type }) => fileId !== fileIdParameter && !notificationTypes.includes(type)
    );
    this.auth_$.userData.next({ ...this.auth_$.userData.getValue(), notifications });
  }

  private async getFilesSharedByCaseName(casename: string) {
    const filesForCase = this.auth_$.userData.value['filesSharedWith'].filter(
      (file: { patientCaseName: string }) => file.patientCaseName === casename
    );

    for (let index = 0; index < filesForCase.length; index++) {
      const folderId = await this.getParentFolderByFileId(filesForCase[index].fileId);
      filesForCase[index].folderId = folderId;
    }

    return filesForCase;
  }

  private getParentFolderByFileId(fileId: string) {
    return this.files_$.getParentFolderByFileId(fileId);
  }

  /**
   * Retrieves files from the home folder based on the provided parameters.
   *
   * @param params - An object containing various parameters for retrieving files.
   * @param params.roleConsultant - A boolean indicating if the user has a consultant role.
   * @param params.caseFolders - An array to store the shared folders if the user is a consultant.
   *
   * @returns A promise that resolves to an array of folders. If the user does not have access,
   *          the returned array will exclude folders named 'Client Upload'.
   *
   * @throws Will throw an error if any of the asynchronous operations fail.
   */
  async getFilesHomeFolder(params): Promise<any> {
    const useremail = this.user?.email || '';
    let indexCount, filesShared;

    if (params.roleConsultant) {
      filesShared = await this.getFilesSharedByCaseName(this.casename);
      indexCount = filesShared.length.toString();
      this.sharedFolders = await this.getUpdatedSharedFolders(filesShared, params);
      params.caseFolders = this.sharedFolders;
    } else {
      indexCount = (await this.getFilesCountByClient(this.casename, params.roleConsultant, useremail)).toString();
    }

    await this.setFoldersWithCountLabels(indexCount, this.realRole, params.roleConsultant, params.caseFolders);
    const folders = await this.getNamedFolders(params, useremail, filesShared);
    return this.ownerHasAccess ? folders : folders.filter(f => f.fileName !== 'Client Upload');
  }

  private async getUpdatedSharedFolders(filesShared, params) {
    const filesParentFolderIds = await this.files_$.getParentFolders(filesShared.map(file => file.fileId));

    const generateFolderName = folder => {
      const folderAlias = this.files_$.findFolderAlias(folder.name);
      const sharedFilesCount = filesShared.filter(file => file.folderId === folder.folderId).length;
      const name = `${folderAlias} (${sharedFilesCount})`;
      return name;
    };

    const setFoldersName = folder => ({ ...folder, name: generateFolderName(folder) });
    const filterByFolderId = folder => filesParentFolderIds.includes(folder.folderId);

    return params.caseFolders.filter(filterByFolderId).map(setFoldersName);
  }

  /**
   * Get the folders for the client profile.
   * @param params the parameters for the folders.
   * @param useremail the email of the user.
   * @param filesShared the files shared with the user.
   * @param files the files to get the folders for.
   * @returns the folders for the client profile.
   */
  private getFolders(params, useremail, filesShared, files) {
    return Promise.all(
      files.map(async folder => {
        return { ...folder, ...(await this.getFolderExtra(folder, params.roleConsultant, useremail, filesShared)) };
      })
    );
  }

  /**
   * Set the files for the client profile.
   * @param foldersWithCountLabels the folders with count labels.
   * @param indexCount the index count.
   * @returns the files for the client profile.
   */
  private setFiles(foldersWithCountLabels, indexCount) {
    return this.realRole === UserRoles.client
      ? foldersWithCountLabels
      : [this.createIndexFolder(indexCount), ...foldersWithCountLabels];
  }

  /**
   * Set the folders with count labels.
   * @param indexCount the index count.
   * @param role the role of the user.
   * @param roleConsultant the role of the consultant.
   * @param caseFolders the case folders.
   * @returns the folders with count labels.
   */
  private async setFoldersWithCountLabels(indexCount, role, roleConsultant, caseFolders) {
    const folders = await this.setFolderCountLabels(roleConsultant, caseFolders);
    this.files = [this.createIndexFolder(indexCount), ...folders];
  }

  private createIndexFolder(indexCount) {
    const indexFolder = this.clientProfileFolderService.createIndexFolder(indexCount);
    this.indexFolderNameCounter = indexFolder.name;
    return indexFolder;
  }

  private createFolderObject(folderName) {
    return this.clientProfileFolderService.createFolderObject(folderName, this.casename, this.userOwnerID);
  }

  private getFileWithNotifications(file) {
    const notifications = this.getUserDataNotifications(file.fileId);
    return this.clientProfileFileService.getFileWithNotifications(
      file,
      this.caseFolders,
      (fileId: string) => this.getUserDataNotifications(fileId)
    );
  }

  private getCategorizedNotifications(n: { type: NotificationTypes }[]) {
    if (environment.config.notifications === 0) {
      return {
        newNoteNotifications: [],
        newFileNotifications: [],
        modifiedNoteNotifications: [],
        sharedFileNotifications: []
      };
    }
    return {
      newNoteNotifications: n.filter(n => n.type === NotificationTypes.newnote),
      newFileNotifications: n.filter(n => n.type === NotificationTypes.newfile),
      modifiedNoteNotifications: n.filter(n => n.type === NotificationTypes.modifiednote),
      sharedFileNotifications: n.filter(n => n.type === NotificationTypes.sharedfile)
    };
  }

  private getOwnerAccess() {
    this.auth_$
      .doesOwnerHasAccess()
      .then(res => (this.ownerHasAccess = res))
      .catch(err => (this.ownerHasAccess = false));
  }

  handleParentFolderNameClick(event, parentFolder) {
    event.preventDefault();
    this.browseFolderByName(parentFolder.folderName);
  }

  getOwnerID() {
    return this.patient.ownerID;
  }

  async browseFolderContentsV2(folderId: string, folderName: string) {
    const getOptions = () => {
      return {
        globalFolders: true,
        folderName: folderName,
        roleConsultant: this.userIsConsultant,
        roleClient: this.userIsClient,
        caseFolders: this.caseFolders
      };
    };
    // TODO: Get rid of this portion since there is no need for activeConsultant
    // this.activeConsultant = null;
    this.selection.clear();
    console.log('browseFolderContents', folderName);
    this.auth_$.setCurrentFolder(folderName);
    await this.getFilesForPatient(folderId, getOptions(), true);
  }

  private updateFileField(fileId: string, field: any) {
    this.files_$.updateFileField(fileId, field);
  }

  handleDownloadDIscFinished(res, fileId) {
    if (!res) {
      this.handleError();
      return;
    }
    res.subscribe({
      next: data => {
        // Data logged

        const { fileInfo } = data;
        // fileInfo logged

        if (data.dataResult?.status === 200)
          this.uiMessaging_$?.toastMessage('The disc is ready to be downloaded.', 'INFO');
        else this.handleError();
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 0) {
          this.uiMessaging_$?.toastMessage(error.statusText, 'ERROR');
          return;
        }
        // Error logged

        this.disableFile(fileId);
        this.handleError();
      },
      complete: () => { }
    });
  }

  disableFile(fileId: string) {
    this.updateFileField(fileId, { disabled: true });
  }

  selectedIsStudy() {
    const selectedFiles = this.selection.selected;
    return selectedFiles.length === 1 && (selectedFiles[0]?.fileName === 'DICOMDIR' || selectedFiles[0]?.viewerurl);
  }

  // Constant for error message
  INVALID_SELECTION_ERROR = 'Invalid selection.';

  async generateDISC(evt: Event, selected: any[]): Promise<void> {
    // Prevent the default event behavior
    evt.preventDefault();

    // Check if the selection is valid
    if (!Array.isArray(selected) || selected.length === 0) throw new Error(this.INVALID_SELECTION_ERROR);

    // Start loading notification
    const { downloadLink, fileDesc, fileId, parentFolderName } = selected[0];
    this.showStartGeneratingDiscNotification({
      studyName: fileDesc,
      folderName: parentFolderName,
      fileId: fileId
    });
    this.notificationIds.push(fileId);

    const fileWithDICOMDIRFileIdExistince = async (fileId: string): Promise<Boolean> => {
      const result = !(await this.files_$.getFileByDICOMDIRFileId(fileId)).empty ? true : false;
      return result;
    };

    const generatedDiscExists = async (fileId: string) => {
      const booleanAnswer = await fileWithDICOMDIRFileIdExistince(fileId);
      return booleanAnswer;
      // return this.files.some(file => file.DICOMDIRFileId === fileId);
    };

    const deleteDownloadLink = fileId => {
      this.files.find(file => file.fileId === fileId).downloadLink = null;
      return this.files_$?.deleteDownloadLink(fileId);
    };

    // If the file doesn't have a download link, handle it separately
    if (!downloadLink) this.generateDownloadDisc(selected[0]);
    else if (await generatedDiscExists(fileId)) {
      // If the file has a download link, hide the loader and download the file
      this.auth_$.hideLoader();

      const removeLoader = this.auth_$.handleGeneratedDiscCheck({ fileId, fileDesc });
      this.hideStartGeneratingDiscNotification(fileId);
    } else {
      deleteDownloadLink(fileId);
      this.generateDownloadDisc(selected[0]);
    }
  }

  showStartGeneratingDiscNotification(params) {
    const options = { position: 'bottom', fileId: params.fileId };
    const message = `Generating disc contents for the study "${params.studyName}" in the folder "${params.folderName}"`;
    this.auth_$.showProgressLoader(message, options);
  }

  private hideStartGeneratingDiscNotification(fileId: string) {
    this.auth_$.hideProgressLoader(fileId);
  }

  private startWaitingForDiscGeneration(fileInProcess: string) {
    this.files = this.files.map(file => {
      if (file.fileId === fileInProcess) file['waiting'] = true;
      else {
        // The file has not been found, so it's not waiting.
        // FIXME: Add a ui notification here.
      }
      return file;
    });
  }

  async getCaseFolders() {
    this.caseFolders = await this.firebase_utilities_$.getFolders(this.casename, {
      ownerID: this.userOwnerID,
      userOwnerID: this.userOwnerID
    });
    return this.caseFolders;
  }

  private getDeleteConfirmDialogConfigData(plural, condition) {
    return {
      title: 'Confirm deletion',
      message: `Are you sure  you want to delete ${this.selection.selected.length} file${plural} from your uploaded files?`,
      confirm_action: condition ? this.handleDeleteAllFiles : this.deleteFiles,
      deleteAllFiles: condition,
      selected_files: condition ? null : this.selection.selected,
      btnOkText: 'Yes',
      btnCancelText: 'No'
    };
  }

  private getFilesForPatientOptions() {
    return {
      folderName: this.getFolderName(this.caseFolders, this.currentFolder),
      caseFolders: this.caseFolders,
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient
    };
  }

  private deleteFilesFromStorage(filePaths: string[]) {
    return this.files_$.deleteFilesFromStorage(filePaths);
  }

  private gotoDiscsFolder(clientProfileActionsData: any) {
    this.discsFolderFlow = { active: true, fileId: clientProfileActionsData.fileId };
    return this.browseFolderByName(DISCS_FOLDER_NAME, 'uploadedDate').catch(err =>
      console.error('Error browsing folder:', err)
    );
  }

  ngAfterViewChecked() {
    if (this.currentFolderName === DISCS_FOLDER_NAME) {
      if (this.discsFolderFlow) {
        this.ngZone.run(() => this.discsFolderFlowRun(this.discsFolderFlow.fileId));
        this.discsFolderFlow = false;
        this.ref.detectChanges();
      }
    }
  }

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscription.unsubscribe();

    // Restore body scrollbar when component is destroyed
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  subscribeToClientProfileFiles() {
    this.auth_$.clientProfileFiles.subscribe((files: { originalFileId: string; fileId: string; waiting: any }[]) => {
      this.files.forEach(file => {
        const fileInProcess = files.find(f => f.originalFileId === file.fileId);
        if (fileInProcess) file['waiting'] = fileInProcess.waiting;
      });
      this.filesTableDataSource.data = this.files;
    });
  }

  subscribeToClientProfileActions() {
    this.auth_$.clientProfileActions.subscribe(async action => {
      if (!action) {
        return;
      }

      switch (action) {
        case 'gotodiscs':
          // If current folder is not Discs, then go to Discs.
          if (this.currentFolderName !== DISCS_FOLDER_NAME)
            await this.gotoDiscsFolder(this.auth_$.clientProfileActionsData);
          break;
        case 'generateddiscfirststepready':
          if (!this.helpPanel.expanded) {
            // this.showHelpPanel();
          }

          console.log('generateddiscfirststepready');
          this.howToBurnADisc.howToBurnADiscSteps[0]['running'] = false;
          this.howToBurnADisc.howToBurnADiscSteps[0]['ready'] = true;
          this.auth_$.clientProfileActions.next(null);
          this.auth_$.clientProfileActionsData = null;
          break;
        case 'startthedownload':
          this.auth_$.clientProfileActions.next(null);
          this.auth_$.clientProfileActionsData = null;
          this.handleDerivedZIPFileClick(this.selection.selected[0]);
          break;
        default:
          break;
      }
    });
  }

  /**
   * Gets the files for the patient.
   * @param folderId the folder id.
   * @param roleConsultant the role consultant.
   * @param caseFolders the case folders.
   * @returns the files for the patient.
   */
  private async getPatientsFilesArray(folderId, roleConsultant, caseFolders, userOwnerID = null) {
    let files = await this.getFilesArray(folderId, roleConsultant, caseFolders, userOwnerID);
    const isDICOM = this.filesFilter.name === 'DICOM';
    const hasName = this.filesFilter.name !== '';
    const isValid = this.filesFilter.valid === true;

    if (!isValid) {
      this.filesFilter.name = '';
    }

    if (hasName && isValid && isDICOM) {
      files = files.filter((file: { fileName: string }) => file.fileName === this.dicomdirFileName);
      this.filesFilter.valid = false;
    }

    return files;
  }

  /* private showHelpPanel() {
    // FIXME: To show checks beside completed tasks.
    this.howToBurnADisc.howToBurnADiscSteps.forEach(step => (step['completed'] = false));
    this.howToBurnADisc.howToBurnADiscSteps[0]['running'] = true;
    this.helpPanel.open();
    // Removed fileActionsMenu reference - no longer needed
  }
 */
  async deleteFolder(folder, event) {
    event.stopPropagation();

    const folderId = folder.folderId;

    if (!folder) return;

    if (!(await this.files_$.checkFolderIsEmpty(folderId))) {
      // You can not delete a folder that is not empty
      return;
    }

    if (folder.type !== 'folder') {
      this.selection.selected[0] = folder;
      this.openDeleteConfirmDialog();
    } else {
      // Remove folder
      this.files_$.deleteFolder(folderId).then(() => {
        this.uiMessaging_$.toastMessage('Folder deleted successfully, please refresh this list.', 'IMPORTANT');
        this.getFilesForPatient(this.currentFolder, this.getFilesForPatientOptions());
      });
    }
  }

  fileActionsEnabled() {
    return this.realRole !== this.UserRoles.consultant && UserRoles.client !== this.realRole;
    // return this.filesSelected() && this.realRole !== this.UserRoles.consultant && UserRoles.client !== this.realRole;
  }

  private discsFolderFlowRun(fileId?: string) {
    // discsFolderFlowRun
    if (fileId) {
      const res = this.selectFile(fileId);
      if (!res) this.uiMessaging_$.toastMessage('The file you are looking for is not in this folder.', 'ERROR');
      else {
        console.log('File selected');
        this.showFileActions('downloadDisc');
      }
    } else console.log('No file selected');
  }

  selectedIsZippedDisc() {
    const selectedFiles = this.selection.selected;
    const answer = selectedFiles.length === 1 && selectedFiles[0]?.DICOMDIRFileId;
    this.activateLastMenuItem(answer);
    return answer;
  }

  private activateLastMenuItem(answer: boolean) {
    if (answer) {
      setTimeout(() => {
        // Removed menu reference - no longer needed
      }, 100);
    }
  }

  showFileActions(action: string) {
    // Removed fileActionsMenu reference - no longer needed
  }

  hideFileActions() {
    // Removed fileActionsMenu reference - no longer needed
  }

  private async refreshCaseFolders() {
    this.caseFolders = await this.firebase_utilities_$.getFolders(this.casename, {
      ownerID: this.ownerID,
      userOwnerID: this.userOwnerID
    });
  }

  private selectFile(fileId: string) {
    const fileToSelect = this.filesTableDataSource.data.find(
      file => file.fileId === fileId || file.DICOMDIRFileId === fileId
    );

    if (!fileToSelect) {
      return false;
    }

    this.handleRowClick(fileToSelect, new Event('click'), { currentFolder: this.currentFolder });

    return fileToSelect;
  }

  private handleError = (error?) => {
    console.trace('Error generating the disc download link.', error);
    const errorMessage = 'Error generating the disc download link. Please try again or contact support@nuagedx.com.';
    if (!error) console.error(errorMessage);
    else console.error(errorMessage, error);
    this.uiMessaging_$?.toastMessage(errorMessage, 'ERROR');
  };

  generateDownloadDisc(fileSelected) {
    // this.showHelpPanel();

    this.gapiOperations_$.downloadDICOMFiles(fileSelected, this.auth_$.userData.getValue()['uid']).subscribe({
      next: (res: { message: string }) => {
        /**
         * NOTE: Please do not forget start the waiting UI notification at this point.
         * The user will be notified when the file is ready to be downloaded.
         * Please do not keep the user waiting for too long.
         * Please do not keep the user "WONDERING" about the status of the process.
         */
        this.startWaitingForDiscGeneration(fileSelected.fileId);
        this.sessionStorage_$.clearStoppedGeneratedDiscAlert();
      },
      error: (error: any) => {
        this.hideStartGeneratingDiscNotification(fileSelected.fileId);
        this.handleError(error);
      },
      complete: () => { }
    });
  }

  private async whenUnShareFilesAreDone(result, email) {
    const params = {
      email,
      casename: this.casename,
      files: result.join(', ')
    };
    this.sendFileUnSharingEmailNotification(params);
    this.handleStoreLog(result, email);
    this.getFilesForPatient(this.currentFolder, this.getOptions());
    this.evaluateConsultantsListsUpdate();
    await this.refreshAccordionFolders();
  }

  private async sendFileUnSharingEmailNotification(params: {
    email: string;
    casename: string;
    files: string;
  }): Promise<void> {
    const messageData = {
      targetEmail: params.email,
      caseName: params.casename,
      files: params.files
    };

    try {
      const result = await this.firebase_utilities_$.sendEmailNotification(messageData, 'unshare');
      // Unshare notification email sent successfully
    } catch (error) {
      console.error('Failed to send unshare notification email:', error);
    }
  }

  private async getRefreshOptions() {
    return {
      folderName: this.currentFolderName,
      caseFolders: await this.getCaseFolders(),
      roleConsultant: this.userIsConsultant,
      roleClient: this.userIsClient
    };
  }

  private getOwnerTotalStudies() {
    return this.firebase_utilities_$.getOwnerTotalStudies(this.patient.ownerID);
  }

  getOwnerPlanCode() {
    return this.patient.ownerPlanCode;
  }

  private markUserEmailSent(email) {
    return this.auth_$.markUserEmailSent(email);
  }

  async getDiagnoses() {
    return this.libraryFacade.getDiagnoses(this.casename);
  }

  openDiagnosis(_t324: any, $event: MouseEvent) {
    this.libraryFacade.openDiagnosis(_t324, $event);
  }

  async showDiagnosisDialog(_t324: any) {
    return this.libraryFacade.showDiagnosisDialog(_t324);
  }

  toggleDiagnosisContent(diagnosis) {
    diagnosis.expanded = !diagnosis.expanded;
  }

  updateFolderPath() {
    const level1 = this.caseFolders.find(folder => folder.folderId === this.currentFolder)?.parentFolder || '';
    const level2 = this.caseFolders.filter(folder => folder.parentFolder === level1).map(folder => folder.name);
    this.folderPath = { level1, level2 };
  }

  backToPatientProfile() {
    this.auth_$.setPatientProfile(this.patient);
    this.router.navigate(['/patient-overview', this.casename]);
  }

  async addFacilityConsultant() {
    const limits = await this.checkPlanLimits();
    const { CreateFacilityUserComponent } = await import('../create-facility-user/create-facility-user.component');
    const r_dialog = this.dialog_$.open(CreateFacilityUserComponent, {
      width: '680px',
      data: {
        userType: 'Admin',
        title: this.realRole === UserRoles.client ? 'Add an observer' : 'Create a Facility User',
        defaultValue: this.realRole === UserRoles.client ? 'consultant' : null,
        role: this.realRole,
        button: 'Create',
        screen: 'full',
        casename: this.casename,
        limits: { limits: limits }
      }
    });
    r_dialog.afterClosed().subscribe(async result => {
      if (result) {
        // Refresh all consultant and admin lists after creating a new user
        this.availableConsultants = await this.getAvailableConsultants();
        // await this.updateFacilityConsultantsLists();
        // await this.updateFacilityAdminsLists();
        // Trigger change detection to update the UI
        this.ref.detectChanges();
      }
    });
  }

  /**
   * Validates that casename is properly set and returns a valid string
   */
  private validateCasename(): string | null {
    if (!this.casename || this.casename === undefined || this.casename === null || this.casename === '') {
      console.warn('validateCasename: casename is invalid:', this.casename);
      return null;
    }

    const validCasename = String(this.casename).trim();
    if (!validCasename || validCasename === 'undefined' || validCasename === 'null') {
      console.warn('validateCasename: casename is invalid after conversion:', validCasename);
      return null;
    }

    return validCasename;
  }

  /**
   * Get consultant display name for accordion
   */
  private getConsultantDisplayNameForAccordion(consultantEmail: string): string {
    const consultant = this.findConsultantByEmail(consultantEmail);

    if (consultant) {
      const name = consultant.name || 'Unknown Name';
      const specialty = consultant.specialty || 'Unknown Specialty';
      const displayName = `${name} - ${specialty}`;
      return displayName;
    }

    // Fallback
    const parts = consultantEmail.split('@');
    const fallbackName = parts[0]
      ? parts[0].replace(/[._]/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      : consultantEmail;
    return fallbackName;
  }

  /**
   * Find consultant data by email from available consultants
   */
  /**
   * Finds a consultant by email from all known consultant lists.
   * Returns the consultant object if found, otherwise null.
   */
  private findConsultantByEmail(email: string): any {
    if (!email) return null;
    const allConsultants = [
      ...(this.activeConsultants || []),
      ...(this.availableConsultants || []),
      ...(this.originalUsersData?.activeConsultants || []),
      ...(this.originalUsersData?.availableConsultants || [])
    ];
    return this.clientProfileConsultantService.findConsultantByEmail(email, allConsultants);
  }

  /**
   * Updates consultant folders for the accordion component
   */

  /**
   * Updates facilitator folders for the accordion component
   * Groups files by facility name instead of individual facilitator emails
   */

  /**
   * Deactivates the active consultant, clears files selection and getFiles for the patient based on a folderId.
   * @param folderId if the folder you intend to browse.
   * @param folderName string name.
   */
  async browseConsultantFolderContents(folder, defaultSort?: string) {
    const { folderId, folderName, consultantEmail } = folder;
    this.selection.clear();
    this.auth_$.setCurrentFolder(folderName);

    this.startRefreshing();

    // Check if files are already loaded in the folder object
    if (folder.files && folder.files.length > 0) {
      // Use the files that are already loaded
      this.filesTableDataSource.data = this.files = folder.files;
    } else {
      // Load files shared with this consultant
      const sharedFiles = await this.firebase_utilities_$.getPatientSharedFilesByConsultant(
        this.casename,
        consultantEmail
      );

      this.filesTableDataSource.data = this.files = sharedFiles;
    }

    this.updatePage(this.files, folderId, folderName);
    this.stopRefreshing();

    if (defaultSort) {
      this.handleSortData({ active: defaultSort, direction: 'desc' });
    }

    if (!this.userIsConsultant) {
      // this.updateFacilityAdminsLists();
      // this.updateFacilityConsultantsLists();
    }

    if (this.currentFolderName === DISCS_FOLDER_NAME) {
      this.sortTypes = this.sortTypes.filter(sort => !['ftype', 'lastModified'].includes(sort.value));
      this.sortTypes.find(sort => sort.value === 'uploadedDate').label = 'Date Created';
    }
  }

  // Add method to toggle breadcrumb collapse (add this method near the end of the class)
  toggleBreadcrumbCollapse() {
    this.breadcrumbCollapsed = !this.breadcrumbCollapsed;
  }

  toggleMainTabGroupCollapse() {
    this.mainTabGroupCollapsed = !this.mainTabGroupCollapsed;
  }

  /**
   * Normalize a facility identifier or name into a comparable slug.
   */
  private normalizeFacilityIdentifier(value: unknown): string {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-]/g, '');
  }

  /**
   * Returns true if the given user's facility matches the selected facility
   * considering both ID and human-readable name (case/format insensitive).
   */
  private isFacilityMatch(userFacility: unknown, selectedFacilityIdOrName: unknown): boolean {
    const userNorm = this.normalizeFacilityIdentifier(userFacility);
    const selectedNorm = this.normalizeFacilityIdentifier(selectedFacilityIdOrName);

    // Attempt to resolve the selected facility against the known facilities
    const facilityObj = this.facilities?.find(
      f =>
        this.normalizeFacilityIdentifier(f.id) === selectedNorm ||
        this.normalizeFacilityIdentifier(f.name) === selectedNorm
    );

    const idNorm = this.normalizeFacilityIdentifier(facilityObj?.id);
    const nameNorm = this.normalizeFacilityIdentifier(facilityObj?.name);

    return userNorm === selectedNorm || userNorm === idNorm || userNorm === nameNorm;
  }

  async updateConsultantsLists() {
    if (this.currentFolder === '') {
      return;
    }

    // FIXME: Get the list of active consultants doesn't get all.
    this.activeConsultants = await this.firebase_utilities_$.getActiveConsultantsAndClientByClientId(
      [UserRoles.consultant, UserRoles.client],
      this.casename,
      this.ownerID,
      this.files
    );

    this.availableConsultants = await this.firebase_utilities_$.getAvailableConsultantsAndClient(
      this.casename,
      UserRoles.consultant,
      this.activeConsultants,
      true
    );
  }

  getAvailableFacilityConsultants(arg0: boolean): any[] | PromiseLike<any[]> {
    return this.firebase_utilities_$.getActiveFaciltiesConsultantsAndClientByClientId(
      [UserRoles.consultant, UserRoles.client],
      this.casename,
      this.ownerID,
      this.files
    );
  }

  backToOverview() {
    // Close the ClientProfile component.
    this.dialogRef.close();
    this.auth_$.setPatientProfile(this.patient);
    // Navigate to the ClientProfile component.
    this.router.navigate(['/patient-overview', this.casename]);
  }
  /**
   * This is used to update the facilities users list: Active and Available.
   * It's called when the user clicks on the facilities tab.
   * It's also called when the user clicks on the folder.
   */
  async updateFacilitiesConsultantsLists() {
    if (this.currentFolder === '') {
      return;
    }

    // Get all active facility consultants (without filtering initially)

    // const ownerID = this.ownerID;
    const ownerID = null;

    const allActiveConsultants = await this.firebase_utilities_$.getActiveFaciltiesConsultantsAndClientByClientId(
      [UserRoles.consultant, UserRoles.client],
      this.casename,
      ownerID,
      this.files
    );

    // Store the complete list in originalUsersData for filtering
    this.originalUsersData.activeConsultants = allActiveConsultants || [];

    // Get all available facility consultants (without filtering initially)
    const allAvailableConsultants = await this.firebase_utilities_$.getAvailableAdmins(
      this.casename,
      UserRoles.consultant,
      allActiveConsultants,
      true,
      ownerID
    );

    // Store the complete list in originalUsersData for filtering
    this.originalUsersData.availableConsultants = allAvailableConsultants || [];

    // Get all active facility admins (without filtering initially)
    const allActiveAdmins = await this.firebase_utilities_$.getActiveFaciltiesConsultantsAndClientByClientId(
      [UserRoles.admin],
      this.casename,
      ownerID,
      this.files
    );

    // Store the complete list in originalUsersData for filtering
    this.originalUsersData.activeAdmins = allActiveAdmins || [];

    // Get all available facility admins (without filtering initially)
    const allAvailableAdmins = await this.firebase_utilities_$.getAvailableAdmins(
      this.casename,
      UserRoles.admin,
      allActiveAdmins,
      true,
      ownerID
    );

    // Store the complete list in originalUsersData for filtering
    this.originalUsersData.availableAdmins = allAvailableAdmins || [];
  }

  /**
   * Remove folder filter and restore original files
   */
  removeFolderFilter() {
    if (this.isFiltered && this.originalFiles.length > 0) {
      // Restore original files
      this.files = [...this.originalFiles]; // Create a deep copy of current files

      // Use the same pattern as updateDataTable() method
      this.sortedData = this.files.slice();
      this.filesTableDataSource.data = this.files;
      this.updatePaginator();

      if (this.filesTableDataSource.paginator) {
        this.filesTableDataSource.paginator.firstPage();
      }

      this.ref.detectChanges();
      this.selection.clear();
      this.refreshButton = true;
      this.refreshing = false;

      // Update page size
      this.setPageSize(this.files.length);

      // Reset filter state
      this.isFiltered = false;
      this.originalFiles = [];

      console.log('Folder filter removed, original files restored');
    }
  }

  getAvailableFacilityAdmins(arg0: boolean): any {
    throw new Error('Method not implemented.');
  }
  getActiveFacilityAdmins(): any {
    throw new Error('Method not implemented.');
  }

  getActiveFacilityConsultants(): any {
    return this.firebase_utilities_$.getActiveFaciltiesConsultantsAndClientByClientId(
      [UserRoles.consultant, UserRoles.client],
      this.casename,
      this.ownerID,
      this.files
    );
  }

  filterByFolder(event: any) {
    console.log('filterByFolder: ', event);

    // Handle both string (folderId) and object ({ folderId }) formats
    let folderId: string;

    if (typeof event === 'string') {
      folderId = event;
    } else if (event && event.folderId) {
      folderId = event.folderId;
    } else {
      // If no valid folderId, remove filter and restore original files
      this.removeFolderFilter();
      return;
    }

    // If this is the first time filtering, save the original files
    if (!this.isFiltered) {
      this.originalFiles = [...this.files]; // Create a deep copy of current files
      this.isFiltered = true;
    }

    // Filter files by parentFolder
    const filteredFiles = this.originalFiles.filter(file => {
      // Check if file belongs to the selected folder
      return (
        file.parentFolder === folderId ||
        (file.parentFolders && file.parentFolders.some((folder: { folderId: string }) => folder.folderId === folderId))
      );
    });

    // Update the files array with filtered results
    this.files = filteredFiles;

    // Use the same pattern as updateDataTable() method
    this.sortedData = this.files.slice();
    this.filesTableDataSource.data = this.files;
    this.updatePaginator();

    if (this.filesTableDataSource.paginator) {
      this.filesTableDataSource.paginator.firstPage();
    }

    this.ref.detectChanges();
    this.selection.clear();
    this.refreshButton = true;
    this.refreshing = false;

    // Update page size
    this.setPageSize(this.files.length);

    console.log(`Filtered ${this.files.length} files for folder: ${folderId}`);

    // Update the breadcrumbs, setting the filter as applied
    this.topMenuData.clearFilterButton = true;
  }

  /**
   * Build hierarchical folder structure from flat folder list
   * @param folders Array of folder objects with parentFolder property
   * @returns Array of all folders with proper hierarchy (flattened for accordion service)
   */
  private buildFolderHierarchy(folders: any[]): any[] {
    // Create a map for quick lookup
    const folderMap = new Map<string, any>();
    const rootFolders: any[] = [];

    // First pass: create map and identify root folders
    folders.forEach(folder => {
      const folderWithHierarchy = {
        ...folder,
        children: [],
        parentId: folder.parentFolder || null, // Use parentId for accordion service
        level: 0 // Will be set correctly in the hierarchy building
      };
      folderMap.set(folder.id, folderWithHierarchy);

      // If no parentFolder or parentFolder is empty/null, it's a root folder
      if (!folder.parentFolder || folder.parentFolder === '' || folder.parentFolder === null) {
        rootFolders.push(folderMap.get(folder.id));
      }
    });

    // Second pass: assign children to their parents and set levels
    folders.forEach(folder => {
      if (folder.parentFolder && folder.parentFolder !== '' && folder.parentFolder !== null) {
        const parent = folderMap.get(folder.parentFolder);
        const child = folderMap.get(folder.id);

        if (parent && child) {
          // Set the child's level based on parent's level
          child.level = (parent.level || 0) + 1;
          parent.children.push(child);
          console.log(
            `🏗️ Added child "${child.name}" (level ${child.level}) to parent "${parent.name}" (level ${parent.level || 0})`
          );
        } else {
          console.warn(`🏗️ Could not find parent "${folder.parentFolder}" for child "${folder.name}"`);
          // If parent not found, treat as root folder
          child.level = 0;
          rootFolders.push(child);
        }
      }
    });

    // Set levels for root folders
    rootFolders.forEach(folder => {
      folder.level = 0;
      this.setChildrenLevels(folder, 1);
    });

    return rootFolders;
  }

  /**
   * Recursively set levels for all children in a folder hierarchy
   */
  private setChildrenLevels(folder: any, level: number): void {
    folder.children.forEach((child: any) => {
      child.level = level;
      if (child.children && child.children.length > 0) {
        this.setChildrenLevels(child, level + 1);
      }
    });
  }

  /**
   * Returns folders formatted for the accordion component.
   *
   * - Always includes INDEX folder as the first (root) folder.
   * - Flattens and formats each folder in `caseFolders`.
   * - Supports both consultant folders and regular folders.
   * - Automatically organizes the folders into a hierarchy using parentFolder references.
   *
   * @returns Promise<any[]> Array of formatted folder objects, with hierarchy and INDEX prepended.
   */
  async getHomeFoldersForAccordion(userOwnerID: string): Promise<any[]> {
    // Clear any cached accordion folders
    this._cachedAccordionFolders = [];

    // Build array of folder objects from caseFolders, if available
    const folderObjs: any[] = this.caseFolders?.length
      ? await Promise.all(
        this.caseFolders.map(async folder => {
          // For consultant folders, folderId includes '@'
          const isConsultant = !!folder.folderId?.includes('@');
          return {
            name: isConsultant ? this.getConsultantDisplayNameForAccordion(folder.folderId) : folder.name,
            id: folder.folderId,
            predefined: folder.predefined,
            color: folder.color,
            parentFolder: folder.parentFolder || null,
            children: [],
            hasNotifications: false,
            count: await this.getFolderFileCount(folder.folderId, this.ownerID, userOwnerID),
            type: isConsultant ? 'consultant' : 'folder',
            consultantEmail: isConsultant ? folder.folderId : undefined,
            files: []
          };
        })
      )
      : [];

    // Organize into hierarchy, or return empty if no folders
    let folders: any[] = this.buildFolderHierarchy(folderObjs);

    // Always prepend the root INDEX folder
    folders.unshift({
      name: 'INDEX',
      id: INDEX_FOLDER_NAME,
      color: indexFolderColor,
      predefined: true,
      children: [],
      hasNotifications: false,
      count: await this.getFolderFileCount(INDEX_FOLDER_NAME, this.ownerID, this.userOwnerID),
      type: 'folder',
      parentFolder: null
    });

    return folders;
  }

  private findFolderInHierarchy(folders: any[], folderId: string): boolean {
    for (const folder of folders) {
      if (folder.id === folderId) {
        return true;
      }
      if (folder.children && folder.children.length > 0) {
        if (this.findFolderInHierarchy(folder.children, folderId)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get the file count for a folder as a string.
   */
  private async getFolderFileCount(folderId: string, ownerID?: string, userOwnerID?: string): Promise<string> {
    if (!this.casename) {
      console.error('getFolderFileCount: this.casename is undefined');
      return '0';
    }

    const getUserEmail = (): string => this.auth_$.userData.getValue()['email'] || '';

    if (folderId === INDEX_FOLDER_NAME) {
      // Use local files array if possible
      if (this.files?.length) return this.files.length.toString();

      await this.refreshAllFiles();
      if (this.allFiles?.length) return this.allFiles.length.toString();

      // Fallback to remote count
      const totalCount = await this.getFilesCountByClient(this.casename, this.userIsConsultant, getUserEmail());
      return totalCount.toString();
    }

    // For all other folders, use remote service
    const count = await this.firebase_utilities_$.getNumberOfFilesByFolderId(
      folderId,
      this.userIsConsultant ? 'Consultant' : undefined,
      getUserEmail(),
      null,
      userOwnerID
    );
    return count.replace(/[()]/g, '');
  }

  /**
   * Force refresh the INDEX folder count specifically
   * This method ensures the INDEX folder count is updated immediately after file upload
   */
  private async forceRefreshIndexFolderCount(): Promise<void> {
    try {
      // Get the current accordion folders
      const currentFolders = this.accordionDataService.getCurrentFolders();

      // Find the INDEX folder
      const indexFolder = currentFolders.find(folder => folder.id === INDEX_FOLDER_NAME);

      if (indexFolder) {
        // Try multiple approaches to get the updated count
        let updatedCount = '';

        // Method 1: Use the getFolderFileCount method which now uses allFiles array directly
        try {
          updatedCount = await this.getFolderFileCount(INDEX_FOLDER_NAME, this.ownerID, this.userOwnerID);

          // If we got a count, verify it's not the same as before
          if (updatedCount && updatedCount === indexFolder.count) {
            console.log('getFolderFileCount unchanged, trying Method 2...');
            updatedCount = ''; // Reset to try next method
          }
        } catch (error) {
          console.error('Method 1 failed:', error);
        }

        // Method 3: Direct query to get files count
        if (!updatedCount || updatedCount === '0') {
          try {
            const userData = this.auth_$.userData.value;
            const userEmail =
              userData && typeof userData === 'object' && 'email' in userData ? (userData as any).email : '';

            // Direct query to get all files for this case
            const files = await this.files_$.getFilesByCaseName(this.casename, true);
            const fileCount = files.filter(({ type }) => type !== 'folder').length;

            if (this.userIsConsultant) {
              const consultantFiles = files.filter(
                ({ sharedUsers }) => sharedUsers && sharedUsers.some(h => h.email === userEmail)
              );
              updatedCount = consultantFiles.filter(({ type }) => type !== 'folder').length.toString();
            } else {
              updatedCount = fileCount.toString();
            }
          } catch (error) {
            console.error('Method 2 failed:', error);
          }
        }

        // Method 4: Use the allFiles array if available (fallback)
        if (!updatedCount || updatedCount === '0') {
          try {
            if (this.allFiles && this.allFiles.length > 0) {
              updatedCount = this.allFiles.length.toString();
              console.log('Method 3 - Using allFiles array count:', updatedCount);
            }
          } catch (error) {
            console.error('Method 3 failed:', error);
          }
        }

        if (updatedCount && updatedCount !== '0' && updatedCount !== indexFolder.count) {
          // Create a new folder object with the updated count to ensure change detection
          const updatedIndexFolder = {
            ...indexFolder,
            count: updatedCount
          };

          // Update the accordion data service with the new folder object
          this.accordionDataService.updateFolder(updatedIndexFolder);

          // Force change detection in the current component
          this.ref.detectChanges();

          // Also trigger change detection in the accordion component if available
          if (this.homeFoldersAccordion && this.homeFoldersAccordion['ref']) {
            this.homeFoldersAccordion['ref'].detectChanges();
          }

          // Direct update to accordion component if available
          if (this.homeFoldersAccordion && this.homeFoldersAccordion.accordionFolders) {
            const folder = this.homeFoldersAccordion.accordionFolders.find(f => f.id === INDEX_FOLDER_NAME);
            if (folder) {
              folder.count = updatedCount;

              // Force change detection on the accordion component
              if (this.homeFoldersAccordion['ref']) {
                this.homeFoldersAccordion['ref'].detectChanges();
              }
            }
          }

          // Double-check the update was applied
          const verifyFolders = this.accordionDataService.getCurrentFolders();
          const verifyIndexFolder = verifyFolders.find(folder => folder.id === INDEX_FOLDER_NAME);

          // Additional verification: check if the observable has been updated
          setTimeout(() => {
            const finalCheckFolders = this.accordionDataService.getCurrentFolders();
            const finalCheckIndexFolder = finalCheckFolders.find(folder => folder.id === INDEX_FOLDER_NAME);
          }, 100);
        } else {
          console.warn('Could not get valid count for INDEX folder');
        }
      } else {
        console.warn('INDEX folder not found in accordion folders');
      }
    } catch (error) {
      console.error('Error force refreshing INDEX folder count:', error);
    }
  }

  /**
   * Force refresh the target folder count specifically
   * This method ensures the target folder count is updated immediately after file upload
   */
  private async forceRefreshTargetFolderCount(folderId: string): Promise<void> {
    try {
      console.log('Force refreshing target folder count for:', folderId);

      // Get the current accordion folders
      const currentFolders = this.accordionDataService.getCurrentFolders();

      // Find the target folder
      const targetFolder = currentFolders.find(folder => folder.id === folderId);

      if (targetFolder) {
        // Get the updated count for target folder
        const updatedCount = await this.getFolderFileCount(folderId, this.ownerID, this.userOwnerID);

        // Update the target folder count
        targetFolder.count = updatedCount;

        // Update the accordion data service
        this.accordionDataService.updateFolder(targetFolder);

        // Force change detection
        this.ref.detectChanges();

        console.log('Target folder count updated to:', updatedCount);
      } else {
        console.warn('Target folder not found in accordion folders:', folderId);
      }
    } catch (error) {
      console.error('Error force refreshing target folder count:', error);
    }
  }

  /**
   * Public method to manually trigger folder count updates
   * This can be called from the browser console for debugging
   */
  public async manualRefreshFolderCounts(): Promise<void> {
    try {
      await this.refreshAllFiles();
      await this.refreshAccordionFolders();
      if (!this.isSpoke) {
        await this.forceRefreshIndexFolderCount();
      }
    } catch (error) {
      console.error('Error in manual refresh:', error);
    }
  }
  /**
   * Handle folder click from accordion component
   */
  // Track the last clicked folder to prevent duplicate handling
  private lastClickedFolderId: string | null = null;
  private lastClickedTime: number = 0;

  handleAccordionFolderClick(folder: any): void {
    const now = Date.now();

    // Prevent duplicate calls for the same folder within 100ms
    if (this.lastClickedFolderId === folder.id && now - this.lastClickedTime < 100) {
      return;
    }

    this.lastClickedFolderId = folder.id;
    this.lastClickedTime = now;

    // Set the current folder name when a folder is clicked
    // The allFoldersClosed event will handle clearing it when all folders are closed
    this.currentFolderName = folder.name;

    // For consultant folders, we don't need to call the old handleFolderClick
    // since the accordion system is now handling the file loading properly
    if (false) {
      // Consultant folders are no longer supported
      return;
    }

    // For regular folders, we should NOT call the old handleFolderClick method
    // because it triggers browseFolderContents which calls refreshAccordionFolders
    // and overrides the expansion state that was set by the accordion component.
    // The accordion component handles file loading through the loadFolderContents event.

    // Only update the UI state without triggering the old folder browsing logic
    this.currentFolder = folder.id;
    this.topMenuData.currentFolderName = folder.name;
    this.topMenuData.currentFolder = folder.id;
  }

  /**
   * Handle file click from accordion component
   */
  handleAccordionFileClick(file: any): void {
    // Create a mock event object that matches what handleFileClick expects
    const mockEvent = {
      stopPropagation: () => { },
      preventDefault: () => { }
    };

    // Create a file element that matches what handleFileClick expects
    const fileElement = {
      fileId: file.fileId,
      fileName: file.fileName,
      fileDesc: file.fileDesc,
      lastModified: file.lastModified,
      uploadedDate: file.uploadedDate,
      fdate: file.fdate,
      type: file.type,
      hasNotifications: file.hasNotifications,
      ftype: file.ftype || file.type, // Add ftype property, fallback to type if not available
      storageBucket: file.storageBucket || file.storename || '', // Add storageBucket property
      viewerurl: file.viewerurl, // Add viewerurl for DICOM files
      filePath: file.filePath, // Add filePath if available
      parentFolder: file.parentFolder || file.parentFolderName, // Add parent folder info
      color: file.color, // Add color info
      style: file.style // Add style info
    };

    this.handleFileClick(mockEvent, fileElement);
  }
  /**
   * Handle when all folders are closed in accordion
   */
  handleAllFoldersClosed(): void {
    // Clear the current folder name when all folders are closed
    this.currentFolderName = '';
    this.currentFolder = '';
    this.topMenuData.currentFolderName = '';
    this.topMenuData.currentFolder = '';
  }

  /**
   * Handle loading folder contents for accordion component
   */
  async handleLoadFolderContents(folderId: string): Promise<void> {
    try {
      // Check if this is a consultant folder by looking for it in the accordion folders
      // const folder = this.accordionDataService.getCurrentFolders().find(f => f.id === folderId);

      // This is a regular folder - use the existing logic
      let files: any[] = [];

      if (folderId === 'all') {
        // Special handling for INDEX folder - get all files
        console.log('Loading INDEX folder contents (all files)');
        files = await this.getPatientsFilesArray('all', this.userIsConsultant, this.caseFolders, this.userOwnerID);
      } else {
        // Regular folder handling
        const folderName = this.getFolderNameById(folderId);
        if (!folderName) {
          console.error('Folder name not found for ID:', folderId);
          return;
        }

        // Get files for the specific folder using getPatientsFilesArray directly
        files = await this.getPatientsFilesArray(folderId, this.userIsConsultant, this.caseFolders, this.userOwnerID);
      }

      // Convert files to the format expected by the accordion component
      const accordionFiles = files.map(file => {
        // Get the proper color for the file based on its parent folder
        const fileColor = this.getFolderColorForFile(file);

        return {
          fileName: file.fileName || file.name || '',
          fileDesc: file.fileDesc || file.description || '',
          lastModified: file.lastModified || file.uploadedDate || '',
          uploadedDate: file.uploadedDate || file.createdDate || '',
          fdate: file.fdate || file.date || '',
          ftime: file.ftime || file.time || '',
          type: file.type || file.ftype || 'file',
          ftype: file.ftype || file.type || '',
          fileId: file.fileId || file.id || '',
          hasNotifications: file.hasNotifications || false,
          hasCommentAttachments: file.notes && file.notes.length > 0,
          parentFolderName: file.parentFolderName || file.parentFolder || '',
          parentFolder: file.parentFolder || file.folderId || '',
          color: fileColor,
          ownerID: file.ownerID || '',
          style: file.style || {},
          viewerurl: file.viewerurl || file.viewerUrl || '',
          sharedUsers: file.sharedUsers || [],
          storename: file.storename || file.storeName || '',
          filePath: file.filePath || ''
        };
      });

      // Update the accordion folder with the loaded files
      this.updateAccordionFolderContents(folderId, accordionFiles);
    } catch (error) {
      console.error('Error loading folder contents:', error);
      // Handle error - set empty array and stop loading
      this.updateAccordionFolderContents(folderId, []);
    }
  }

  /**
   * Get folder name by ID
   */
  private getFolderNameById(folderId: string): string {
    // First try to find in foldersStructure.children
    if (this.foldersStructure && this.foldersStructure.children) {
      const folder = this.foldersStructure.children.find(f => f.id === folderId);
      if (folder) {
        console.log(`Found folder in foldersStructure: ${folder.name} for ID: ${folderId}`);
        return folder.name;
      }
    }

    // Fallback: look in caseFolders for newly created folders
    if (this.caseFolders && this.caseFolders.length > 0) {
      const folder = this.caseFolders.find(f => f.folderId === folderId);
      if (folder) {
        console.log(`Found folder in caseFolders: ${folder.name} for ID: ${folderId}`);
        return folder.name;
      }
    }

    console.warn(`Folder not found for ID: ${folderId} in both foldersStructure and caseFolders`);
    return '';
  }

  /**
   * Update accordion folder contents
   */
  private updateAccordionFolderContents(folderId: string, files: any[]): void {
    console.log('Updating accordion folder contents for:', folderId, 'with', files.length, 'files');
    // Use the accordion data service to update the folder contents
    this.accordionDataService.updateFolderFiles(folderId, files);
  }

  /**
   * Clear accordion cache when folder data changes
   */
  private clearAccordionCache(): void {
    this._cachedAccordionFolders = [];
  }

  private async getNamedFolders(params, useremail, filesShared) {
    let folderList = (await this.getFolders(params, useremail, filesShared, this.files)).map(
      (g: { fileName: string; type: string; name: string; color: string }) => {
        return {
          ...g,
          name: g.fileName,
          style:
            g.type === 'folder'
              ? this.utils_$.getButtonStyle(g.name, g.color)
              : this.utils_$.getButtonStyle(g.name, g.color)
        };
      }
    );
    // Sort the folders
    folderList = folderList.sort();
    return folderList;
  }

  // Recursively format folders while preserving hierarchy
  private formatFolder(folder: any): any {
    const formattedFolder = {
      id: folder.id,
      name: folder.name,
      predefined: folder.predefined,
      color: folder.color,
      hasNotifications: folder.hasNotifications,
      count: folder.count,
      type: folder.type,
      restricted_to: folder.restricted_to,
      expanded: false,
      loading: false,
      files: null,
      consultantEmail: folder.consultantEmail || undefined,
      children: []
    };

    // Recursively format children
    if (folder.children && folder.children.length > 0) {
      formattedFolder.children = folder.children.map((child: any) => this.formatFolder(child));
    }

    return formattedFolder;
  }

  /**
   * Initialize accordion data service with folders
   */
  private async initializeAccordionData(): Promise<void> {
    const formattedFolders = (await this.getHomeFoldersForAccordion(this.userOwnerID)).map(folder =>
      this.formatFolder(folder)
    );

    // Set the public property for template binding
    // Keep the hierarchical structure for proper display
    this.setAccordionFolders(formattedFolders);
    this.accordionDataService.setFolders(formattedFolders);

    // Set the hierarchical folders for the accordion component
    this.hierarchicalFolders = formattedFolders;
  }

  // Debounce mechanism to prevent multiple rapid calls
  private refreshAccordionFoldersTimeout: any = null;
  private isRefreshingAccordion = false;

  /**
   * Refresh accordion folders with updated file counts
   */
  public async refreshAccordionFolders(): Promise<void> {
    // Clear any pending refresh
    if (this.refreshAccordionFoldersTimeout) {
      clearTimeout(this.refreshAccordionFoldersTimeout);
    }

    // If already refreshing, skip this call
    if (this.isRefreshingAccordion) {
      return;
    }

    // Debounce the refresh to prevent multiple rapid calls
    return new Promise<void>(resolve => {
      this.refreshAccordionFoldersTimeout = setTimeout(async () => {
        try {
          this.isRefreshingAccordion = true;

          // Get current expansion states before refreshing
          const currentFolders = this.accordionDataService.getCurrentFolders();
          const expansionStates = new Map<string, boolean>();
          currentFolders.forEach(folder => {
            expansionStates.set(folder.id, folder.expanded || false);
          });

          // Get new folders with updated counts
          const newFolders = await this.getHomeFoldersForAccordion(this.userOwnerID);

          // Recursively preserve expansion states and files while maintaining hierarchy
          const preserveFolderState = (folder: any): any => {
            const existingFolder = currentFolders.find(f => f.id === folder.id);
            const preservedFolder = {
              ...folder,
              expanded: existingFolder ? expansionStates.get(folder.id) || false : false,
              files: existingFolder ? existingFolder.files || null : null,
              loading: existingFolder ? existingFolder.loading || false : false,
              refreshing: existingFolder ? existingFolder.refreshing || false : false,
              children: []
            };

            // Recursively process children
            if (folder.children && folder.children.length > 0) {
              preservedFolder.children = folder.children.map((child: any) => preserveFolderState(child));
            }

            return preservedFolder;
          };

          const updatedFolders = newFolders.map(folder => preserveFolderState(folder));

          // Set the hierarchical structure directly in the accordion service
          this.accordionDataService.setFolders(updatedFolders);

          // Update the hierarchical folders for the accordion component
          this.hierarchicalFolders = updatedFolders;

          resolve();
        } catch (error) {
          console.error('Error in refreshAccordionFolders:', error);
          resolve(); // Don't throw the error to prevent breaking the deletion flow
        } finally {
          this.isRefreshingAccordion = false;
        }
      }, 100); // 100ms debounce delay
    });
  }

  // Core selection handling method
  async handleAccordionSelectionChange(event: any) {
    if (!event || !event.folderId) {
      return;
    }

    // Ensure allFiles is populated before processing selections
    await this.ensureAllFilesPopulated();

    // Update the selection for this specific folder
    const folderSelection = new Set<string>();
    if (event.selectedFiles && Array.isArray(event.selectedFiles)) {
      event.selectedFiles.forEach(file => {
        const fileId = file.fileId || file.id;
        if (fileId) {
          folderSelection.add(fileId);
        }
      });
    }
    this.folderSelections.set(event.folderId, folderSelection);

    // Get all selected files from all folders (this automatically prevents duplicates)
    const allSelectedFiles = this.getAllSelectedFilesFromAllFolders();

    // Update selectedFilesForAccordion with all selected files
    this.selectedFilesForAccordion = allSelectedFiles.map(file => ({
      id: file.fileId || file.id,
      fileName: file.fileName,
      fileType: file.type || file.fileType,
      fileContent: file.fileDesc || file.fileContent,
      dateOfFile: file.fdate || file.dateOfFile,
      lastModified: file.lastModified,
      dateUploaded: file.uploadedDate || file.dateUploaded,
      fileFolderName:
        file.parentFolderName || file.fileFolderName || this.getFolderNameById(this.getFileFolderId(file)),
      folderColor: this.getFolderColorForFile(file),
      selectionStatus: 'Selected',
      actions: ['edit', 'delete'],
      sharedUsers: file.sharedUsers || []
    }));

    // Update the selection model to include all selected files
    this.selection = new SelectionModel<any>(true, []);
    let foundFiles = 0;
    this.selectedFilesForAccordion.forEach(file => {
      const originalFile = this.findOriginalFileById(file.id);
      if (originalFile) {
        this.selection.select(originalFile);
        foundFiles++;
      } else {
        console.warn(`Could not find original file for ID: ${file.id}, fileName: ${file.fileName}`);
      }
    });

    console.log(
      `Selection update: selectedFilesForAccordion.length=${this.selectedFilesForAccordion.length}, selection.selected.length=${this.selection.selected.length}, foundFiles=${foundFiles}`
    );

    this.ref.detectChanges();
  }

  /**
   * Find the original file object by ID from all available files
   */
  private findOriginalFileById(fileId: string): any {
    if (!fileId) {
      console.warn('findOriginalFileById called with empty fileId');
      return null;
    }

    // Check in indexFiles (INDEX folder)
    let file = this.indexFiles.find(f => (f.fileId || f.id) === fileId);
    if (file) {
      console.log('File found in indexFiles:', file.fileName || file.fileId);
      return file;
    }

    // Check in global files
    file = this.files.find(f => (f.fileId || f.id) === fileId);
    if (file) {
      console.log('File found in files:', file.fileName || file.fileId);
      return file;
    }

    // Check in allFiles (INDEX folder files)
    file = this.allFiles.find(f => (f.fileId || f.id) === fileId);
    if (file) {
      console.log('File found in allFiles:', file.fileName || file.fileId);
      return file;
    }

    // Check in accordion folders
    for (const folder of this.accordionFolders) {
      if (folder.files && Array.isArray(folder.files)) {
        file = folder.files.find(f => (f.fileId || f.id) === fileId);
        if (file) {
          console.log('File found in accordion folder:', folder.name, file.fileName || file.fileId);
          return file;
        }
      }
    }

    console.warn('File not found in any array:', fileId);
    console.log('Available arrays:', {
      indexFiles: this.indexFiles.length,
      files: this.files.length,
      allFiles: this.allFiles.length,
      accordionFolders: this.accordionFolders.length
    });
    return null;
  }

  /**
   * Manually refresh the allFiles variable with current INDEX folder files
   * This method can be called when you need to ensure allFiles is up to date
   */
  async refreshAllFiles(): Promise<void> {
    if (this.casename) {
      await this.getFilesIndexFolder({
        casename: this.casename,
        roleConsultant: this.userIsConsultant,
        userOwnerID: this.auth_$.userData.value['ownerID']
      });
      // Note: allFiles is already updated in getFilesIndexFolder method
      // Consultant folders are also updated in getFilesIndexFolder method
    }
  }

  /**
   * Ensure allFiles is populated with INDEX folder files
   * This method can be called to populate allFiles if it's empty
   */
  async ensureAllFilesPopulated(): Promise<void> {
    if (this.allFiles.length === 0 && this.casename) {
      await this.refreshAllFiles();
    }
  }

  /**
   * Get the current status of allFiles for debugging
   */
  getAllFilesStatus(): { length: number; populated: boolean; casename: string } {
    return {
      length: this.allFiles.length,
      populated: this.allFiles.length > 0,
      casename: this.casename || 'not set'
    };
  }

  // Toggle methods for collapsible sections
  togglePatientInfo() {
    this.patientInfoCollapsed = !this.patientInfoCollapsed;
    this.saveLayoutPreferences();
  }

  toggleTopActions() {
    this.topActionsCollapsed = !this.topActionsCollapsed;
    this.saveLayoutPreferences();
  }

  // Keyboard shortcuts for improved UX
  @HostListener('keydown', ['$event'])
  handleKeyboardShortcuts(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey) {
      switch (event.key.toLowerCase()) {
        case 'u': // Ctrl+U for upload
          event.preventDefault();
          if (this.permissions_uploadfiles && this.isClientAndNotUploadsFolder) {
            this.openDialog(null);
          }
          break;
        case 'r': // Ctrl+R for refresh (prevent browser refresh)
          if (!event.shiftKey) {
            event.preventDefault();
            this.handleRefresh();
          }
          break;
        case 't': // Ctrl+T for toggle table
          event.preventDefault();
          this.dataTableCollapsed = !this.dataTableCollapsed;
          this.saveLayoutPreferences();
          break;
        case 'p': // Ctrl+P for toggle patient info
          event.preventDefault();
          this.togglePatientInfo();
          break;
        case 'h': // Ctrl+H for toggle right panel
          event.preventDefault();
          // this.rightPanelCollapsed = !this.rightPanelCollapsed;
          this.saveLayoutPreferences();
          break;
      }
    }
  }

  // Layout preferences persistence
  saveLayoutPreferences() {
    const preferences = {
      dataTableCollapsed: this.dataTableCollapsed,
      // rightPanelCollapsed: this.rightPanelCollapsed,
      patientInfoCollapsed: this.patientInfoCollapsed,
      topActionsCollapsed: this.topActionsCollapsed,
      breadcrumbCollapsed: this.breadcrumbCollapsed
    };
    try {
      localStorage.setItem('clientProfileLayout', JSON.stringify(preferences));
    } catch (error) {
      console.warn('Could not save layout preferences:', error);
    }
  }

  /**
   * Load layout preferences from localStorage
   * Used to restore the layout preferences when the page is reloaded
   * For example, if the user collapses the patient info section, this will restore it to the collapsed state when the page is reloaded
   * This is also used to restore the layout preferences when the user navigates to the client profile page from the home page
   * The variables updated are:
   * - dataTableCollapsed
   * - patientInfoCollapsed
   * - topActionsCollapsed
   * - breadcrumbCollapsed
   */
  loadLayoutPreferences(): void {
    try {
      const preferences = JSON.parse(localStorage.getItem('clientProfileLayout') || '{}');
      this.dataTableCollapsed = preferences.dataTableCollapsed ?? true;
      // this.rightPanelCollapsed = preferences.rightPanelCollapsed ?? false;
      this.patientInfoCollapsed = preferences.patientInfoCollapsed ?? false;
      this.topActionsCollapsed = preferences.topActionsCollapsed ?? false;
      this.breadcrumbCollapsed = preferences.breadcrumbCollapsed ?? false;
    } catch (error) {
      console.warn('Could not load layout preferences:', error);
    }
  }

  // Check if user can upload files
  get isClientAndNotUploadsFolder(): boolean {
    return this.permissions_uploadfiles && this.currentFolderName !== '' && this.realRole !== 'Consultant';
  }

  /**
   * Get comprehensive status of all file arrays for debugging
   */
  getFileArraysStatus(): {
    indexFiles: number;
    files: number;
    allFiles: number;
    accordionFolders: number;
    totalFilesInAccordion: number;
  } {
    let totalFilesInAccordion = 0;
    this.accordionFolders.forEach(folder => {
      if (folder.files && Array.isArray(folder.files)) {
        totalFilesInAccordion += folder.files.length;
      }
    });

    return {
      indexFiles: this.indexFiles.length,
      files: this.files.length,
      allFiles: this.allFiles.length,
      accordionFolders: this.accordionFolders.length,
      totalFilesInAccordion
    };
  }

  // Whenever accordionFolders is set, update indexFiles
  setAccordionFolders(folders: any[]) {
    // Keep the hierarchical structure for proper display
    this.accordionFolders = folders;
    // Find INDEX folder in the hierarchical structure
    const findIndexFolder = (folderList: any[]): any => {
      for (const folder of folderList) {
        if (folder.name === 'INDEX') {
          return folder;
        }
        if (folder.children && folder.children.length > 0) {
          const found = findIndexFolder(folder.children);
          if (found) return found;
        }
      }
      return null;
    };
    const indexFolder = findIndexFolder(folders);
    this.indexFiles = indexFolder && indexFolder.files ? indexFolder.files : [];
  }

  /**
   * Get the folder ID for a file
   */
  private getFileFolderId(file: any): string {
    if (file.folderId) return file.folderId;
    if (file.parentFolderId) return file.parentFolderId;

    for (const folder of this.accordionFolders) {
      if (folder.files && folder.files.some(f => (f.fileId || f.id) === (file.fileId || file.id))) {
        return folder.id;
      }
    }

    return 'all';
  }

  private getFolderColorForFile(file: any): string {
    // First, check if the file already has a color property set
    if (file.color) {
      return file.color;
    }

    // For files with parentFolderName, try to find the folder by name first
    if (file.parentFolderName) {
      const folderByName = this.accordionFolders.find(f => f.name === file.parentFolderName);
      if (folderByName && folderByName.color) {
        return folderByName.color;
      }
    }

    // Try to find folder by parentFolder property
    if (file.parentFolder) {
      const folderByParent = this.accordionFolders.find(
        f => f.id === file.parentFolder || f.name === file.parentFolder
      );
      if (folderByParent && folderByParent.color) {
        return folderByParent.color;
      }
    }

    const folderId = this.getFileFolderId(file);

    // Find the folder in accordionFolders to get its color
    const folder = this.accordionFolders.find(f => f.id === folderId);
    if (folder && folder.color) {
      return folder.color;
    }

    // Return a default color if no folder color found
    return '#757575';
  }

  /**
   * Get all selected files from all folders
   * This method automatically prevents duplicates by using a Set to track file IDs
   * Works with the allFiles array and folderSelections map
   */
  private getAllSelectedFilesFromAllFolders(): any[] {
    const allSelectedFiles: any[] = [];
    const selectedFileIds = new Set<string>();

    // Get all selected file IDs from all folder selections
    const allSelectedFileIds = new Set<string>();
    for (const [folderId, selection] of this.folderSelections) {
      selection.forEach(fileId => allSelectedFileIds.add(fileId));
    }

    console.log(`getAllSelectedFilesFromAllFolders: allSelectedFileIds=${Array.from(allSelectedFileIds)}`);

    // Find the actual file objects from allFiles array (INDEX folder files)
    let foundInAllFiles = 0;
    for (const file of this.allFiles) {
      const fileId = file.fileId || file.id;
      if (allSelectedFileIds.has(fileId)) {
        if (!selectedFileIds.has(fileId)) {
          allSelectedFiles.push(file);
          selectedFileIds.add(fileId);
          foundInAllFiles++;
        }
      }
    }

    // Also find files from accordion folders
    let foundInAccordionFolders = 0;
    for (const folder of this.accordionFolders) {
      if (folder.files && Array.isArray(folder.files)) {
        for (const file of folder.files) {
          const fileId = file.fileId || file.id;
          if (allSelectedFileIds.has(fileId) && !selectedFileIds.has(fileId)) {
            allSelectedFiles.push(file);
            selectedFileIds.add(fileId);
            foundInAccordionFolders++;
          }
        }
      }
    }

    console.log(
      `getAllSelectedFilesFromAllFolders: foundInAllFiles=${foundInAllFiles}, foundInAccordionFolders=${foundInAccordionFolders}, total=${allSelectedFiles.length}`
    );

    return allSelectedFiles;
  }
  // Missing accordion event handlers (placeholder implementations)
  async handleAccordionDeleteFile(event: any) {
    console.log('handleAccordionDeleteFile called with:', event);
    const { file } = event;

    // Check if the accordion file has the minimum required properties
    if (!file.fileId) {
      console.error('File missing required fileId for deletion:', file);
      this.uiMessaging_$.toastMessage(`Error deleting the file(s). Missing file ID.`, 'ERROR');
      return;
    }

    try {
      // Try local arrays first to avoid Firebase reads that can fail
      // with permission-denied for cross-owner files.
      const localFile = this.findOriginalFileById(file.fileId);
      if (localFile && localFile.filePath) {
        this.deleteSingleRow(localFile, event.event);
        return;
      }

      const fileName = file.fileName || file.name || 'Unknown File';
      let filePath = file.filePath;

      if (!filePath) {
        if (file.parentFolder && fileName) {
          filePath = `${file.parentFolder}/${fileName}`;
        } else if (file.folderId && fileName) {
          filePath = `${file.folderId}/${fileName}`;
        }
      }

      if (filePath) {
        this.deleteSingleRow({ ...file, filePath }, event.event);
      } else {
        console.error('Cannot resolve filePath for deletion:', file);
        this.uiMessaging_$.toastMessage(`Error deleting the file(s). ${fileName} - Missing file path`, 'ERROR');
      }
    } catch (error) {
      console.error('Error in handleAccordionDeleteFile:', error);
      this.uiMessaging_$.toastMessage('Error deleting the file. Please try again.', 'ERROR');
    }
  }
  async handleAccordionEditFile(event: any) {
    const { file } = event;
    // Find the original file from allFiles to get the complete file object
    const originalFile = this.allFiles.find(f => f.fileId === file.fileId || f.id === file.fileId);
    if (originalFile) {
      this.renameElement(originalFile, event.event);
    }
  }

  async handleAccordionCopyFile(event: any) {
    const { file } = event;
    // Find the original file from allFiles to get the complete file object
    const originalFile = this.allFiles.find(f => f.fileId === file.fileId || f.id === file.fileId);
    if (originalFile) {
      // Clear current selection and select the file
      this.selection.clear();
      this.selection.select(originalFile);
      this.selectTarget(FileActionsDictionary.COPY);
    }
  }

  async handleAccordionGenerateDisc(event: any) {
    const { file } = event;
    // Find the original file from allFiles to get the complete file object
    const originalFile = this.allFiles.find(f => f.fileId === file.fileId || f.id === file.fileId);
    if (originalFile) {
      // Clear current selection and select the file
      this.selection.clear();
      this.selection.select(originalFile);
      this.generateDISC(event.event, [originalFile]);
    }
  }

  async handleAccordionAddCommentOrAttachment(event: any) {
    const { file } = event;
    // Find the original file from allFiles to get the complete file object
    const originalFile = this.allFiles.find(f => f.fileId === file.fileId || f.id === file.fileId);
    if (originalFile) {
      // Call the openCommentsAndAttachments method directly
      await this.openCommentsAndAttachments(originalFile);
    }
  }

  /**
   * Refresh accordion data after DELETE or EDIT operations
   * This ensures the accordion stays in sync with the DataTable
   */
  private async refreshAccordionAfterOperation(): Promise<void> {
    try {
      // Wait a bit for the DataTable operations to complete
      await new Promise(resolve => setTimeout(resolve, 1000));

      // Refresh the accordion folders
      await this.refreshAccordionFolders();

      // Also refresh all files to ensure consistency
      await this.refreshAllFiles();

      console.log('Accordion data refreshed after operation');
    } catch (error) {
      console.error('Error refreshing accordion data:', error);
    }
  }
  /**
   * Force refresh all accordion data - useful for debugging or when data gets out of sync
   */
  async forceRefreshAccordionData(): Promise<void> {
    try {
      console.log('Force refreshing accordion data...');

      // Clear all cached data
      this.clearAccordionCache();

      // Refresh all files
      await this.refreshAllFiles();

      // Refresh accordion folders
      await this.refreshAccordionFolders();

      console.log('Accordion data force refreshed successfully');
      console.log('Current file arrays status:', this.getFileArraysStatus());
    } catch (error) {
      console.error('Error force refreshing accordion data:', error);
    }
  }

  /**
   * Remove a specific file from the accordion's file lists
   * This is called after a successful file deletion to keep the UI in sync
   */
  private removeFileFromAccordion(fileId: string): void {
    try {
      console.log('Removing file from accordion:', fileId);

      // Get current folders from the accordion data service
      const currentFolders = this.accordionDataService.getCurrentFolders();

      currentFolders.forEach(folder => {
        if (folder.files && Array.isArray(folder.files)) {
          const fileIndex = folder.files.findIndex(file => (file.fileId || file.id) === fileId);

          if (fileIndex !== -1) {
            console.log(`Removing file from folder ${folder.name}:`, folder.files[fileIndex].fileName);

            // Remove the file from the folder's files array
            folder.files.splice(fileIndex, 1);

            // Update the folder in the accordion data service
            this.accordionDataService.updateFolderFiles(folder.id, folder.files);

            // Update pagination state
            this.updatePaginationState(folder.id, folder.files.length);
          }
        }
      });

      console.log('File removed from accordion successfully');
    } catch (error) {
      console.error('Error removing file from accordion:', error);
    }
  }

  /**
   * Update pagination state for a folder after file changes
   */
  private updatePaginationState(folderId: string, totalItems: number): void {
    // This method should be implemented to update pagination when files are added/removed
    // For now, we'll just log the change
    console.log(`Updated pagination for folder ${folderId}: ${totalItems} items`);
  }

  /**
   * Clear all files from all accordion folders
   * This is called when "Delete All Files" is selected
   */
  private clearAllFilesFromAccordion(): void {
    try {
      console.log('Clearing all files from accordion');

      // Get current folders from the accordion data service
      const currentFolders = this.accordionDataService.getCurrentFolders();

      currentFolders.forEach(folder => {
        if (folder.files && Array.isArray(folder.files) && folder.files.length > 0) {
          console.log(`Clearing ${folder.files.length} files from folder ${folder.name}`);

          // Clear the files array
          folder.files = [];

          // Update the folder in the accordion data service
          this.accordionDataService.updateFolderFiles(folder.id, []);

          // Update pagination state
          this.updatePaginationState(folder.id, 0);
        }
      });

      console.log('All files cleared from accordion successfully');
    } catch (error) {
      console.error('Error clearing files from accordion:', error);
    }
  }

  handleAccordionFolderNameClick(event: any) {
    console.log('handleAccordionFolderNameClick called with:', event);
    // Implementation can be added later
  }

  handleRefreshFolderContents(event: any) {
    console.log('handleRefreshFolderContents called with:', event);
    // Implementation can be added later
  }

  handleAccordionSharedIconClick(event: any) {
    // The shared-users-dialog is now handled directly by the home-folders-accordion component
    // This method is called for backward compatibility and can be used for additional side effects

    console.log('Shared icon clicked for file:', event);

    // Log analytics or perform any additional actions when shared icon is clicked
    if (event && event.fileName) {
      console.log(`User clicked shared icon for file: ${event.fileName}`);

      // You can add analytics tracking here if needed
      // this.analyticsService.track('shared_icon_clicked', {
      //   fileName: event.fileName,
      //   fileId: event.fileId,
      //   casename: this.casename
      // });
    }

    // Update the allFiles array to reflect any changes made in the shared users dialog
    // This ensures that consultant folders are properly updated when files are unshared
    if (event && event.fileId) {
      const fileIndex = this.allFiles.findIndex(file => file.fileId === event.fileId);
      if (fileIndex !== -1) {
        console.log(`Before update - allFiles[${fileIndex}].sharedUsers:`, this.allFiles[fileIndex].sharedUsers);
        console.log(`Event sharedUsers:`, event.sharedUsers);

        // Update the file's sharedUsers array in allFiles to match the accordion
        this.allFiles[fileIndex].sharedUsers = event.sharedUsers || [];
        console.log(`After update - allFiles[${fileIndex}].sharedUsers:`, this.allFiles[fileIndex].sharedUsers);

        // Update consultant folders for accordion to reflect the changes

        // Trigger change detection to ensure the UI updates
        this.ref.detectChanges();
      }
    }

    // The actual dialog opening is now handled by the home-folders-accordion component
    // No additional implementation needed here
  }

  handleAccordionStudyClick(event: any) {
    // Handle study click from accordion
    console.log('Study click from accordion:', event);
  }

  async handleAccordionDeleteFolder(event: any) {
    const { folder } = event;

    if (!folder || !folder.id) {
      console.error('Invalid folder data for deletion:', folder);
      return;
    }

    // Check against Firebase whether the folder is truly empty.
    // permission-denied means there are files the user cannot access → treat as non-empty.
    let isEmpty: boolean;
    try {
      isEmpty = await this.files_$.checkFolderIsEmpty(folder.id);
    } catch (e) {
      isEmpty = false;
    }
    if (!isEmpty) {
      this.uiMessaging_$.toastMessage(
        `The folder "${folder.name}" still has contents. Please delete all files inside it before deleting the folder.`,
        'WARNING'
      );
      return;
    }

    // Show confirmation dialog
    const { ConfirmationDialogComponent } = await import('../ui/confirmation-dialog/confirmation-dialog.component');
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Folder',
        message: `Are you sure you want to delete the folder "${folder.name}"? This action cannot be undone.`,
        confirmText: 'Delete',
        cancelText: 'Cancel',
        confirmColor: 'warn'
      }
    });

    const result = await firstValueFrom(confirmDialog.afterClosed());

    if (result) {
      try {
        this.auth_$.showLoader('Deleting folder...');

        // Delete folder from Firebase
        console.log('Deleting folder from Firebase:', folder.id);
        await this.firebase_utilities_$.deleteFolder(folder.id, this.casename);
        console.log('Folder deleted from Firebase successfully');

        // Only proceed with local cleanup if Firebase deletion succeeded
        // Remove from caseFolders
        const beforeCount = this.caseFolders.length;
        this.caseFolders = this.caseFolders.filter(f => f.folderId !== folder.id);
        const afterCount = this.caseFolders.length;
        console.log(`Removed folder from caseFolders: ${beforeCount} -> ${afterCount}`);

        // Remove from accordion data service
        this.accordionDataService.removeFolder(folder.id);
        console.log('Removed folder from accordion data service');

        // Update foldersStructure if it exists
        if (this.foldersStructure && this.foldersStructure.children) {
          this.removeFolderFromStructure(this.foldersStructure, folder.id);
          console.log('Removed folder from foldersStructure');
        }

        // Wait a moment to ensure deletion is complete
        await new Promise(resolve => setTimeout(resolve, 500));

        // Refresh accordion data
        console.log('Refreshing accordion data after deletion...');
        await this.refreshAccordionAfterOperation();
        console.log('Accordion data refresh completed');

        this.auth_$.hideLoader();

        // Show success message
        this.uiMessaging_$.toastMessage(`Folder "${folder.name}" deleted successfully`, 'Success');
      } catch (error) {
        this.auth_$.hideLoader();
        console.error('Error deleting folder:', error);

        // Show specific error message based on the error
        let errorMessage = 'Error deleting folder. Please try again.';
        if (error.message && error.message.includes('not found')) {
          errorMessage = `Folder "${folder.name}" was not found in the database. It may have already been deleted or moved.`;
        } else if (error.message) {
          errorMessage = `Error deleting folder: ${error.message}`;
        }

        this.uiMessaging_$.toastMessage(errorMessage, 'Error');
      }
    }
  }

  handleSharedFilesDeleteFile(event: any): void {
    const { file } = event;
    // Find the original file from allFiles to get the complete file object
    const originalFile = this.allFiles.find(f => f.fileId === file.id || f.id === file.id);
    if (originalFile) {
      this.deleteSingleRow(originalFile, event.event);
    }
  }

  /**
   * Force refresh consultant lists to ensure proper movement from Available to Active
   */
  private async forceRefreshConsultantLists(consultantEmail: string): Promise<void> {
    try {
      // Wait a bit for Firebase updates to propagate
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Force reload all consultant data
      if (!this.userIsConsultant) {
        // await this.updateFacilityConsultantsLists();
      } else {
        await this.updateConsultantsLists();
      }
    } catch (error) {
      console.error('Error in forceRefreshConsultantLists:', error);
    }
  }

  /**
   * Clear all file selections across all folders
   * This method can be called to reset the selection state
   */
  clearAllFileSelections(): void {
    this.folderSelections.clear();
    this.selectedFilesForAccordion = [];
    this.selection = new SelectionModel<any>(true, []);

    // Clear selections in the home-folders-accordion component
    if (this.homeFoldersAccordion) {
      this.homeFoldersAccordion.clearAllSelections();
    }

    console.log('All file selections cleared');
    this.ref.detectChanges();
  }

  /**
   * Get the total count of selected files across all folders
   */
  getTotalSelectedFilesCount(): number {
    return this.selectedFilesForAccordion.length;
  }

  /**
   * Check if any files are currently selected
   */
  hasSelectedFiles(): boolean {
    return this.selectedFilesForAccordion.length > 0;
  }

  /**
   * Handle removing a specific file from the selected files list
   * This will also remove the file from the folder selection
   */
  handleRemoveSelectedFile(fileToRemove: any): void {
    const fileId = fileToRemove.id;

    // Remove from selectedFilesForAccordion
    this.selectedFilesForAccordion = this.selectedFilesForAccordion.filter(file => file.id !== fileId);

    // Remove from folder selections
    for (const [folderId, selection] of this.folderSelections.entries()) {
      if (selection.has(fileId)) {
        selection.delete(fileId);
      }
    }

    // Update the selection model
    this.selection = new SelectionModel<any>(true, []);
    this.selectedFilesForAccordion.forEach(file => {
      const originalFile = this.findOriginalFileById(file.id);
      if (originalFile) {
        this.selection.select(originalFile);
      }
    });

    this.ref.detectChanges();
  }

  /**
   * Update the selected files accordion with fresh data
   */
  private updateSelectedFilesAccordion(): void {
    // Refresh the selected files to get updated sharing status
    const allSelectedFiles = this.getAllSelectedFilesFromAllFolders();
    this.selectedFilesForAccordion = allSelectedFiles.map(file => ({
      id: file.fileId || file.id,
      fileName: file.fileName,
      fileType: file.type || file.fileType,
      fileContent: file.fileDesc || file.fileContent,
      dateOfFile: file.fdate || file.dateOfFile,
      lastModified: file.lastModified,
      dateUploaded: file.uploadedDate || file.dateUploaded,
      fileFolderName:
        file.parentFolderName || file.fileFolderName || this.getFolderNameById(this.getFileFolderId(file)),
      folderColor: this.getFolderColorForFile(file),
      selectionStatus: 'Selected',
      actions: ['edit', 'delete'],
      sharedUsers: file.sharedUsers || []
    }));
    this.ref.detectChanges();
  }

  /**
   * Manual method to force a consultant to move from Available to Active
   * Call this method from browser console if automatic movement fails
   */
  async forceActivateConsultant(consultantEmail: string): Promise<void> {
    try {
      // Force refresh the lists
      await this.forceRefreshConsultantLists(consultantEmail);
    } catch (error) {
      console.error('🔧 MANUAL: Error in forceActivateConsultant:', error);
    }
  }

  async getConsultantsFromFacilities(facilities: any) {
    const consultants = this.firebase_utilities_$.getConsultantsFromFacilities(facilities);
    return consultants;
  }
}
